export const GetTestDummy = () => {
  return {
    "all": {
      "nodes": [
        {
          "id": "5936d90786f7742b1420ba5b",
          "data": {
            "taskName": "Debut",
            "minPlayerLevel": "1",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5936da9e86f7742d65037edf",
              "5fd9fad9c1ce6b1a3b486d00"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5936da9e86f7742d65037edf",
          "data": {
            "taskName": "Background Check",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "59674cd986f7744ab26e32f2",
              "59674eb386f774539f14813a"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59674cd986f7744ab26e32f2",
          "data": {
            "taskName": "Shootout Picnic",
            "minPlayerLevel": "3",
            "kappaRequired": false,
            "traderName": "Prapor",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59674eb386f774539f14813a",
          "data": {
            "taskName": "Delivery from the Past",
            "minPlayerLevel": "5",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "59c124d686f774189b3c843f"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5967530a86f77462ba22226b",
          "data": {
            "taskName": "Bad Rep Evidence",
            "minPlayerLevel": "6",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "59675d6c86f7740a842fc482"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59675d6c86f7740a842fc482",
          "data": {
            "taskName": "Ice Cream Cones",
            "minPlayerLevel": "9",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "59675ea386f77414b32bded2",
              "5967725e86f774601a446662"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59675ea386f77414b32bded2",
          "data": {
            "taskName": "Postman Pat - Part 1",
            "minPlayerLevel": "10",
            "kappaRequired": false,
            "traderName": "Prapor",
            "parents": [
              "596760e186f7741e11214d58",
              "6391359b9444fb141f4e6ee6"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "596760e186f7741e11214d58",
          "data": {
            "taskName": "Postman Pat - Part 2",
            "minPlayerLevel": "10",
            "kappaRequired": false,
            "traderName": "Therapist",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5967725e86f774601a446662",
          "data": {
            "taskName": "Shaking up the Teller",
            "minPlayerLevel": "15",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "59c50a9e86f7745fef66f4ff",
              "5c12452c86f7744b83469073",
              "5eda19f0edce541157209cee"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5967733e86f774602332fc84",
          "data": {
            "taskName": "Shortage",
            "minPlayerLevel": "1",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "59689ee586f7740d1570bbd5",
              "59689fbd86f7740d137ebfc4"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59689ee586f7740d1570bbd5",
          "data": {
            "taskName": "Sanitary Standards - Part 1",
            "minPlayerLevel": "4",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "596a204686f774576d4c95de"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59689fbd86f7740d137ebfc4",
          "data": {
            "taskName": "Operation Aquarius - Part 1",
            "minPlayerLevel": "6",
            "kappaRequired": false,
            "traderName": "Therapist",
            "parents": [
              "5968eb3186f7741dde183a4d"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5968eb3186f7741dde183a4d",
          "data": {
            "taskName": "Operation Aquarius - Part 2",
            "minPlayerLevel": "6",
            "kappaRequired": false,
            "traderName": "Therapist",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5969f90786f77420d2328015",
          "data": {
            "taskName": "Painkiller",
            "minPlayerLevel": "8",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5969f9e986f7741dde183a50"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5969f9e986f7741dde183a50",
          "data": {
            "taskName": "Pharmacist",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "596a0e1686f7741ddf17dbee",
              "596a1e6c86f7741ddc2d3206",
              "596a218586f77420d232807c",
              "5a68661a86f774500f48afb0",
              "60896e28e4a85c72ef3fa301",
              "639135d89444fb141f4e6eea"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "596a0e1686f7741ddf17dbee",
          "data": {
            "taskName": "Supply Plans",
            "minPlayerLevel": "13",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "596a101f86f7741ddb481582",
              "5d25e2ee86f77443e35162ea",
              "63ab180c87413d64ae0ac20a"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "596a101f86f7741ddb481582",
          "data": {
            "taskName": "Kind of Sabotage",
            "minPlayerLevel": "13",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "596a1e6c86f7741ddc2d3206",
          "data": {
            "taskName": "General Wares",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5edab736cc183c769d778bc2"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "596a204686f774576d4c95de",
          "data": {
            "taskName": "Sanitary Standards - Part 2",
            "minPlayerLevel": "8",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5969f90786f77420d2328015"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "596a218586f77420d232807c",
          "data": {
            "taskName": "Car Repair",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "596b36c586f77450d6045ad2",
          "data": {
            "taskName": "Supplier",
            "minPlayerLevel": "5",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "596b43fb86f77457ca186186",
              "596b455186f77457cb50eccb",
              "5a27c99a86f7747d2c6bdd8e"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "596b43fb86f77457ca186186",
          "data": {
            "taskName": "The Extortionist",
            "minPlayerLevel": "7",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5979ed3886f77431307dc512"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "596b455186f77457cb50eccb",
          "data": {
            "taskName": "Stirrup",
            "minPlayerLevel": "8",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5979ed3886f77431307dc512",
          "data": {
            "taskName": "What’s on the Flash Drive?",
            "minPlayerLevel": "8",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5979eee086f774311955e614",
              "5d25e48d86f77408251c4bfb"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5979eee086f774311955e614",
          "data": {
            "taskName": "Golden Swag",
            "minPlayerLevel": "8",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5979f9ba86f7740f6c3fe9f2"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5979f8bb86f7743ec214c7a6",
          "data": {
            "taskName": "Polikhim Hobo",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5d4bec3486f7743cac246665"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5979f9ba86f7740f6c3fe9f2",
          "data": {
            "taskName": "Chemical - Part 1",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5979f8bb86f7743ec214c7a6",
              "597a0b2986f77426d66c0633"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "597a0b2986f77426d66c0633",
          "data": {
            "taskName": "Chemical - Part 2",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "597a0e5786f77426d66c0636"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "597a0e5786f77426d66c0636",
          "data": {
            "taskName": "Chemical - Part 3",
            "minPlayerLevel": "11",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "597a0f5686f774273b74f676",
              "5b478eca86f7744642012254"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "597a0f5686f774273b74f676",
          "data": {
            "taskName": "Chemical - Part 4",
            "minPlayerLevel": "11",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "597a160786f77477531d39d2",
              "597a171586f77405ba6887d3",
              "59c93e8e86f7742a406989c4",
              "6089743983426423753cd58a"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "597a160786f77477531d39d2",
          "data": {
            "taskName": "Out of Curiosity",
            "minPlayerLevel": "11",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "59c9392986f7742f6923add2"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "597a171586f77405ba6887d3",
          "data": {
            "taskName": "Big Customer",
            "minPlayerLevel": "11",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "59ca1a6286f774509a270942"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59c124d686f774189b3c843f",
          "data": {
            "taskName": "BP Depot",
            "minPlayerLevel": "5",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5967530a86f77462ba22226b",
              "5ede55112c95834b583f052a"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59c50a9e86f7745fef66f4ff",
          "data": {
            "taskName": "The Punisher - Part 1",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "59c50c8886f7745fed3193bf"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59c50c8886f7745fed3193bf",
          "data": {
            "taskName": "The Punisher - Part 2",
            "minPlayerLevel": "18",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "59c512ad86f7741f0d09de9b",
              "6179ac7511973d018217d0b9"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59c512ad86f7741f0d09de9b",
          "data": {
            "taskName": "The Punisher - Part 3",
            "minPlayerLevel": "19",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "59ca264786f77445a80ed044"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59c9392986f7742f6923add2",
          "data": {
            "taskName": "Trust Regain",
            "minPlayerLevel": "11",
            "kappaRequired": false,
            "traderName": "Therapist",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59c93e8e86f7742a406989c4",
          "data": {
            "taskName": "Loyalty Buyout",
            "minPlayerLevel": "11",
            "kappaRequired": false,
            "traderName": "Skier",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59ca1a6286f774509a270942",
          "data": {
            "taskName": "No Offence",
            "minPlayerLevel": "11",
            "kappaRequired": false,
            "traderName": "Prapor",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59ca264786f77445a80ed044",
          "data": {
            "taskName": "The Punisher - Part 4",
            "minPlayerLevel": "20",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "59ca29fb86f77445ab465c87",
              "639136f086e646067c176a8b"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59ca29fb86f77445ab465c87",
          "data": {
            "taskName": "The Punisher - Part 5",
            "minPlayerLevel": "20",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "59ca2eb686f77445a80ed049",
              "6179b5b06e9dd54ac275e409",
              "625d6ff5ddc94657c21a1625"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59ca2eb686f77445a80ed049",
          "data": {
            "taskName": "The Punisher - Part 6",
            "minPlayerLevel": "21",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "60e71b62a0beca400d69efc4",
              "60e71b9bbd90872cb85440f3",
              "60e71bb4e456d449cd47ca75",
              "60effd818b669d08a35bfad5",
              "63a9ae24009ffc6a551631a5",
              "64e7b99017ab941a6f7bf9d7"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a03153686f77442d90e2171",
          "data": {
            "taskName": "Spa Tour - Part 1",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a03173786f77451cb427172",
              "6179aff8f57fb279792c60a1"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a03173786f77451cb427172",
          "data": {
            "taskName": "Spa Tour - Part 2",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a0327ba86f77456b9154236"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a0327ba86f77456b9154236",
          "data": {
            "taskName": "Spa Tour - Part 3",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a03296886f774569778596a",
              "6179b5eabca27a099552e052"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a03296886f774569778596a",
          "data": {
            "taskName": "Spa Tour - Part 4",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a0449d586f77474e66227b7"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a0449d586f77474e66227b7",
          "data": {
            "taskName": "Spa Tour - Part 5",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27ba9586f7741b543d8e85"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27b75b86f7742e97191958",
          "data": {
            "taskName": "Fishing Gear",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27b7a786f774579c3eb376",
              "5edac020218d181e29451446",
              "60e71ccb5688f6424c7bfec4"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27b7a786f774579c3eb376",
          "data": {
            "taskName": "Tigr Safari",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27b7d686f77460d847e6a6"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27b7d686f77460d847e6a6",
          "data": {
            "taskName": "Scrap Metal",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27b80086f774429a5d7e20"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27b80086f774429a5d7e20",
          "data": {
            "taskName": "Eagle Eye",
            "minPlayerLevel": "11",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27b87686f77460de0252a8"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27b87686f77460de0252a8",
          "data": {
            "taskName": "Humanitarian Supplies",
            "minPlayerLevel": "11",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a03153686f77442d90e2171",
              "5a27b9de86f77464e5044585",
              "6086c852c945025d41566124"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27b9de86f77464e5044585",
          "data": {
            "taskName": "The Cult - Part 1",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27ba1c86f77461ea5a3c56"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27ba1c86f77461ea5a3c56",
          "data": {
            "taskName": "The Cult - Part 2",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27ba9586f7741b543d8e85",
          "data": {
            "taskName": "Spa Tour - Part 6",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27bafb86f7741c73584017"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27bafb86f7741c73584017",
          "data": {
            "taskName": "Spa Tour - Part 7",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27bb1e86f7741f27621b7e",
              "5a27bb8386f7741c770d2d0a",
              "639136d68ba6894d155e77cf",
              "639282134ed9512be67647ed"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27bb1e86f7741f27621b7e",
          "data": {
            "taskName": "Cargo X - Part 1",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27bb3d86f77411ea361a21"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27bb3d86f77411ea361a21",
          "data": {
            "taskName": "Cargo X - Part 2",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27bb5986f7741dfb660900"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27bb5986f7741dfb660900",
          "data": {
            "taskName": "Cargo X - Part 3",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "61958c366726521dd96828ec"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27bb8386f7741c770d2d0a",
          "data": {
            "taskName": "Wet Job - Part 1",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27bbf886f774333a418eeb"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27bbf886f774333a418eeb",
          "data": {
            "taskName": "Wet Job - Part 2",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27bc1586f7741f6d40fa2f"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27bc1586f7741f6d40fa2f",
          "data": {
            "taskName": "Wet Job - Part 3",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27bc3686f7741c73584026"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27bc3686f7741c73584026",
          "data": {
            "taskName": "Wet Job - Part 4",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27bc6986f7741c7358402b"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27bc6986f7741c7358402b",
          "data": {
            "taskName": "Wet Job - Part 5",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27bc8586f7741b543d8ea4",
              "5d6fbc2886f77449d825f9d3",
              "63a9b229813bba58a50c9ee5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27bc8586f7741b543d8ea4",
          "data": {
            "taskName": "Wet Job - Part 6",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5c0be13186f7746f016734aa",
              "5c0d4e61d09282029f53920e"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27c99a86f7747d2c6bdd8e",
          "data": {
            "taskName": "Friend From the West - Part 1",
            "minPlayerLevel": "9",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5a27b75b86f7742e97191958",
              "5a27d2af86f7744e1115b323"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27d2af86f7744e1115b323",
          "data": {
            "taskName": "Friend From the West - Part 2",
            "minPlayerLevel": "9",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5a03153686f77442d90e2171",
              "5a27b9de86f77464e5044585",
              "5b47926a86f7747ccc057c15",
              "5b4794cb86f774598100d5d4",
              "5edac020218d181e29451446",
              "6086c852c945025d41566124",
              "6193850f60b34236ee0483de"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a68661a86f774500f48afb0",
          "data": {
            "taskName": "Health Care Privacy - Part 1",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5a68663e86f774501078f78a"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a68663e86f774501078f78a",
          "data": {
            "taskName": "Health Care Privacy - Part 2",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5a68665c86f774255929b4c7",
              "6179afd0bca27a099552e040"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a68665c86f774255929b4c7",
          "data": {
            "taskName": "Health Care Privacy - Part 3",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5a68667486f7742607157d28"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a68667486f7742607157d28",
          "data": {
            "taskName": "Health Care Privacy - Part 4",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5a68669a86f774255929b4d4",
              "5c0be5fc86f774467a116593",
              "5c0d0d5086f774363760aef2",
              "5d6fb2c086f77449da599c24"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a68669a86f774255929b4d4",
          "data": {
            "taskName": "Health Care Privacy - Part 5",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5c0d1c4cd0928202a02a6f5c"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac23c6186f7741247042bad",
          "data": {
            "taskName": "Gunsmith - Part 1",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac2426c86f774138762edfe",
              "5ac2428686f77412450b42bf",
              "5ac345dc86f774288030817f",
              "5d2495a886f77425cd51e403"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac2426c86f774138762edfe",
          "data": {
            "taskName": "Gunsmith - Part 2",
            "minPlayerLevel": "5",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac3467986f7741d6224abc2",
              "639872f9decada40426d3447"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac2428686f77412450b42bf",
          "data": {
            "taskName": "Gunsmith - Part 3",
            "minPlayerLevel": "7",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac3479086f7742880308199",
              "639872f9decada40426d3447"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac242ab86f77412464f68b4",
          "data": {
            "taskName": "Gunsmith - Part 16",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5b47749f86f7746c5d6a5fd4"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac244c486f77413e12cf945",
          "data": {
            "taskName": "Gunsmith - Part 13",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "639872fe8871e1272b10ccf6"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac244eb86f7741356335af1",
          "data": {
            "taskName": "Gunsmith - Part 7",
            "minPlayerLevel": "15",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ae3277186f7745973054106"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac345dc86f774288030817f",
          "data": {
            "taskName": "Farming - Part 1",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac3460c86f7742880308185"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac3460c86f7742880308185",
          "data": {
            "taskName": "Farming - Part 2",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac3462b86f7741d6118b983",
              "5ac3475486f7741d6224abd3",
              "626bd75e47ea7f506e5493c5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac3462b86f7741d6118b983",
          "data": {
            "taskName": "Farming - Part 3",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac3464c86f7741d651d6877",
              "5c0bde0986f77479cf22c2f8",
              "6179b3bdc7560e13d23eeb8d"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac3464c86f7741d651d6877",
          "data": {
            "taskName": "Farming - Part 4",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c1128e386f7746565181106",
              "5c139eb686f7747878361a6f",
              "6179b3a12153c15e937d52bc"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac3467986f7741d6224abc2",
          "data": {
            "taskName": "Signal - Part 1",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac346a886f7744e1b083d67",
              "5ac3479086f7742880308199"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac346a886f7744e1b083d67",
          "data": {
            "taskName": "Signal - Part 2",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac346cf86f7741d63233a02",
              "5ac3477486f7741d651d6885"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac346cf86f7741d63233a02",
          "data": {
            "taskName": "Signal - Part 3",
            "minPlayerLevel": "15",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac346e886f7741d6118b99b",
              "64ee9df4496db64f9b7a4432"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac346e886f7741d6118b99b",
          "data": {
            "taskName": "Signal - Part 4",
            "minPlayerLevel": "15",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac3475486f7741d6224abd3",
          "data": {
            "taskName": "Bad Habit",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac3477486f7741d651d6885",
          "data": {
            "taskName": "Scout",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "6089736efa70fc097863b8f6",
              "60c0c018f7afb4354815096a"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac3479086f7742880308199",
          "data": {
            "taskName": "Insider",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae3267986f7742a413592fe",
          "data": {
            "taskName": "Gunsmith - Part 5",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ae3270f86f77445ba41d4dd"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae3270f86f77445ba41d4dd",
          "data": {
            "taskName": "Gunsmith - Part 6",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac244eb86f7741356335af1"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae3277186f7745973054106",
          "data": {
            "taskName": "Gunsmith - Part 8",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "639872fa9b4fb827b200d8e5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae327c886f7745c7b3f2f3f",
          "data": {
            "taskName": "Gunsmith - Part 10",
            "minPlayerLevel": "20",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "639872fc93ae507d5858c3a6"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae3280386f7742a41359364",
          "data": {
            "taskName": "Gunsmith - Part 15",
            "minPlayerLevel": "29",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac242ab86f77412464f68b4",
              "625d6ff5ddc94657c21a1625"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae448a386f7744d3730fff0",
          "data": {
            "taskName": "Only Business",
            "minPlayerLevel": "15",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae448bf86f7744d733e55ee",
              "5ae448e586f7744dcf0c2a67",
              "638fcd23dc65553116701d33"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae448bf86f7744d733e55ee",
          "data": {
            "taskName": "Make ULTRA Great Again",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae448f286f77448d73c0131",
              "5ae4493486f7744efa289417"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae448e586f7744dcf0c2a67",
          "data": {
            "taskName": "Big Sale",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae448f286f77448d73c0131",
              "5ae4493486f7744efa289417"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae448f286f77448d73c0131",
          "data": {
            "taskName": "The Blood of War - Part 1",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae4490786f7744ca822adcc",
              "5ae4499a86f77449783815db",
              "5b47876e86f7744d1c353205",
              "5b47891f86f7744d1b23c571",
              "608974d01a66564e74191fc0"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae4490786f7744ca822adcc",
          "data": {
            "taskName": "Dressed to Kill",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae449b386f77446d8741719"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae4493486f7744efa289417",
          "data": {
            "taskName": "Database - Part 1",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae4493d86f7744b8e15aa8f"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae4493d86f7744b8e15aa8f",
          "data": {
            "taskName": "Database - Part 2",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae4495086f77443c122bc40",
              "5ae449b386f77446d8741719",
              "5b478d0f86f7744d190d91b5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae4495086f77443c122bc40",
          "data": {
            "taskName": "Sew it Good - Part 1",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae4495c86f7744e87761355",
              "5b47876e86f7744d1c353205"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae4495c86f7744e87761355",
          "data": {
            "taskName": "Sew it Good - Part 2",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae4496986f774459e77beb6",
              "5ae4498786f7744bde357695"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae4496986f774459e77beb6",
          "data": {
            "taskName": "Sew it Good - Part 3",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae4497b86f7744cf402ed00",
              "5b47891f86f7744d1b23c571"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae4497b86f7744cf402ed00",
          "data": {
            "taskName": "Sew it Good - Part 4",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae4499a86f77449783815db",
              "5e381b0286f77420e3417a74",
              "5e383a6386f77465910ce1f3"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae4498786f7744bde357695",
          "data": {
            "taskName": "The Key to Success",
            "minPlayerLevel": "26",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae449a586f7744bde357696",
              "5ae449d986f774453a54a7e1",
              "5dc53acb86f77469c740c893"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae4499a86f77449783815db",
          "data": {
            "taskName": "Charisma Brings Success",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae449a586f7744bde357696",
          "data": {
            "taskName": "No Fuss Needed",
            "minPlayerLevel": "26",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae449b386f77446d8741719",
          "data": {
            "taskName": "Gratitude",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae449c386f7744bde357697",
              "5b478b1886f7744d1b23c57d"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae449c386f7744bde357697",
          "data": {
            "taskName": "Sales Night",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae449d986f774453a54a7e1",
              "5d25e2e286f77444001e2e48"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae449d986f774453a54a7e1",
          "data": {
            "taskName": "Supervisor",
            "minPlayerLevel": "40",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5c51aac186f77432ea65c552",
              "60e71dc0a94be721b065bbfc"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b47749f86f7746c5d6a5fd4",
          "data": {
            "taskName": "Gunsmith - Part 17",
            "minPlayerLevel": "31",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5b477b6f86f7747290681823"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b47799d86f7746c5d6a5fd8",
          "data": {
            "taskName": "Gunsmith - Part 12",
            "minPlayerLevel": "23",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac244c486f77413e12cf945"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b477b6f86f7747290681823",
          "data": {
            "taskName": "Gunsmith - Part 18",
            "minPlayerLevel": "33",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "639873003693c63d86328f25"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b477f7686f7744d1b23c4d2",
          "data": {
            "taskName": "Gunsmith - Part 20",
            "minPlayerLevel": "37",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "63987301e11ec11ff5504036"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b47825886f77468074618d3",
          "data": {
            "taskName": "Gunsmith - Part 22",
            "minPlayerLevel": "39",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552",
              "64f83bb69878a0569d6ecfbe"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b47876e86f7744d1c353205",
          "data": {
            "taskName": "The Blood of War - Part 2",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5c10f94386f774227172c572"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b47891f86f7744d1b23c571",
          "data": {
            "taskName": "Living High is Not a Crime - Part 1",
            "minPlayerLevel": "27",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5c1141f386f77430ff393792"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b478b1886f7744d1b23c57d",
          "data": {
            "taskName": "Hot Delivery",
            "minPlayerLevel": "29",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5c112d7e86f7740d6f647486"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b478d0f86f7744d190d91b5",
          "data": {
            "taskName": "Minibus",
            "minPlayerLevel": "24",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5c51aac186f77432ea65c552",
              "639135bbc115f907b14700a6"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b478eca86f7744642012254",
          "data": {
            "taskName": "Vitamins - Part 1",
            "minPlayerLevel": "22",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5b478ff486f7744d184ecbbf"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b478ff486f7744d184ecbbf",
          "data": {
            "taskName": "Vitamins - Part 2",
            "minPlayerLevel": "22",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5c51aac186f77432ea65c552",
              "64f5e20652fc01298e2c61e3"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b47926a86f7747ccc057c15",
          "data": {
            "taskName": "Informed Means Armed",
            "minPlayerLevel": "24",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5b4795fb86f7745876267770"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b4794cb86f774598100d5d4",
          "data": {
            "taskName": "Lend-Lease - Part 1",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5c0d0f1886f77457b8210226"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b4795fb86f7745876267770",
          "data": {
            "taskName": "Chumming",
            "minPlayerLevel": "27",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5c0bc91486f7746ab41857a2",
              "5c0bdb5286f774166e38eed4",
              "639dbaf17c898a131e1cffff"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5bc4776586f774512d07cf05",
          "data": {
            "taskName": "The Tarkov Shooter - Part 1",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5bc479e586f7747f376c7da3"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5bc479e586f7747f376c7da3",
          "data": {
            "taskName": "The Tarkov Shooter - Part 2",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5bc47dbf86f7741ee74e93b9"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5bc47dbf86f7741ee74e93b9",
          "data": {
            "taskName": "The Tarkov Shooter - Part 3",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5bc480a686f7741af0342e29",
              "5d25e2b486f77409de05bba0"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5bc480a686f7741af0342e29",
          "data": {
            "taskName": "The Tarkov Shooter - Part 4",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5bc4826c86f774106d22d88b"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5bc4826c86f774106d22d88b",
          "data": {
            "taskName": "The Tarkov Shooter - Part 5",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5bc4836986f7740c0152911c"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5bc4836986f7740c0152911c",
          "data": {
            "taskName": "The Tarkov Shooter - Part 6",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5bc4856986f77454c317bea7"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5bc4856986f77454c317bea7",
          "data": {
            "taskName": "The Tarkov Shooter - Part 7",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5bc4893c86f774626f5ebf3e",
              "625d6ff5ddc94657c21a1625"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5bc4893c86f774626f5ebf3e",
          "data": {
            "taskName": "The Tarkov Shooter - Part 8",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0bbaa886f7746941031d82",
          "data": {
            "taskName": "Bullshit",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5c1234c286f77406fa13baeb",
              "625d6ff5ddc94657c21a1625"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0bc91486f7746ab41857a2",
          "data": {
            "taskName": "Silent Caliber",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5c0bbaa886f7746941031d82"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0bd01e86f7747cdd799e56",
          "data": {
            "taskName": "Insomnia",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0bd94186f7747a727f09b2",
          "data": {
            "taskName": "Test Drive - Part 1",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5c51aac186f77432ea65c552",
              "63a5cf262964a7488f5243ce"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0bdb5286f774166e38eed4",
          "data": {
            "taskName": "Flint",
            "minPlayerLevel": "35",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0bde0986f77479cf22c2f8",
          "data": {
            "taskName": "A Shooter Born in Heaven",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0be13186f7746f016734aa",
          "data": {
            "taskName": "Psycho Sniper",
            "minPlayerLevel": "35",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0be5fc86f774467a116593",
          "data": {
            "taskName": "Private Clinic",
            "minPlayerLevel": "35",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5c0d1c4cd0928202a02a6f5c"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0d0d5086f774363760aef2",
          "data": {
            "taskName": "Athlete",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "60e71c48c1bfa3050473b8e5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0d0f1886f77457b8210226",
          "data": {
            "taskName": "Lend-Lease - Part 2",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5c0d4c12d09282029f539173"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0d190cd09282029f5390d8",
          "data": {
            "taskName": "Grenadier",
            "minPlayerLevel": "20",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5c0bd94186f7747a727f09b2"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0d1c4cd0928202a02a6f5c",
          "data": {
            "taskName": "Decontamination Service",
            "minPlayerLevel": "35",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5c51aac186f77432ea65c552",
              "625d6ff5ddc94657c21a1625"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0d4c12d09282029f539173",
          "data": {
            "taskName": "Peacekeeping Mission",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5c51aac186f77432ea65c552",
              "625d6ff5ddc94657c21a1625"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0d4e61d09282029f53920e",
          "data": {
            "taskName": "The Guide",
            "minPlayerLevel": "40",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5c51aac186f77432ea65c552",
              "60e71c9ad54b755a3b53eb66"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c10f94386f774227172c572",
          "data": {
            "taskName": "The Blood of War - Part 3",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5c1141f386f77430ff393792"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c1128e386f7746565181106",
          "data": {
            "taskName": "Fertilizers",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c112d7e86f7740d6f647486",
          "data": {
            "taskName": "Scavenger",
            "minPlayerLevel": "29",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5c51aac186f77432ea65c552",
              "64edbb1317ab941a6f7cc247"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c1141f386f77430ff393792",
          "data": {
            "taskName": "Living High is Not a Crime - Part 2",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5c51aac186f77432ea65c552",
              "625d6ff5ddc94657c21a1625"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c1234c286f77406fa13baeb",
          "data": {
            "taskName": "Setup",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c12452c86f7744b83469073",
          "data": {
            "taskName": "Perfect Mediator",
            "minPlayerLevel": "35",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c139eb686f7747878361a6f",
          "data": {
            "taskName": "Import",
            "minPlayerLevel": "35",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c51aac186f77432ea65c552",
          "data": {
            "taskName": "Collector",
            "minPlayerLevel": "48",
            "kappaRequired": true,
            "traderName": "Fence",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d2495a886f77425cd51e403",
          "data": {
            "taskName": "Introduction",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5d24b81486f77439c92d6ba8"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d24b81486f77439c92d6ba8",
          "data": {
            "taskName": "Acquaintance",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5bc4776586f774512d07cf05",
              "5d25aed386f77442734d25d2",
              "5d25e48d86f77408251c4bfb"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25aed386f77442734d25d2",
          "data": {
            "taskName": "The Survivalist Path - Unprotected but Dangerous",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25b6be86f77444001e1b89"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25b6be86f77444001e1b89",
          "data": {
            "taskName": "The Survivalist Path - Thrifty",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25bfd086f77442734d3007",
              "63a88045abf76d719f42d715"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25bfd086f77442734d3007",
          "data": {
            "taskName": "The Survivalist Path - Zhivchik",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25c81b86f77443e625dd71"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25c81b86f77443e625dd71",
          "data": {
            "taskName": "The Survivalist Path - Wounded Beast",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25cf2686f77443e75488d4",
              "5d25d2c186f77443e35162e5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25cf2686f77443e75488d4",
          "data": {
            "taskName": "The Survivalist Path - Tough Guy",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e29d86f7740a22516326",
              "5d25e2b486f77409de05bba0",
              "5d25e48186f77443e625e386"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25d2c186f77443e35162e5",
          "data": {
            "taskName": "The Survivalist Path - Cold Blooded",
            "minPlayerLevel": "2",
            "kappaRequired": false,
            "traderName": "Jaeger",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e29d86f7740a22516326",
          "data": {
            "taskName": "The Survivalist Path - Eagle-Owl",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e2a986f77409dd5cdf2a"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e2a986f77409dd5cdf2a",
          "data": {
            "taskName": "The Survivalist Path - Combat Medic",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5eaaaa7c93afa0558f3b5a1c"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e2b486f77409de05bba0",
          "data": {
            "taskName": "The Huntsman Path - Secured Perimeter",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e2c386f77443e7549029",
              "5d25e2cc86f77443e47ae019",
              "5d25e2ee86f77443e35162ea",
              "5d25e45e86f77408251c4bfa"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e2c386f77443e7549029",
          "data": {
            "taskName": "The Huntsman Path - Trophy",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e43786f7740a212217fa",
              "60e71e8ed54b755a3b53eb67",
              "626bdcc3a371ee3a7a3514c5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e2cc86f77443e47ae019",
          "data": {
            "taskName": "The Huntsman Path - Forest Cleaning",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e2d886f77442734d335e",
              "5d25e2e286f77444001e2e48",
              "5d25e44386f77409453bce7b",
              "60c0c018f7afb4354815096a",
              "60e71ccb5688f6424c7bfec4",
              "6179ad0a6e9dd54ac275e3f2",
              "625d6ff5ddc94657c21a1625",
              "639136df4b15ca31f76bc31f",
              "64e7b971f9d6fa49d6769b44"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e2d886f77442734d335e",
          "data": {
            "taskName": "The Huntsman Path - Controller",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e2e286f77444001e2e48",
          "data": {
            "taskName": "The Huntsman Path - Sellout",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5dc53acb86f77469c740c893",
              "60e71e8ed54b755a3b53eb67",
              "626bdcc3a371ee3a7a3514c5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e2ee86f77443e35162ea",
          "data": {
            "taskName": "The Huntsman Path - Woods Keeper",
            "minPlayerLevel": "13",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e4ca86f77409dd5cdf2c",
              "600302d73b897b11364cd161",
              "60e71e8ed54b755a3b53eb67",
              "626bdcc3a371ee3a7a3514c5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e43786f7740a212217fa",
          "data": {
            "taskName": "The Huntsman Path - Justice",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e44386f77409453bce7b",
          "data": {
            "taskName": "The Huntsman Path - Evil Watchman",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e44f86f77443e625e385",
          "data": {
            "taskName": "The Huntsman Path - Eraser - Part 1",
            "minPlayerLevel": "20",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e45e86f77408251c4bfa",
              "60e71e8ed54b755a3b53eb67"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e45e86f77408251c4bfa",
          "data": {
            "taskName": "The Huntsman Path - Eraser - Part 2",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e46e86f77409453bce7c",
          "data": {
            "taskName": "Ambulance",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e48186f77443e625e386",
          "data": {
            "taskName": "Courtesy Visit",
            "minPlayerLevel": "20",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e4ad86f77443e625e387",
              "61904daa7d0d857927447b9c"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e48d86f77408251c4bfb",
          "data": {
            "taskName": "Shady Business",
            "minPlayerLevel": "20",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e46e86f77409453bce7c"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e4ad86f77443e625e387",
          "data": {
            "taskName": "Nostalgia",
            "minPlayerLevel": "28",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e4b786f77408251c4bfc"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e4b786f77408251c4bfc",
          "data": {
            "taskName": "Fishing Place",
            "minPlayerLevel": "28",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e4ca86f77409dd5cdf2c",
          "data": {
            "taskName": "Hunting Trip",
            "minPlayerLevel": "33",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e4d586f77443e625e388",
          "data": {
            "taskName": "Reserve",
            "minPlayerLevel": "20",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "608a768d82e40b3c727fd17d"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d4bec3486f7743cac246665",
          "data": {
            "taskName": "Regulated Materials",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d6fb2c086f77449da599c24",
          "data": {
            "taskName": "An Apple a Day Keeps the Doctor Away",
            "minPlayerLevel": "10",
            "kappaRequired": false,
            "traderName": "Therapist",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d6fbc2886f77449d825f9d3",
          "data": {
            "taskName": "Mentor",
            "minPlayerLevel": "14",
            "kappaRequired": false,
            "traderName": "Peacekeeper",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5dc53acb86f77469c740c893",
          "data": {
            "taskName": "The Stylish One",
            "minPlayerLevel": "30",
            "kappaRequired": false,
            "traderName": "Ragman",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5e381b0286f77420e3417a74",
          "data": {
            "taskName": "Textile - Part 1",
            "minPlayerLevel": "42",
            "kappaRequired": false,
            "traderName": "Ragman",
            "parents": [
              "5e4d4ac186f774264f758336"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5e383a6386f77465910ce1f3",
          "data": {
            "taskName": "Textile - Part 1",
            "minPlayerLevel": "42",
            "kappaRequired": false,
            "traderName": "Ragman",
            "parents": [
              "5e4d515e86f77438b2195244"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5e4d4ac186f774264f758336",
          "data": {
            "taskName": "Textile - Part 2",
            "minPlayerLevel": "42",
            "kappaRequired": false,
            "traderName": "Ragman",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5e4d515e86f77438b2195244",
          "data": {
            "taskName": "Textile - Part 2",
            "minPlayerLevel": "42",
            "kappaRequired": false,
            "traderName": "Ragman",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5eaaaa7c93afa0558f3b5a1c",
          "data": {
            "taskName": "The Survivalist Path - Junkie",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5eda19f0edce541157209cee",
          "data": {
            "taskName": "Anesthesia",
            "minPlayerLevel": "21",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5edabd13218d181e29451442",
              "5edac020218d181e29451446",
              "5f04886a3937dc337a6b8238"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5edab4b1218d181e29451435",
          "data": {
            "taskName": "The Huntsman Path - Sadist",
            "minPlayerLevel": "22",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5edac34d0bb72a50635c2bfa",
              "60e71e8ed54b755a3b53eb67",
              "60e729cf5698ee7b05057439"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5edab736cc183c769d778bc2",
          "data": {
            "taskName": "Colleagues - Part 1",
            "minPlayerLevel": "21",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5edaba7c0c502106f869bc02",
              "5f04886a3937dc337a6b8238"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5edaba7c0c502106f869bc02",
          "data": {
            "taskName": "Colleagues - Part 2",
            "minPlayerLevel": "21",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5edab4b1218d181e29451435"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5edabd13218d181e29451442",
          "data": {
            "taskName": "Rigged Game",
            "minPlayerLevel": "21",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5edab4b1218d181e29451435",
              "60e71c11d54b755a3b53eb65"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5edac020218d181e29451446",
          "data": {
            "taskName": "Samples",
            "minPlayerLevel": "21",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5edac63b930f5454f51e128b"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5edac34d0bb72a50635c2bfa",
          "data": {
            "taskName": "Colleagues - Part 3",
            "minPlayerLevel": "22",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5edac63b930f5454f51e128b"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5edac63b930f5454f51e128b",
          "data": {
            "taskName": "TerraGroup Employee",
            "minPlayerLevel": "23",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ede55112c95834b583f052a",
          "data": {
            "taskName": "The Bunker - Part 1",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5ede567cfa6dc072ce15d6e3"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ede567cfa6dc072ce15d6e3",
          "data": {
            "taskName": "The Bunker - Part 2",
            "minPlayerLevel": "11",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "60896bca6ee58f38c417d4f2"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5f04886a3937dc337a6b8238",
          "data": {
            "taskName": "Chemistry Closet",
            "minPlayerLevel": "22",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5edab4b1218d181e29451435",
              "60e71d23c1bfa3050473b8e6"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5fd9fad9c1ce6b1a3b486d00",
          "data": {
            "taskName": "Search Mission",
            "minPlayerLevel": "5",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "600302d73b897b11364cd161",
          "data": {
            "taskName": "Hunter",
            "minPlayerLevel": "33",
            "kappaRequired": false,
            "traderName": "Jaeger",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6086c852c945025d41566124",
          "data": {
            "taskName": "Revision - Reserve",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "60896888e4a85c72ef3fa300",
              "6179b4d1bca27a099552e04e",
              "639135f286e646067c176a87"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60896888e4a85c72ef3fa300",
          "data": {
            "taskName": "Classified Technologies",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60896b7bfa70fc097863b8f5",
          "data": {
            "taskName": "Documents",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60896bca6ee58f38c417d4f2",
          "data": {
            "taskName": "No Place for Renegades",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "60896b7bfa70fc097863b8f5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60896e28e4a85c72ef3fa301",
          "data": {
            "taskName": "Disease History",
            "minPlayerLevel": "15",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "6179ad56c760af5ad2053587"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6089732b59b92115597ad789",
          "data": {
            "taskName": "Surplus Goods",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6089736efa70fc097863b8f6",
          "data": {
            "taskName": "Back Door",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "6089732b59b92115597ad789"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6089743983426423753cd58a",
          "data": {
            "taskName": "Safe Corridor",
            "minPlayerLevel": "15",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "608974af4b05530f55550c21",
          "data": {
            "taskName": "Inventory Check",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "608974d01a66564e74191fc0",
          "data": {
            "taskName": "A Fuel Matter",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "608974af4b05530f55550c21"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "608a768d82e40b3c727fd17d",
          "data": {
            "taskName": "Pest Control",
            "minPlayerLevel": "20",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e44f86f77443e625e385"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60c0c018f7afb4354815096a",
          "data": {
            "taskName": "The Huntsman Path - Factory Chief",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552",
              "60e71e8ed54b755a3b53eb67"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60e71b62a0beca400d69efc4",
          "data": {
            "taskName": "Escort",
            "minPlayerLevel": "60",
            "kappaRequired": false,
            "traderName": "Prapor",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60e71b9bbd90872cb85440f3",
          "data": {
            "taskName": "Capturing Outposts",
            "minPlayerLevel": "42",
            "kappaRequired": false,
            "traderName": "Prapor",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60e71bb4e456d449cd47ca75",
          "data": {
            "taskName": "Intimidator",
            "minPlayerLevel": "45",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60e71c11d54b755a3b53eb65",
          "data": {
            "taskName": "Night Sweep",
            "minPlayerLevel": "50",
            "kappaRequired": false,
            "traderName": "Skier",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60e71c48c1bfa3050473b8e5",
          "data": {
            "taskName": "Crisis",
            "minPlayerLevel": "48",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60e71c9ad54b755a3b53eb66",
          "data": {
            "taskName": "The Cleaner",
            "minPlayerLevel": "45",
            "kappaRequired": false,
            "traderName": "Peacekeeper",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60e71ccb5688f6424c7bfec4",
          "data": {
            "taskName": "Trophies",
            "minPlayerLevel": "55",
            "kappaRequired": false,
            "traderName": "Peacekeeper",
            "parents": [
              "60e71ce009d7c801eb0c0ec6"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60e71ce009d7c801eb0c0ec6",
          "data": {
            "taskName": "Special Equipment",
            "minPlayerLevel": "60",
            "kappaRequired": false,
            "traderName": "Peacekeeper",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60e71d23c1bfa3050473b8e6",
          "data": {
            "taskName": "Calibration",
            "minPlayerLevel": "47",
            "kappaRequired": false,
            "traderName": "Mechanic",
            "parents": [
              "60e71d6d7fcf9c556f325055"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60e71d6d7fcf9c556f325055",
          "data": {
            "taskName": "The Courier",
            "minPlayerLevel": "52",
            "kappaRequired": false,
            "traderName": "Mechanic",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60e71dc0a94be721b065bbfc",
          "data": {
            "taskName": "Long Line",
            "minPlayerLevel": "45",
            "kappaRequired": false,
            "traderName": "Ragman",
            "parents": [
              "60e71dc67fcf9c556f325056"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60e71dc67fcf9c556f325056",
          "data": {
            "taskName": "Booze",
            "minPlayerLevel": "50",
            "kappaRequired": false,
            "traderName": "Ragman",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60e71e8ed54b755a3b53eb67",
          "data": {
            "taskName": "The Huntsman Path - Relentless",
            "minPlayerLevel": "65",
            "kappaRequired": false,
            "traderName": "Jaeger",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60e729cf5698ee7b05057439",
          "data": {
            "taskName": "Swift One",
            "minPlayerLevel": "50",
            "kappaRequired": false,
            "traderName": "Jaeger",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60effd818b669d08a35bfad5",
          "data": {
            "taskName": "The Choice",
            "minPlayerLevel": "50",
            "kappaRequired": false,
            "traderName": "Fence",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6179ac7511973d018217d0b9",
          "data": {
            "taskName": "Easy Job - Part 1",
            "minPlayerLevel": "18",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "6179acbdc760af5ad2053585",
              "626bd75c71bd851e971b82a5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6179acbdc760af5ad2053585",
          "data": {
            "taskName": "Easy Job - Part 2",
            "minPlayerLevel": "18",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6179ad0a6e9dd54ac275e3f2",
          "data": {
            "taskName": "The Huntsman Path - Outcasts",
            "minPlayerLevel": "22",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6179ad56c760af5ad2053587",
          "data": {
            "taskName": "Seaside Vacation",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6179afd0bca27a099552e040",
          "data": {
            "taskName": "Lost Contact",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "626bd75b05f287031503c7f6"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6179aff8f57fb279792c60a1",
          "data": {
            "taskName": "Overpopulation",
            "minPlayerLevel": "15",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6179b3a12153c15e937d52bc",
          "data": {
            "taskName": "Energy Crisis",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6179b3bdc7560e13d23eeb8d",
          "data": {
            "taskName": "Corporate Secrets",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552",
              "639135e8c115f907b14700aa"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6179b4d1bca27a099552e04e",
          "data": {
            "taskName": "Revision - Lighthouse",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6179b4f16e9dd54ac275e407",
          "data": {
            "taskName": "Missing Cargo",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5c51aac186f77432ea65c552",
              "626bd75d5bef5d7d590bd415"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6179b5b06e9dd54ac275e409",
          "data": {
            "taskName": "Our Own Land",
            "minPlayerLevel": "20",
            "kappaRequired": false,
            "traderName": "Prapor",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6179b5eabca27a099552e052",
          "data": {
            "taskName": "Counteraction",
            "minPlayerLevel": "30",
            "kappaRequired": false,
            "traderName": "Peacekeeper",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "61904daa7d0d857927447b9c",
          "data": {
            "taskName": "The Hermit",
            "minPlayerLevel": "20",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6193850f60b34236ee0483de",
          "data": {
            "taskName": "Long Road",
            "minPlayerLevel": "20",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "6179b4f16e9dd54ac275e407"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "61958c366726521dd96828ec",
          "data": {
            "taskName": "Cargo X - Part 4",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5c0bd01e86f7747cdd799e56",
              "625d6ff5ddc94657c21a1625",
              "639135534b15ca31f76bc317"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "61e6e5e0f5b9633f6719ed95",
          "data": {
            "taskName": "Compensation for Damage - Trust",
            "minPlayerLevel": "0",
            "kappaRequired": false,
            "traderName": "Fence",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "61e6e60223374d168a4576a6",
          "data": {
            "taskName": "Compensation for Damage - Wager",
            "minPlayerLevel": "0",
            "kappaRequired": false,
            "traderName": "Fence",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "61e6e60c5ca3b3783662be27",
          "data": {
            "taskName": "Compensation for Damage - Wergild",
            "minPlayerLevel": "0",
            "kappaRequired": false,
            "traderName": "Fence",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "61e6e615eea2935bc018a2c5",
          "data": {
            "taskName": "Compensation for Damage - Barkeep",
            "minPlayerLevel": "0",
            "kappaRequired": false,
            "traderName": "Fence",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "61e6e621bfeab00251576265",
          "data": {
            "taskName": "Compensation for Damage - Collection",
            "minPlayerLevel": "0",
            "kappaRequired": false,
            "traderName": "Fence",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "625d6ff5ddc94657c21a1625",
          "data": {
            "taskName": "Network Provider - Part 1",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Mechanic",
            "parents": [
              "625d6ffaf7308432be1d44c5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "625d6ffaf7308432be1d44c5",
          "data": {
            "taskName": "Network Provider - Part 2",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Mechanic",
            "parents": [
              "625d6ffcaa168e51321d69d7"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "625d6ffcaa168e51321d69d7",
          "data": {
            "taskName": "Assessment - Part 1",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Mechanic",
            "parents": [
              "625d6fff4149f1149b5b12c9"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "625d6fff4149f1149b5b12c9",
          "data": {
            "taskName": "Assessment - Part 2",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Mechanic",
            "parents": [
              "625d7001c4874104f230c0c5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "625d7001c4874104f230c0c5",
          "data": {
            "taskName": "Assessment - Part 3",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Mechanic",
            "parents": [
              "625d70031ed3bb5bcc5bd9e5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "625d70031ed3bb5bcc5bd9e5",
          "data": {
            "taskName": "Key to the Tower",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Mechanic",
            "parents": [
              "625d7005a4eb80027c4f2e09"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "625d7005a4eb80027c4f2e09",
          "data": {
            "taskName": "Knock-Knock",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Mechanic",
            "parents": [
              "625d700cc48e6c62a440fab5",
              "626148251ed3bb5bcc5bd9ed",
              "63966faeea19ac7ed845db2c"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "625d700cc48e6c62a440fab5",
          "data": {
            "taskName": "Getting Acquainted",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Mechanic",
            "parents": [
              "626bd75d5bef5d7d590bd415"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "626148251ed3bb5bcc5bd9ed",
          "data": {
            "taskName": "Make Amends - Buyout",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Mechanic",
            "parents": [
              "6261482fa4eb80027c4f2e11"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6261482fa4eb80027c4f2e11",
          "data": {
            "taskName": "Make Amends - Equipment",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Mechanic",
            "parents": [
              "626148334149f1149b5b12ca",
              "6391d90f4ed9512be67647df"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "626148334149f1149b5b12ca",
          "data": {
            "taskName": "Make Amends - Security",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Mechanic",
            "parents": [
              "62614836f7308432be1d44cc"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "62614836f7308432be1d44cc",
          "data": {
            "taskName": "Make Amends - Sweep Up",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Mechanic",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "626bd75b05f287031503c7f6",
          "data": {
            "taskName": "Drug Trafficking",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5c51aac186f77432ea65c552",
              "625d6ff5ddc94657c21a1625"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "626bd75c71bd851e971b82a5",
          "data": {
            "taskName": "Reconnaissance",
            "minPlayerLevel": "18",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "626bd75d5bef5d7d590bd415",
          "data": {
            "taskName": "Top Secret",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Skier",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "626bd75e47ea7f506e5493c5",
          "data": {
            "taskName": "Broadcast - Part 1",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552",
              "63913715f8e5dd32bf4e3aaa"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "626bdcc3a371ee3a7a3514c5",
          "data": {
            "taskName": "Stray Dogs",
            "minPlayerLevel": "35",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "638fcd23dc65553116701d33",
          "data": {
            "taskName": "Audit",
            "minPlayerLevel": "17",
            "kappaRequired": false,
            "traderName": "Ragman",
            "parents": [
              "639135a7e705511c8a4a1b78"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639135534b15ca31f76bc317",
          "data": {
            "taskName": "Your Car Needs a Service",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Peacekeeper",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6391359b9444fb141f4e6ee6",
          "data": {
            "taskName": "You've Got Mail",
            "minPlayerLevel": "10",
            "kappaRequired": false,
            "traderName": "Prapor",
            "parents": [
              "639135b04ed9512be67647d7"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639135a7e705511c8a4a1b78",
          "data": {
            "taskName": "Ballet Lover",
            "minPlayerLevel": "20",
            "kappaRequired": false,
            "traderName": "Ragman",
            "parents": [
              "639135bbc115f907b14700a6",
              "64edbb1317ab941a6f7cc247"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639135b04ed9512be67647d7",
          "data": {
            "taskName": "Glory to CPSU - Part 1",
            "minPlayerLevel": "15",
            "kappaRequired": false,
            "traderName": "Prapor",
            "parents": [
              "64f5aac4b63b74469b6c14c2"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639135bbc115f907b14700a6",
          "data": {
            "taskName": "Audiophile",
            "minPlayerLevel": "25",
            "kappaRequired": false,
            "traderName": "Ragman",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639135c3744e452011470807",
          "data": {
            "taskName": "House Arrest - Part 1",
            "minPlayerLevel": "33",
            "kappaRequired": false,
            "traderName": "Skier",
            "parents": [
              "625d6ff5ddc94657c21a1625",
              "639135cd8ba6894d155e77cb"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639135cd8ba6894d155e77cb",
          "data": {
            "taskName": "House Arrest - Part 2",
            "minPlayerLevel": "33",
            "kappaRequired": false,
            "traderName": "Skier",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639135d89444fb141f4e6eea",
          "data": {
            "taskName": "Population Census",
            "minPlayerLevel": "12",
            "kappaRequired": false,
            "traderName": "Therapist",
            "parents": [
              "639135e0fa894f0a866afde6",
              "64f731ab83cfca080a361e42"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639135e0fa894f0a866afde6",
          "data": {
            "taskName": "Urban Medicine",
            "minPlayerLevel": "17",
            "kappaRequired": false,
            "traderName": "Therapist",
            "parents": [
              "64e7b971f9d6fa49d6769b44",
              "64f3176921045e77405d63b5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639135e8c115f907b14700aa",
          "data": {
            "taskName": "Surveillance",
            "minPlayerLevel": "25",
            "kappaRequired": false,
            "traderName": "Mechanic",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639135f286e646067c176a87",
          "data": {
            "taskName": "Revision - Streets of Tarkov",
            "minPlayerLevel": "17",
            "kappaRequired": false,
            "traderName": "Peacekeeper",
            "parents": [
              "63a9b229813bba58a50c9ee5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639136d68ba6894d155e77cf",
          "data": {
            "taskName": "Green Corridor",
            "minPlayerLevel": "20",
            "kappaRequired": false,
            "traderName": "Prapor",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639136df4b15ca31f76bc31f",
          "data": {
            "taskName": "The Huntsman Path - Administrator",
            "minPlayerLevel": "23",
            "kappaRequired": false,
            "traderName": "Jaeger",
            "parents": [
              "63a9b36cc31b00242d28a99f"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639136e84ed9512be67647db",
          "data": {
            "taskName": "Cease Fire!",
            "minPlayerLevel": "10",
            "kappaRequired": false,
            "traderName": "Jaeger",
            "parents": [
              "64f3176921045e77405d63b5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639136f086e646067c176a8b",
          "data": {
            "taskName": "Kings of the Rooftops",
            "minPlayerLevel": "22",
            "kappaRequired": false,
            "traderName": "Prapor",
            "parents": [
              "63a9ae24009ffc6a551631a5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639136fa9444fb141f4e6eee",
          "data": {
            "taskName": "Watching You",
            "minPlayerLevel": "20",
            "kappaRequired": false,
            "traderName": "Mechanic",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "63913715f8e5dd32bf4e3aaa",
          "data": {
            "taskName": "Broadcast - Part 2",
            "minPlayerLevel": "15",
            "kappaRequired": false,
            "traderName": "Mechanic",
            "parents": [
              "625d6ff5ddc94657c21a1625",
              "639135e8c115f907b14700aa",
              "639136fa9444fb141f4e6eee",
              "63a511ea30d85e10e375b045"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6391372c8ba6894d155e77d7",
          "data": {
            "taskName": "Broadcast - Part 4",
            "minPlayerLevel": "27",
            "kappaRequired": false,
            "traderName": "Jaeger",
            "parents": [
              "63a9b36cc31b00242d28a99f",
              "64ee99639878a0569d6ec8c9"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6391d90f4ed9512be67647df",
          "data": {
            "taskName": "Make Amends",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Mechanic",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639282134ed9512be67647ed",
          "data": {
            "taskName": "Road Closed",
            "minPlayerLevel": "20",
            "kappaRequired": false,
            "traderName": "Peacekeeper",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "63966faeea19ac7ed845db2c",
          "data": {
            "taskName": "Information Source",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Lightkeeper",
            "parents": [
              "63966fbeea19ac7ed845db2e"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "63966fbeea19ac7ed845db2e",
          "data": {
            "taskName": "Missing Informant",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Lightkeeper",
            "parents": [
              "63966fccac6f8f3c677b9d89"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "63966fccac6f8f3c677b9d89",
          "data": {
            "taskName": "Snatch",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Lightkeeper",
            "parents": [
              "63966fe7ea74a47c2d3fc0e6"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "63966fd9ea19ac7ed845db30",
          "data": {
            "taskName": "Payback",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Lightkeeper",
            "parents": [
              "63966ff54c3ef01b6f3ffad8"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "63966fe7ea74a47c2d3fc0e6",
          "data": {
            "taskName": "Return the Favor",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Lightkeeper",
            "parents": [
              "63966fd9ea19ac7ed845db30"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "63966ff54c3ef01b6f3ffad8",
          "data": {
            "taskName": "Provocation",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Lightkeeper",
            "parents": [
              "639670029113f06a7c3b2377"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639670029113f06a7c3b2377",
          "data": {
            "taskName": "Following the Bread Crumbs",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Lightkeeper",
            "parents": [
              "6396700fea19ac7ed845db32"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6396700fea19ac7ed845db32",
          "data": {
            "taskName": "Spotter",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Lightkeeper",
            "parents": [
              "6396701b9113f06a7c3b2379"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6396701b9113f06a7c3b2379",
          "data": {
            "taskName": "Make an Impression",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Lightkeeper",
            "parents": [
              "63967028c4a91c5cb76abd81"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "63967028c4a91c5cb76abd81",
          "data": {
            "taskName": "Trouble in the Big City",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Lightkeeper",
            "parents": [
              "64f1cc571a5f313cb144bf90"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639872f9decada40426d3447",
          "data": {
            "taskName": "Gunsmith - Part 4",
            "minPlayerLevel": "9",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ae3267986f7742a413592fe"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639872fa9b4fb827b200d8e5",
          "data": {
            "taskName": "Gunsmith - Part 9",
            "minPlayerLevel": "19",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ae327c886f7745c7b3f2f3f"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639872fc93ae507d5858c3a6",
          "data": {
            "taskName": "Gunsmith - Part 11",
            "minPlayerLevel": "22",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5b47799d86f7746c5d6a5fd8"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639872fe8871e1272b10ccf6",
          "data": {
            "taskName": "Gunsmith - Part 14",
            "minPlayerLevel": "27",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ae3280386f7742a41359364"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639873003693c63d86328f25",
          "data": {
            "taskName": "Gunsmith - Part 19",
            "minPlayerLevel": "36",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5b477f7686f7744d1b23c4d2"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "63987301e11ec11ff5504036",
          "data": {
            "taskName": "Gunsmith - Part 21",
            "minPlayerLevel": "38",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5b47825886f77468074618d3"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639dbaf17c898a131e1cffff",
          "data": {
            "taskName": "Debtor",
            "minPlayerLevel": "31",
            "kappaRequired": false,
            "traderName": "Skier",
            "parents": [
              "639135c3744e452011470807"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "63a511ea30d85e10e375b045",
          "data": {
            "taskName": "Broadcast - Part 3",
            "minPlayerLevel": "20",
            "kappaRequired": false,
            "traderName": "Jaeger",
            "parents": [
              "6391372c8ba6894d155e77d7"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "63a5cf262964a7488f5243ce",
          "data": {
            "taskName": "Test Drive - Part 2",
            "minPlayerLevel": "30",
            "kappaRequired": false,
            "traderName": "Prapor",
            "parents": [
              "64f5deac39e45b527a7c4232"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "63a88045abf76d719f42d715",
          "data": {
            "taskName": "The Delicious Sausage",
            "minPlayerLevel": "5",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e4d586f77443e625e388",
              "639136e84ed9512be67647db"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "63a9ae24009ffc6a551631a5",
          "data": {
            "taskName": "Best Job in the World",
            "minPlayerLevel": "25",
            "kappaRequired": false,
            "traderName": "Prapor",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "63a9b229813bba58a50c9ee5",
          "data": {
            "taskName": "Worst Job in the World",
            "minPlayerLevel": "25",
            "kappaRequired": false,
            "traderName": "Peacekeeper",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "63a9b36cc31b00242d28a99f",
          "data": {
            "taskName": "Slaughterhouse",
            "minPlayerLevel": "40",
            "kappaRequired": false,
            "traderName": "Jaeger",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "63ab180c87413d64ae0ac20a",
          "data": {
            "taskName": "Dangerous Road",
            "minPlayerLevel": "15",
            "kappaRequired": false,
            "traderName": "Therapist",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "64e7b971f9d6fa49d6769b44",
          "data": {
            "taskName": "The Huntsman Path - Big Game",
            "minPlayerLevel": "17",
            "kappaRequired": false,
            "traderName": "Jaeger",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "64e7b99017ab941a6f7bf9d7",
          "data": {
            "taskName": "Gendarmerie - Mall Cop",
            "minPlayerLevel": "21",
            "kappaRequired": false,
            "traderName": "Prapor",
            "parents": [
              "64e7b9a4aac4cd0a726562cb"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "64e7b9a4aac4cd0a726562cb",
          "data": {
            "taskName": "Gendarmerie - Tickets, Please",
            "minPlayerLevel": "21",
            "kappaRequired": false,
            "traderName": "Prapor",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "64edbb1317ab941a6f7cc247",
          "data": {
            "taskName": "Out of Time",
            "minPlayerLevel": "29",
            "kappaRequired": false,
            "traderName": "Ragman",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "64ee99639878a0569d6ec8c9",
          "data": {
            "taskName": "Broadcast - Part 5",
            "minPlayerLevel": "27",
            "kappaRequired": false,
            "traderName": "Jaeger",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "64ee9df4496db64f9b7a4432",
          "data": {
            "taskName": "The Door",
            "minPlayerLevel": "15",
            "kappaRequired": false,
            "traderName": "Mechanic",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "64f1cc571a5f313cb144bf90",
          "data": {
            "taskName": "Overseas Trust - Part 1",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Lightkeeper",
            "parents": [
              "64f1d6e732bed22c3e0c7423"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "64f1d6e732bed22c3e0c7423",
          "data": {
            "taskName": "Overseas Trust - Part 2",
            "minPlayerLevel": "35",
            "kappaRequired": false,
            "traderName": "Ragman",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "64f3176921045e77405d63b5",
          "data": {
            "taskName": "Ambulances Again",
            "minPlayerLevel": "17",
            "kappaRequired": false,
            "traderName": "Therapist",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "64f5aac4b63b74469b6c14c2",
          "data": {
            "taskName": "Glory to CPSU - Part 2",
            "minPlayerLevel": "15",
            "kappaRequired": false,
            "traderName": "Prapor",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "64f5deac39e45b527a7c4232",
          "data": {
            "taskName": "Test Drive - Part 3",
            "minPlayerLevel": "30",
            "kappaRequired": false,
            "traderName": "Prapor",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "64f5e20652fc01298e2c61e3",
          "data": {
            "taskName": "Beyond the Red Meat - Part 1",
            "minPlayerLevel": "22",
            "kappaRequired": false,
            "traderName": "Skier",
            "parents": [
              "64f6aafd67e11a7c6206e0d0"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "64f6aafd67e11a7c6206e0d0",
          "data": {
            "taskName": "Beyond the Red Meat - Part 2",
            "minPlayerLevel": "22",
            "kappaRequired": false,
            "traderName": "Skier",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "64f731ab83cfca080a361e42",
          "data": {
            "taskName": "Pets Won't Need It - Part 1",
            "minPlayerLevel": "12",
            "kappaRequired": false,
            "traderName": "Therapist",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "64f83bb69878a0569d6ecfbe",
          "data": {
            "taskName": "Gunsmith - Part 23",
            "minPlayerLevel": "39",
            "kappaRequired": false,
            "traderName": "Mechanic",
            "parents": [
              "64f83bcdde58fc437700d8fa"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "64f83bcdde58fc437700d8fa",
          "data": {
            "taskName": "Gunsmith - Part 24",
            "minPlayerLevel": "39",
            "kappaRequired": false,
            "traderName": "Mechanic",
            "parents": [
              "64f83bd983cfca080a362c82"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "64f83bd983cfca080a362c82",
          "data": {
            "taskName": "Gunsmith - Part 25",
            "minPlayerLevel": "39",
            "kappaRequired": false,
            "traderName": "Mechanic",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "657315ddab5a49b71f098853",
          "data": {
            "taskName": "First in Line",
            "minPlayerLevel": "0",
            "kappaRequired": false,
            "traderName": "Therapist",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "657315df034d76585f032e01",
          "data": {
            "taskName": "Shooting Cans",
            "minPlayerLevel": "0",
            "kappaRequired": false,
            "traderName": "Prapor",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "657315e270bb0b8dba00cc48",
          "data": {
            "taskName": "Burning Rubber",
            "minPlayerLevel": "0",
            "kappaRequired": false,
            "traderName": "Skier",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "657315e4a6af4ab4b50f3459",
          "data": {
            "taskName": "Saving the Mole",
            "minPlayerLevel": "0",
            "kappaRequired": false,
            "traderName": "Mechanic",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        }
      ],
      "edges": [
        {
          "id": "e5936d90786f7742b1420ba5b-5936da9e86f7742d65037edf",
          "source": "5936d90786f7742b1420ba5b",
          "target": "5936da9e86f7742d65037edf",
          "type": "custom"
        },
        {
          "id": "e5936da9e86f7742d65037edf-59674cd986f7744ab26e32f2",
          "source": "5936da9e86f7742d65037edf",
          "target": "59674cd986f7744ab26e32f2",
          "type": "custom"
        },
        {
          "id": "e5936da9e86f7742d65037edf-59674eb386f774539f14813a",
          "source": "5936da9e86f7742d65037edf",
          "target": "59674eb386f774539f14813a",
          "type": "custom"
        },
        {
          "id": "e59c124d686f774189b3c843f-5967530a86f77462ba22226b",
          "source": "59c124d686f774189b3c843f",
          "target": "5967530a86f77462ba22226b",
          "type": "custom"
        },
        {
          "id": "e5967530a86f77462ba22226b-59675d6c86f7740a842fc482",
          "source": "5967530a86f77462ba22226b",
          "target": "59675d6c86f7740a842fc482",
          "type": "custom"
        },
        {
          "id": "e59675d6c86f7740a842fc482-59675ea386f77414b32bded2",
          "source": "59675d6c86f7740a842fc482",
          "target": "59675ea386f77414b32bded2",
          "type": "custom"
        },
        {
          "id": "e59675ea386f77414b32bded2-596760e186f7741e11214d58",
          "source": "59675ea386f77414b32bded2",
          "target": "596760e186f7741e11214d58",
          "type": "custom"
        },
        {
          "id": "e59675d6c86f7740a842fc482-5967725e86f774601a446662",
          "source": "59675d6c86f7740a842fc482",
          "target": "5967725e86f774601a446662",
          "type": "custom"
        },
        {
          "id": "e5967733e86f774602332fc84-59689ee586f7740d1570bbd5",
          "source": "5967733e86f774602332fc84",
          "target": "59689ee586f7740d1570bbd5",
          "type": "custom"
        },
        {
          "id": "e5967733e86f774602332fc84-59689fbd86f7740d137ebfc4",
          "source": "5967733e86f774602332fc84",
          "target": "59689fbd86f7740d137ebfc4",
          "type": "custom"
        },
        {
          "id": "e59689fbd86f7740d137ebfc4-5968eb3186f7741dde183a4d",
          "source": "59689fbd86f7740d137ebfc4",
          "target": "5968eb3186f7741dde183a4d",
          "type": "custom"
        },
        {
          "id": "e596a204686f774576d4c95de-5969f90786f77420d2328015",
          "source": "596a204686f774576d4c95de",
          "target": "5969f90786f77420d2328015",
          "type": "custom"
        },
        {
          "id": "e5969f90786f77420d2328015-5969f9e986f7741dde183a50",
          "source": "5969f90786f77420d2328015",
          "target": "5969f9e986f7741dde183a50",
          "type": "custom"
        },
        {
          "id": "e5969f9e986f7741dde183a50-596a0e1686f7741ddf17dbee",
          "source": "5969f9e986f7741dde183a50",
          "target": "596a0e1686f7741ddf17dbee",
          "type": "custom"
        },
        {
          "id": "e596a0e1686f7741ddf17dbee-596a101f86f7741ddb481582",
          "source": "596a0e1686f7741ddf17dbee",
          "target": "596a101f86f7741ddb481582",
          "type": "custom"
        },
        {
          "id": "e5969f9e986f7741dde183a50-596a1e6c86f7741ddc2d3206",
          "source": "5969f9e986f7741dde183a50",
          "target": "596a1e6c86f7741ddc2d3206",
          "type": "custom"
        },
        {
          "id": "e59689ee586f7740d1570bbd5-596a204686f774576d4c95de",
          "source": "59689ee586f7740d1570bbd5",
          "target": "596a204686f774576d4c95de",
          "type": "custom"
        },
        {
          "id": "e5969f9e986f7741dde183a50-596a218586f77420d232807c",
          "source": "5969f9e986f7741dde183a50",
          "target": "596a218586f77420d232807c",
          "type": "custom"
        },
        {
          "id": "e596b36c586f77450d6045ad2-596b43fb86f77457ca186186",
          "source": "596b36c586f77450d6045ad2",
          "target": "596b43fb86f77457ca186186",
          "type": "custom"
        },
        {
          "id": "e596b36c586f77450d6045ad2-596b455186f77457cb50eccb",
          "source": "596b36c586f77450d6045ad2",
          "target": "596b455186f77457cb50eccb",
          "type": "custom"
        },
        {
          "id": "e596b43fb86f77457ca186186-5979ed3886f77431307dc512",
          "source": "596b43fb86f77457ca186186",
          "target": "5979ed3886f77431307dc512",
          "type": "custom"
        },
        {
          "id": "e5979ed3886f77431307dc512-5979eee086f774311955e614",
          "source": "5979ed3886f77431307dc512",
          "target": "5979eee086f774311955e614",
          "type": "custom"
        },
        {
          "id": "e5979f9ba86f7740f6c3fe9f2-5979f8bb86f7743ec214c7a6",
          "source": "5979f9ba86f7740f6c3fe9f2",
          "target": "5979f8bb86f7743ec214c7a6",
          "type": "custom"
        },
        {
          "id": "e5979eee086f774311955e614-5979f9ba86f7740f6c3fe9f2",
          "source": "5979eee086f774311955e614",
          "target": "5979f9ba86f7740f6c3fe9f2",
          "type": "custom"
        },
        {
          "id": "e5979f9ba86f7740f6c3fe9f2-597a0b2986f77426d66c0633",
          "source": "5979f9ba86f7740f6c3fe9f2",
          "target": "597a0b2986f77426d66c0633",
          "type": "custom"
        },
        {
          "id": "e597a0b2986f77426d66c0633-597a0e5786f77426d66c0636",
          "source": "597a0b2986f77426d66c0633",
          "target": "597a0e5786f77426d66c0636",
          "type": "custom"
        },
        {
          "id": "e597a0e5786f77426d66c0636-597a0f5686f774273b74f676",
          "source": "597a0e5786f77426d66c0636",
          "target": "597a0f5686f774273b74f676",
          "type": "custom"
        },
        {
          "id": "e597a0f5686f774273b74f676-597a160786f77477531d39d2",
          "source": "597a0f5686f774273b74f676",
          "target": "597a160786f77477531d39d2",
          "type": "custom"
        },
        {
          "id": "e597a0f5686f774273b74f676-597a171586f77405ba6887d3",
          "source": "597a0f5686f774273b74f676",
          "target": "597a171586f77405ba6887d3",
          "type": "custom"
        },
        {
          "id": "e59674eb386f774539f14813a-59c124d686f774189b3c843f",
          "source": "59674eb386f774539f14813a",
          "target": "59c124d686f774189b3c843f",
          "type": "custom"
        },
        {
          "id": "e5967725e86f774601a446662-59c50a9e86f7745fef66f4ff",
          "source": "5967725e86f774601a446662",
          "target": "59c50a9e86f7745fef66f4ff",
          "type": "custom"
        },
        {
          "id": "e59c50a9e86f7745fef66f4ff-59c50c8886f7745fed3193bf",
          "source": "59c50a9e86f7745fef66f4ff",
          "target": "59c50c8886f7745fed3193bf",
          "type": "custom"
        },
        {
          "id": "e59c50c8886f7745fed3193bf-59c512ad86f7741f0d09de9b",
          "source": "59c50c8886f7745fed3193bf",
          "target": "59c512ad86f7741f0d09de9b",
          "type": "custom"
        },
        {
          "id": "e597a160786f77477531d39d2-59c9392986f7742f6923add2",
          "source": "597a160786f77477531d39d2",
          "target": "59c9392986f7742f6923add2",
          "type": "custom"
        },
        {
          "id": "e597a0f5686f774273b74f676-59c93e8e86f7742a406989c4",
          "source": "597a0f5686f774273b74f676",
          "target": "59c93e8e86f7742a406989c4",
          "type": "custom"
        },
        {
          "id": "e597a171586f77405ba6887d3-59ca1a6286f774509a270942",
          "source": "597a171586f77405ba6887d3",
          "target": "59ca1a6286f774509a270942",
          "type": "custom"
        },
        {
          "id": "e59c512ad86f7741f0d09de9b-59ca264786f77445a80ed044",
          "source": "59c512ad86f7741f0d09de9b",
          "target": "59ca264786f77445a80ed044",
          "type": "custom"
        },
        {
          "id": "e59ca264786f77445a80ed044-59ca29fb86f77445ab465c87",
          "source": "59ca264786f77445a80ed044",
          "target": "59ca29fb86f77445ab465c87",
          "type": "custom"
        },
        {
          "id": "e59ca29fb86f77445ab465c87-59ca2eb686f77445a80ed049",
          "source": "59ca29fb86f77445ab465c87",
          "target": "59ca2eb686f77445a80ed049",
          "type": "custom"
        },
        {
          "id": "e5a27d2af86f7744e1115b323-5a03153686f77442d90e2171",
          "source": "5a27d2af86f7744e1115b323",
          "target": "5a03153686f77442d90e2171",
          "type": "custom"
        },
        {
          "id": "e5a27b87686f77460de0252a8-5a03153686f77442d90e2171",
          "source": "5a27b87686f77460de0252a8",
          "target": "5a03153686f77442d90e2171",
          "type": "custom"
        },
        {
          "id": "e5a03153686f77442d90e2171-5a03173786f77451cb427172",
          "source": "5a03153686f77442d90e2171",
          "target": "5a03173786f77451cb427172",
          "type": "custom"
        },
        {
          "id": "e5a03173786f77451cb427172-5a0327ba86f77456b9154236",
          "source": "5a03173786f77451cb427172",
          "target": "5a0327ba86f77456b9154236",
          "type": "custom"
        },
        {
          "id": "e5a0327ba86f77456b9154236-5a03296886f774569778596a",
          "source": "5a0327ba86f77456b9154236",
          "target": "5a03296886f774569778596a",
          "type": "custom"
        },
        {
          "id": "e5a03296886f774569778596a-5a0449d586f77474e66227b7",
          "source": "5a03296886f774569778596a",
          "target": "5a0449d586f77474e66227b7",
          "type": "custom"
        },
        {
          "id": "e5a27c99a86f7747d2c6bdd8e-5a27b75b86f7742e97191958",
          "source": "5a27c99a86f7747d2c6bdd8e",
          "target": "5a27b75b86f7742e97191958",
          "type": "custom"
        },
        {
          "id": "e5a27b75b86f7742e97191958-5a27b7a786f774579c3eb376",
          "source": "5a27b75b86f7742e97191958",
          "target": "5a27b7a786f774579c3eb376",
          "type": "custom"
        },
        {
          "id": "e5a27b7a786f774579c3eb376-5a27b7d686f77460d847e6a6",
          "source": "5a27b7a786f774579c3eb376",
          "target": "5a27b7d686f77460d847e6a6",
          "type": "custom"
        },
        {
          "id": "e5a27b7d686f77460d847e6a6-5a27b80086f774429a5d7e20",
          "source": "5a27b7d686f77460d847e6a6",
          "target": "5a27b80086f774429a5d7e20",
          "type": "custom"
        },
        {
          "id": "e5a27b80086f774429a5d7e20-5a27b87686f77460de0252a8",
          "source": "5a27b80086f774429a5d7e20",
          "target": "5a27b87686f77460de0252a8",
          "type": "custom"
        },
        {
          "id": "e5a27d2af86f7744e1115b323-5a27b9de86f77464e5044585",
          "source": "5a27d2af86f7744e1115b323",
          "target": "5a27b9de86f77464e5044585",
          "type": "custom"
        },
        {
          "id": "e5a27b87686f77460de0252a8-5a27b9de86f77464e5044585",
          "source": "5a27b87686f77460de0252a8",
          "target": "5a27b9de86f77464e5044585",
          "type": "custom"
        },
        {
          "id": "e5a27b9de86f77464e5044585-5a27ba1c86f77461ea5a3c56",
          "source": "5a27b9de86f77464e5044585",
          "target": "5a27ba1c86f77461ea5a3c56",
          "type": "custom"
        },
        {
          "id": "e5a0449d586f77474e66227b7-5a27ba9586f7741b543d8e85",
          "source": "5a0449d586f77474e66227b7",
          "target": "5a27ba9586f7741b543d8e85",
          "type": "custom"
        },
        {
          "id": "e5a27ba9586f7741b543d8e85-5a27bafb86f7741c73584017",
          "source": "5a27ba9586f7741b543d8e85",
          "target": "5a27bafb86f7741c73584017",
          "type": "custom"
        },
        {
          "id": "e5a27bafb86f7741c73584017-5a27bb1e86f7741f27621b7e",
          "source": "5a27bafb86f7741c73584017",
          "target": "5a27bb1e86f7741f27621b7e",
          "type": "custom"
        },
        {
          "id": "e5a27bb1e86f7741f27621b7e-5a27bb3d86f77411ea361a21",
          "source": "5a27bb1e86f7741f27621b7e",
          "target": "5a27bb3d86f77411ea361a21",
          "type": "custom"
        },
        {
          "id": "e5a27bb3d86f77411ea361a21-5a27bb5986f7741dfb660900",
          "source": "5a27bb3d86f77411ea361a21",
          "target": "5a27bb5986f7741dfb660900",
          "type": "custom"
        },
        {
          "id": "e5a27bafb86f7741c73584017-5a27bb8386f7741c770d2d0a",
          "source": "5a27bafb86f7741c73584017",
          "target": "5a27bb8386f7741c770d2d0a",
          "type": "custom"
        },
        {
          "id": "e5a27bb8386f7741c770d2d0a-5a27bbf886f774333a418eeb",
          "source": "5a27bb8386f7741c770d2d0a",
          "target": "5a27bbf886f774333a418eeb",
          "type": "custom"
        },
        {
          "id": "e5a27bbf886f774333a418eeb-5a27bc1586f7741f6d40fa2f",
          "source": "5a27bbf886f774333a418eeb",
          "target": "5a27bc1586f7741f6d40fa2f",
          "type": "custom"
        },
        {
          "id": "e5a27bc1586f7741f6d40fa2f-5a27bc3686f7741c73584026",
          "source": "5a27bc1586f7741f6d40fa2f",
          "target": "5a27bc3686f7741c73584026",
          "type": "custom"
        },
        {
          "id": "e5a27bc3686f7741c73584026-5a27bc6986f7741c7358402b",
          "source": "5a27bc3686f7741c73584026",
          "target": "5a27bc6986f7741c7358402b",
          "type": "custom"
        },
        {
          "id": "e5a27bc6986f7741c7358402b-5a27bc8586f7741b543d8ea4",
          "source": "5a27bc6986f7741c7358402b",
          "target": "5a27bc8586f7741b543d8ea4",
          "type": "custom"
        },
        {
          "id": "e596b36c586f77450d6045ad2-5a27c99a86f7747d2c6bdd8e",
          "source": "596b36c586f77450d6045ad2",
          "target": "5a27c99a86f7747d2c6bdd8e",
          "type": "custom"
        },
        {
          "id": "e5a27c99a86f7747d2c6bdd8e-5a27d2af86f7744e1115b323",
          "source": "5a27c99a86f7747d2c6bdd8e",
          "target": "5a27d2af86f7744e1115b323",
          "type": "custom"
        },
        {
          "id": "e5969f9e986f7741dde183a50-5a68661a86f774500f48afb0",
          "source": "5969f9e986f7741dde183a50",
          "target": "5a68661a86f774500f48afb0",
          "type": "custom"
        },
        {
          "id": "e5a68661a86f774500f48afb0-5a68663e86f774501078f78a",
          "source": "5a68661a86f774500f48afb0",
          "target": "5a68663e86f774501078f78a",
          "type": "custom"
        },
        {
          "id": "e5a68663e86f774501078f78a-5a68665c86f774255929b4c7",
          "source": "5a68663e86f774501078f78a",
          "target": "5a68665c86f774255929b4c7",
          "type": "custom"
        },
        {
          "id": "e5a68665c86f774255929b4c7-5a68667486f7742607157d28",
          "source": "5a68665c86f774255929b4c7",
          "target": "5a68667486f7742607157d28",
          "type": "custom"
        },
        {
          "id": "e5a68667486f7742607157d28-5a68669a86f774255929b4d4",
          "source": "5a68667486f7742607157d28",
          "target": "5a68669a86f774255929b4d4",
          "type": "custom"
        },
        {
          "id": "e5ac23c6186f7741247042bad-5ac2426c86f774138762edfe",
          "source": "5ac23c6186f7741247042bad",
          "target": "5ac2426c86f774138762edfe",
          "type": "custom"
        },
        {
          "id": "e5ac23c6186f7741247042bad-5ac2428686f77412450b42bf",
          "source": "5ac23c6186f7741247042bad",
          "target": "5ac2428686f77412450b42bf",
          "type": "custom"
        },
        {
          "id": "e5ae3280386f7742a41359364-5ac242ab86f77412464f68b4",
          "source": "5ae3280386f7742a41359364",
          "target": "5ac242ab86f77412464f68b4",
          "type": "custom"
        },
        {
          "id": "e5b47799d86f7746c5d6a5fd8-5ac244c486f77413e12cf945",
          "source": "5b47799d86f7746c5d6a5fd8",
          "target": "5ac244c486f77413e12cf945",
          "type": "custom"
        },
        {
          "id": "e5ae3270f86f77445ba41d4dd-5ac244eb86f7741356335af1",
          "source": "5ae3270f86f77445ba41d4dd",
          "target": "5ac244eb86f7741356335af1",
          "type": "custom"
        },
        {
          "id": "e5ac23c6186f7741247042bad-5ac345dc86f774288030817f",
          "source": "5ac23c6186f7741247042bad",
          "target": "5ac345dc86f774288030817f",
          "type": "custom"
        },
        {
          "id": "e5ac345dc86f774288030817f-5ac3460c86f7742880308185",
          "source": "5ac345dc86f774288030817f",
          "target": "5ac3460c86f7742880308185",
          "type": "custom"
        },
        {
          "id": "e5ac3460c86f7742880308185-5ac3462b86f7741d6118b983",
          "source": "5ac3460c86f7742880308185",
          "target": "5ac3462b86f7741d6118b983",
          "type": "custom"
        },
        {
          "id": "e5ac3462b86f7741d6118b983-5ac3464c86f7741d651d6877",
          "source": "5ac3462b86f7741d6118b983",
          "target": "5ac3464c86f7741d651d6877",
          "type": "custom"
        },
        {
          "id": "e5ac2426c86f774138762edfe-5ac3467986f7741d6224abc2",
          "source": "5ac2426c86f774138762edfe",
          "target": "5ac3467986f7741d6224abc2",
          "type": "custom"
        },
        {
          "id": "e5ac3467986f7741d6224abc2-5ac346a886f7744e1b083d67",
          "source": "5ac3467986f7741d6224abc2",
          "target": "5ac346a886f7744e1b083d67",
          "type": "custom"
        },
        {
          "id": "e5ac346a886f7744e1b083d67-5ac346cf86f7741d63233a02",
          "source": "5ac346a886f7744e1b083d67",
          "target": "5ac346cf86f7741d63233a02",
          "type": "custom"
        },
        {
          "id": "e5ac346cf86f7741d63233a02-5ac346e886f7741d6118b99b",
          "source": "5ac346cf86f7741d63233a02",
          "target": "5ac346e886f7741d6118b99b",
          "type": "custom"
        },
        {
          "id": "e5ac3460c86f7742880308185-5ac3475486f7741d6224abd3",
          "source": "5ac3460c86f7742880308185",
          "target": "5ac3475486f7741d6224abd3",
          "type": "custom"
        },
        {
          "id": "e5ac346a886f7744e1b083d67-5ac3477486f7741d651d6885",
          "source": "5ac346a886f7744e1b083d67",
          "target": "5ac3477486f7741d651d6885",
          "type": "custom"
        },
        {
          "id": "e5ac2428686f77412450b42bf-5ac3479086f7742880308199",
          "source": "5ac2428686f77412450b42bf",
          "target": "5ac3479086f7742880308199",
          "type": "custom"
        },
        {
          "id": "e5ac3467986f7741d6224abc2-5ac3479086f7742880308199",
          "source": "5ac3467986f7741d6224abc2",
          "target": "5ac3479086f7742880308199",
          "type": "custom"
        },
        {
          "id": "e639872f9decada40426d3447-5ae3267986f7742a413592fe",
          "source": "639872f9decada40426d3447",
          "target": "5ae3267986f7742a413592fe",
          "type": "custom"
        },
        {
          "id": "e5ae3267986f7742a413592fe-5ae3270f86f77445ba41d4dd",
          "source": "5ae3267986f7742a413592fe",
          "target": "5ae3270f86f77445ba41d4dd",
          "type": "custom"
        },
        {
          "id": "e5ac244eb86f7741356335af1-5ae3277186f7745973054106",
          "source": "5ac244eb86f7741356335af1",
          "target": "5ae3277186f7745973054106",
          "type": "custom"
        },
        {
          "id": "e639872fa9b4fb827b200d8e5-5ae327c886f7745c7b3f2f3f",
          "source": "639872fa9b4fb827b200d8e5",
          "target": "5ae327c886f7745c7b3f2f3f",
          "type": "custom"
        },
        {
          "id": "e639872fe8871e1272b10ccf6-5ae3280386f7742a41359364",
          "source": "639872fe8871e1272b10ccf6",
          "target": "5ae3280386f7742a41359364",
          "type": "custom"
        },
        {
          "id": "e5ae448a386f7744d3730fff0-5ae448bf86f7744d733e55ee",
          "source": "5ae448a386f7744d3730fff0",
          "target": "5ae448bf86f7744d733e55ee",
          "type": "custom"
        },
        {
          "id": "e5ae448a386f7744d3730fff0-5ae448e586f7744dcf0c2a67",
          "source": "5ae448a386f7744d3730fff0",
          "target": "5ae448e586f7744dcf0c2a67",
          "type": "custom"
        },
        {
          "id": "e5ae448e586f7744dcf0c2a67-5ae448f286f77448d73c0131",
          "source": "5ae448e586f7744dcf0c2a67",
          "target": "5ae448f286f77448d73c0131",
          "type": "custom"
        },
        {
          "id": "e5ae448bf86f7744d733e55ee-5ae448f286f77448d73c0131",
          "source": "5ae448bf86f7744d733e55ee",
          "target": "5ae448f286f77448d73c0131",
          "type": "custom"
        },
        {
          "id": "e5ae448f286f77448d73c0131-5ae4490786f7744ca822adcc",
          "source": "5ae448f286f77448d73c0131",
          "target": "5ae4490786f7744ca822adcc",
          "type": "custom"
        },
        {
          "id": "e5ae448e586f7744dcf0c2a67-5ae4493486f7744efa289417",
          "source": "5ae448e586f7744dcf0c2a67",
          "target": "5ae4493486f7744efa289417",
          "type": "custom"
        },
        {
          "id": "e5ae448bf86f7744d733e55ee-5ae4493486f7744efa289417",
          "source": "5ae448bf86f7744d733e55ee",
          "target": "5ae4493486f7744efa289417",
          "type": "custom"
        },
        {
          "id": "e5ae4493486f7744efa289417-5ae4493d86f7744b8e15aa8f",
          "source": "5ae4493486f7744efa289417",
          "target": "5ae4493d86f7744b8e15aa8f",
          "type": "custom"
        },
        {
          "id": "e5ae4493d86f7744b8e15aa8f-5ae4495086f77443c122bc40",
          "source": "5ae4493d86f7744b8e15aa8f",
          "target": "5ae4495086f77443c122bc40",
          "type": "custom"
        },
        {
          "id": "e5ae4495086f77443c122bc40-5ae4495c86f7744e87761355",
          "source": "5ae4495086f77443c122bc40",
          "target": "5ae4495c86f7744e87761355",
          "type": "custom"
        },
        {
          "id": "e5ae4495c86f7744e87761355-5ae4496986f774459e77beb6",
          "source": "5ae4495c86f7744e87761355",
          "target": "5ae4496986f774459e77beb6",
          "type": "custom"
        },
        {
          "id": "e5ae4496986f774459e77beb6-5ae4497b86f7744cf402ed00",
          "source": "5ae4496986f774459e77beb6",
          "target": "5ae4497b86f7744cf402ed00",
          "type": "custom"
        },
        {
          "id": "e5ae4495c86f7744e87761355-5ae4498786f7744bde357695",
          "source": "5ae4495c86f7744e87761355",
          "target": "5ae4498786f7744bde357695",
          "type": "custom"
        },
        {
          "id": "e5ae448f286f77448d73c0131-5ae4499a86f77449783815db",
          "source": "5ae448f286f77448d73c0131",
          "target": "5ae4499a86f77449783815db",
          "type": "custom"
        },
        {
          "id": "e5ae4497b86f7744cf402ed00-5ae4499a86f77449783815db",
          "source": "5ae4497b86f7744cf402ed00",
          "target": "5ae4499a86f77449783815db",
          "type": "custom"
        },
        {
          "id": "e5ae4498786f7744bde357695-5ae449a586f7744bde357696",
          "source": "5ae4498786f7744bde357695",
          "target": "5ae449a586f7744bde357696",
          "type": "custom"
        },
        {
          "id": "e5ae4490786f7744ca822adcc-5ae449b386f77446d8741719",
          "source": "5ae4490786f7744ca822adcc",
          "target": "5ae449b386f77446d8741719",
          "type": "custom"
        },
        {
          "id": "e5ae4493d86f7744b8e15aa8f-5ae449b386f77446d8741719",
          "source": "5ae4493d86f7744b8e15aa8f",
          "target": "5ae449b386f77446d8741719",
          "type": "custom"
        },
        {
          "id": "e5ae449b386f77446d8741719-5ae449c386f7744bde357697",
          "source": "5ae449b386f77446d8741719",
          "target": "5ae449c386f7744bde357697",
          "type": "custom"
        },
        {
          "id": "e5ae4498786f7744bde357695-5ae449d986f774453a54a7e1",
          "source": "5ae4498786f7744bde357695",
          "target": "5ae449d986f774453a54a7e1",
          "type": "custom"
        },
        {
          "id": "e5ae449c386f7744bde357697-5ae449d986f774453a54a7e1",
          "source": "5ae449c386f7744bde357697",
          "target": "5ae449d986f774453a54a7e1",
          "type": "custom"
        },
        {
          "id": "e5ac242ab86f77412464f68b4-5b47749f86f7746c5d6a5fd4",
          "source": "5ac242ab86f77412464f68b4",
          "target": "5b47749f86f7746c5d6a5fd4",
          "type": "custom"
        },
        {
          "id": "e639872fc93ae507d5858c3a6-5b47799d86f7746c5d6a5fd8",
          "source": "639872fc93ae507d5858c3a6",
          "target": "5b47799d86f7746c5d6a5fd8",
          "type": "custom"
        },
        {
          "id": "e5b47749f86f7746c5d6a5fd4-5b477b6f86f7747290681823",
          "source": "5b47749f86f7746c5d6a5fd4",
          "target": "5b477b6f86f7747290681823",
          "type": "custom"
        },
        {
          "id": "e639873003693c63d86328f25-5b477f7686f7744d1b23c4d2",
          "source": "639873003693c63d86328f25",
          "target": "5b477f7686f7744d1b23c4d2",
          "type": "custom"
        },
        {
          "id": "e63987301e11ec11ff5504036-5b47825886f77468074618d3",
          "source": "63987301e11ec11ff5504036",
          "target": "5b47825886f77468074618d3",
          "type": "custom"
        },
        {
          "id": "e5ae448f286f77448d73c0131-5b47876e86f7744d1c353205",
          "source": "5ae448f286f77448d73c0131",
          "target": "5b47876e86f7744d1c353205",
          "type": "custom"
        },
        {
          "id": "e5ae4495086f77443c122bc40-5b47876e86f7744d1c353205",
          "source": "5ae4495086f77443c122bc40",
          "target": "5b47876e86f7744d1c353205",
          "type": "custom"
        },
        {
          "id": "e5ae448f286f77448d73c0131-5b47891f86f7744d1b23c571",
          "source": "5ae448f286f77448d73c0131",
          "target": "5b47891f86f7744d1b23c571",
          "type": "custom"
        },
        {
          "id": "e5ae4496986f774459e77beb6-5b47891f86f7744d1b23c571",
          "source": "5ae4496986f774459e77beb6",
          "target": "5b47891f86f7744d1b23c571",
          "type": "custom"
        },
        {
          "id": "e5ae449b386f77446d8741719-5b478b1886f7744d1b23c57d",
          "source": "5ae449b386f77446d8741719",
          "target": "5b478b1886f7744d1b23c57d",
          "type": "custom"
        },
        {
          "id": "e5ae4493d86f7744b8e15aa8f-5b478d0f86f7744d190d91b5",
          "source": "5ae4493d86f7744b8e15aa8f",
          "target": "5b478d0f86f7744d190d91b5",
          "type": "custom"
        },
        {
          "id": "e597a0e5786f77426d66c0636-5b478eca86f7744642012254",
          "source": "597a0e5786f77426d66c0636",
          "target": "5b478eca86f7744642012254",
          "type": "custom"
        },
        {
          "id": "e5b478eca86f7744642012254-5b478ff486f7744d184ecbbf",
          "source": "5b478eca86f7744642012254",
          "target": "5b478ff486f7744d184ecbbf",
          "type": "custom"
        },
        {
          "id": "e5a27d2af86f7744e1115b323-5b47926a86f7747ccc057c15",
          "source": "5a27d2af86f7744e1115b323",
          "target": "5b47926a86f7747ccc057c15",
          "type": "custom"
        },
        {
          "id": "e5a27d2af86f7744e1115b323-5b4794cb86f774598100d5d4",
          "source": "5a27d2af86f7744e1115b323",
          "target": "5b4794cb86f774598100d5d4",
          "type": "custom"
        },
        {
          "id": "e5b47926a86f7747ccc057c15-5b4795fb86f7745876267770",
          "source": "5b47926a86f7747ccc057c15",
          "target": "5b4795fb86f7745876267770",
          "type": "custom"
        },
        {
          "id": "e5d24b81486f77439c92d6ba8-5bc4776586f774512d07cf05",
          "source": "5d24b81486f77439c92d6ba8",
          "target": "5bc4776586f774512d07cf05",
          "type": "custom"
        },
        {
          "id": "e5bc4776586f774512d07cf05-5bc479e586f7747f376c7da3",
          "source": "5bc4776586f774512d07cf05",
          "target": "5bc479e586f7747f376c7da3",
          "type": "custom"
        },
        {
          "id": "e5bc479e586f7747f376c7da3-5bc47dbf86f7741ee74e93b9",
          "source": "5bc479e586f7747f376c7da3",
          "target": "5bc47dbf86f7741ee74e93b9",
          "type": "custom"
        },
        {
          "id": "e5bc47dbf86f7741ee74e93b9-5bc480a686f7741af0342e29",
          "source": "5bc47dbf86f7741ee74e93b9",
          "target": "5bc480a686f7741af0342e29",
          "type": "custom"
        },
        {
          "id": "e5bc480a686f7741af0342e29-5bc4826c86f774106d22d88b",
          "source": "5bc480a686f7741af0342e29",
          "target": "5bc4826c86f774106d22d88b",
          "type": "custom"
        },
        {
          "id": "e5bc4826c86f774106d22d88b-5bc4836986f7740c0152911c",
          "source": "5bc4826c86f774106d22d88b",
          "target": "5bc4836986f7740c0152911c",
          "type": "custom"
        },
        {
          "id": "e5bc4836986f7740c0152911c-5bc4856986f77454c317bea7",
          "source": "5bc4836986f7740c0152911c",
          "target": "5bc4856986f77454c317bea7",
          "type": "custom"
        },
        {
          "id": "e5bc4856986f77454c317bea7-5bc4893c86f774626f5ebf3e",
          "source": "5bc4856986f77454c317bea7",
          "target": "5bc4893c86f774626f5ebf3e",
          "type": "custom"
        },
        {
          "id": "e5c0bc91486f7746ab41857a2-5c0bbaa886f7746941031d82",
          "source": "5c0bc91486f7746ab41857a2",
          "target": "5c0bbaa886f7746941031d82",
          "type": "custom"
        },
        {
          "id": "e5b4795fb86f7745876267770-5c0bc91486f7746ab41857a2",
          "source": "5b4795fb86f7745876267770",
          "target": "5c0bc91486f7746ab41857a2",
          "type": "custom"
        },
        {
          "id": "e61958c366726521dd96828ec-5c0bd01e86f7747cdd799e56",
          "source": "61958c366726521dd96828ec",
          "target": "5c0bd01e86f7747cdd799e56",
          "type": "custom"
        },
        {
          "id": "e5c0d190cd09282029f5390d8-5c0bd94186f7747a727f09b2",
          "source": "5c0d190cd09282029f5390d8",
          "target": "5c0bd94186f7747a727f09b2",
          "type": "custom"
        },
        {
          "id": "e5b4795fb86f7745876267770-5c0bdb5286f774166e38eed4",
          "source": "5b4795fb86f7745876267770",
          "target": "5c0bdb5286f774166e38eed4",
          "type": "custom"
        },
        {
          "id": "e5ac3462b86f7741d6118b983-5c0bde0986f77479cf22c2f8",
          "source": "5ac3462b86f7741d6118b983",
          "target": "5c0bde0986f77479cf22c2f8",
          "type": "custom"
        },
        {
          "id": "e5a27bc8586f7741b543d8ea4-5c0be13186f7746f016734aa",
          "source": "5a27bc8586f7741b543d8ea4",
          "target": "5c0be13186f7746f016734aa",
          "type": "custom"
        },
        {
          "id": "e5a68667486f7742607157d28-5c0be5fc86f774467a116593",
          "source": "5a68667486f7742607157d28",
          "target": "5c0be5fc86f774467a116593",
          "type": "custom"
        },
        {
          "id": "e5a68667486f7742607157d28-5c0d0d5086f774363760aef2",
          "source": "5a68667486f7742607157d28",
          "target": "5c0d0d5086f774363760aef2",
          "type": "custom"
        },
        {
          "id": "e5b4794cb86f774598100d5d4-5c0d0f1886f77457b8210226",
          "source": "5b4794cb86f774598100d5d4",
          "target": "5c0d0f1886f77457b8210226",
          "type": "custom"
        },
        {
          "id": "e5a68669a86f774255929b4d4-5c0d1c4cd0928202a02a6f5c",
          "source": "5a68669a86f774255929b4d4",
          "target": "5c0d1c4cd0928202a02a6f5c",
          "type": "custom"
        },
        {
          "id": "e5c0be5fc86f774467a116593-5c0d1c4cd0928202a02a6f5c",
          "source": "5c0be5fc86f774467a116593",
          "target": "5c0d1c4cd0928202a02a6f5c",
          "type": "custom"
        },
        {
          "id": "e5c0d0f1886f77457b8210226-5c0d4c12d09282029f539173",
          "source": "5c0d0f1886f77457b8210226",
          "target": "5c0d4c12d09282029f539173",
          "type": "custom"
        },
        {
          "id": "e5a27bc8586f7741b543d8ea4-5c0d4e61d09282029f53920e",
          "source": "5a27bc8586f7741b543d8ea4",
          "target": "5c0d4e61d09282029f53920e",
          "type": "custom"
        },
        {
          "id": "e5b47876e86f7744d1c353205-5c10f94386f774227172c572",
          "source": "5b47876e86f7744d1c353205",
          "target": "5c10f94386f774227172c572",
          "type": "custom"
        },
        {
          "id": "e5ac3464c86f7741d651d6877-5c1128e386f7746565181106",
          "source": "5ac3464c86f7741d651d6877",
          "target": "5c1128e386f7746565181106",
          "type": "custom"
        },
        {
          "id": "e5b478b1886f7744d1b23c57d-5c112d7e86f7740d6f647486",
          "source": "5b478b1886f7744d1b23c57d",
          "target": "5c112d7e86f7740d6f647486",
          "type": "custom"
        },
        {
          "id": "e5b47891f86f7744d1b23c571-5c1141f386f77430ff393792",
          "source": "5b47891f86f7744d1b23c571",
          "target": "5c1141f386f77430ff393792",
          "type": "custom"
        },
        {
          "id": "e5c10f94386f774227172c572-5c1141f386f77430ff393792",
          "source": "5c10f94386f774227172c572",
          "target": "5c1141f386f77430ff393792",
          "type": "custom"
        },
        {
          "id": "e5c0bbaa886f7746941031d82-5c1234c286f77406fa13baeb",
          "source": "5c0bbaa886f7746941031d82",
          "target": "5c1234c286f77406fa13baeb",
          "type": "custom"
        },
        {
          "id": "e5967725e86f774601a446662-5c12452c86f7744b83469073",
          "source": "5967725e86f774601a446662",
          "target": "5c12452c86f7744b83469073",
          "type": "custom"
        },
        {
          "id": "e5ac3464c86f7741d651d6877-5c139eb686f7747878361a6f",
          "source": "5ac3464c86f7741d651d6877",
          "target": "5c139eb686f7747878361a6f",
          "type": "custom"
        },
        {
          "id": "e5bc4893c86f774626f5ebf3e-5c51aac186f77432ea65c552",
          "source": "5bc4893c86f774626f5ebf3e",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5eaaaa7c93afa0558f3b5a1c-5c51aac186f77432ea65c552",
          "source": "5eaaaa7c93afa0558f3b5a1c",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5d25e43786f7740a212217fa-5c51aac186f77432ea65c552",
          "source": "5d25e43786f7740a212217fa",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5d25e2d886f77442734d335e-5c51aac186f77432ea65c552",
          "source": "5d25e2d886f77442734d335e",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5d25e44386f77409453bce7b-5c51aac186f77432ea65c552",
          "source": "5d25e44386f77409453bce7b",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5fd9fad9c1ce6b1a3b486d00-5c51aac186f77432ea65c552",
          "source": "5fd9fad9c1ce6b1a3b486d00",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e596b455186f77457cb50eccb-5c51aac186f77432ea65c552",
          "source": "596b455186f77457cb50eccb",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e596a218586f77420d232807c-5c51aac186f77432ea65c552",
          "source": "596a218586f77420d232807c",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5ac3475486f7741d6224abd3-5c51aac186f77432ea65c552",
          "source": "5ac3475486f7741d6224abd3",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5ac3479086f7742880308199-5c51aac186f77432ea65c552",
          "source": "5ac3479086f7742880308199",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5a27ba1c86f77461ea5a3c56-5c51aac186f77432ea65c552",
          "source": "5a27ba1c86f77461ea5a3c56",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e60896b7bfa70fc097863b8f5-5c51aac186f77432ea65c552",
          "source": "60896b7bfa70fc097863b8f5",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e60c0c018f7afb4354815096a-5c51aac186f77432ea65c552",
          "source": "60c0c018f7afb4354815096a",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e626bd75e47ea7f506e5493c5-5c51aac186f77432ea65c552",
          "source": "626bd75e47ea7f506e5493c5",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c0bde0986f77479cf22c2f8-5c51aac186f77432ea65c552",
          "source": "5c0bde0986f77479cf22c2f8",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e60896888e4a85c72ef3fa300-5c51aac186f77432ea65c552",
          "source": "60896888e4a85c72ef3fa300",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e6089732b59b92115597ad789-5c51aac186f77432ea65c552",
          "source": "6089732b59b92115597ad789",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e6179b4d1bca27a099552e04e-5c51aac186f77432ea65c552",
          "source": "6179b4d1bca27a099552e04e",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5ac346e886f7741d6118b99b-5c51aac186f77432ea65c552",
          "source": "5ac346e886f7741d6118b99b",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e6179aff8f57fb279792c60a1-5c51aac186f77432ea65c552",
          "source": "6179aff8f57fb279792c60a1",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e6089743983426423753cd58a-5c51aac186f77432ea65c552",
          "source": "6089743983426423753cd58a",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e608974af4b05530f55550c21-5c51aac186f77432ea65c552",
          "source": "608974af4b05530f55550c21",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e6179b3bdc7560e13d23eeb8d-5c51aac186f77432ea65c552",
          "source": "6179b3bdc7560e13d23eeb8d",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e6179ad56c760af5ad2053587-5c51aac186f77432ea65c552",
          "source": "6179ad56c760af5ad2053587",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e626bd75b05f287031503c7f6-5c51aac186f77432ea65c552",
          "source": "626bd75b05f287031503c7f6",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e6179acbdc760af5ad2053585-5c51aac186f77432ea65c552",
          "source": "6179acbdc760af5ad2053585",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e626bd75c71bd851e971b82a5-5c51aac186f77432ea65c552",
          "source": "626bd75c71bd851e971b82a5",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e61904daa7d0d857927447b9c-5c51aac186f77432ea65c552",
          "source": "61904daa7d0d857927447b9c",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5b478ff486f7744d184ecbbf-5c51aac186f77432ea65c552",
          "source": "5b478ff486f7744d184ecbbf",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e6179ad0a6e9dd54ac275e3f2-5c51aac186f77432ea65c552",
          "source": "6179ad0a6e9dd54ac275e3f2",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5edac63b930f5454f51e128b-5c51aac186f77432ea65c552",
          "source": "5edac63b930f5454f51e128b",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5b478d0f86f7744d190d91b5-5c51aac186f77432ea65c552",
          "source": "5b478d0f86f7744d190d91b5",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5d25e46e86f77409453bce7c-5c51aac186f77432ea65c552",
          "source": "5d25e46e86f77409453bce7c",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c0bd01e86f7747cdd799e56-5c51aac186f77432ea65c552",
          "source": "5c0bd01e86f7747cdd799e56",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e6179b3a12153c15e937d52bc-5c51aac186f77432ea65c552",
          "source": "6179b3a12153c15e937d52bc",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5ae4499a86f77449783815db-5c51aac186f77432ea65c552",
          "source": "5ae4499a86f77449783815db",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5d4bec3486f7743cac246665-5c51aac186f77432ea65c552",
          "source": "5d4bec3486f7743cac246665",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5ae449a586f7744bde357696-5c51aac186f77432ea65c552",
          "source": "5ae449a586f7744bde357696",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5d25e4b786f77408251c4bfc-5c51aac186f77432ea65c552",
          "source": "5d25e4b786f77408251c4bfc",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c112d7e86f7740d6f647486-5c51aac186f77432ea65c552",
          "source": "5c112d7e86f7740d6f647486",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c1234c286f77406fa13baeb-5c51aac186f77432ea65c552",
          "source": "5c1234c286f77406fa13baeb",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c1141f386f77430ff393792-5c51aac186f77432ea65c552",
          "source": "5c1141f386f77430ff393792",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c1128e386f7746565181106-5c51aac186f77432ea65c552",
          "source": "5c1128e386f7746565181106",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c0bd94186f7747a727f09b2-5c51aac186f77432ea65c552",
          "source": "5c0bd94186f7747a727f09b2",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5d25e45e86f77408251c4bfa-5c51aac186f77432ea65c552",
          "source": "5d25e45e86f77408251c4bfa",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e6179b4f16e9dd54ac275e407-5c51aac186f77432ea65c552",
          "source": "6179b4f16e9dd54ac275e407",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c0d4c12d09282029f539173-5c51aac186f77432ea65c552",
          "source": "5c0d4c12d09282029f539173",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5d25e4ca86f77409dd5cdf2c-5c51aac186f77432ea65c552",
          "source": "5d25e4ca86f77409dd5cdf2c",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c0d1c4cd0928202a02a6f5c-5c51aac186f77432ea65c552",
          "source": "5c0d1c4cd0928202a02a6f5c",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c0bdb5286f774166e38eed4-5c51aac186f77432ea65c552",
          "source": "5c0bdb5286f774166e38eed4",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c0be13186f7746f016734aa-5c51aac186f77432ea65c552",
          "source": "5c0be13186f7746f016734aa",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c12452c86f7744b83469073-5c51aac186f77432ea65c552",
          "source": "5c12452c86f7744b83469073",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c139eb686f7747878361a6f-5c51aac186f77432ea65c552",
          "source": "5c139eb686f7747878361a6f",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e626bdcc3a371ee3a7a3514c5-5c51aac186f77432ea65c552",
          "source": "626bdcc3a371ee3a7a3514c5",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5b47825886f77468074618d3-5c51aac186f77432ea65c552",
          "source": "5b47825886f77468074618d3",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5ae449d986f774453a54a7e1-5c51aac186f77432ea65c552",
          "source": "5ae449d986f774453a54a7e1",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c0d4e61d09282029f53920e-5c51aac186f77432ea65c552",
          "source": "5c0d4e61d09282029f53920e",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e60e71bb4e456d449cd47ca75-5c51aac186f77432ea65c552",
          "source": "60e71bb4e456d449cd47ca75",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e60e71c48c1bfa3050473b8e5-5c51aac186f77432ea65c552",
          "source": "60e71c48c1bfa3050473b8e5",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5ac23c6186f7741247042bad-5d2495a886f77425cd51e403",
          "source": "5ac23c6186f7741247042bad",
          "target": "5d2495a886f77425cd51e403",
          "type": "custom"
        },
        {
          "id": "e5d2495a886f77425cd51e403-5d24b81486f77439c92d6ba8",
          "source": "5d2495a886f77425cd51e403",
          "target": "5d24b81486f77439c92d6ba8",
          "type": "custom"
        },
        {
          "id": "e5d24b81486f77439c92d6ba8-5d25aed386f77442734d25d2",
          "source": "5d24b81486f77439c92d6ba8",
          "target": "5d25aed386f77442734d25d2",
          "type": "custom"
        },
        {
          "id": "e5d25aed386f77442734d25d2-5d25b6be86f77444001e1b89",
          "source": "5d25aed386f77442734d25d2",
          "target": "5d25b6be86f77444001e1b89",
          "type": "custom"
        },
        {
          "id": "e5d25b6be86f77444001e1b89-5d25bfd086f77442734d3007",
          "source": "5d25b6be86f77444001e1b89",
          "target": "5d25bfd086f77442734d3007",
          "type": "custom"
        },
        {
          "id": "e5d25bfd086f77442734d3007-5d25c81b86f77443e625dd71",
          "source": "5d25bfd086f77442734d3007",
          "target": "5d25c81b86f77443e625dd71",
          "type": "custom"
        },
        {
          "id": "e5d25c81b86f77443e625dd71-5d25cf2686f77443e75488d4",
          "source": "5d25c81b86f77443e625dd71",
          "target": "5d25cf2686f77443e75488d4",
          "type": "custom"
        },
        {
          "id": "e5d25c81b86f77443e625dd71-5d25d2c186f77443e35162e5",
          "source": "5d25c81b86f77443e625dd71",
          "target": "5d25d2c186f77443e35162e5",
          "type": "custom"
        },
        {
          "id": "e5d25cf2686f77443e75488d4-5d25e29d86f7740a22516326",
          "source": "5d25cf2686f77443e75488d4",
          "target": "5d25e29d86f7740a22516326",
          "type": "custom"
        },
        {
          "id": "e5d25e29d86f7740a22516326-5d25e2a986f77409dd5cdf2a",
          "source": "5d25e29d86f7740a22516326",
          "target": "5d25e2a986f77409dd5cdf2a",
          "type": "custom"
        },
        {
          "id": "e5bc47dbf86f7741ee74e93b9-5d25e2b486f77409de05bba0",
          "source": "5bc47dbf86f7741ee74e93b9",
          "target": "5d25e2b486f77409de05bba0",
          "type": "custom"
        },
        {
          "id": "e5d25cf2686f77443e75488d4-5d25e2b486f77409de05bba0",
          "source": "5d25cf2686f77443e75488d4",
          "target": "5d25e2b486f77409de05bba0",
          "type": "custom"
        },
        {
          "id": "e5d25e2b486f77409de05bba0-5d25e2c386f77443e7549029",
          "source": "5d25e2b486f77409de05bba0",
          "target": "5d25e2c386f77443e7549029",
          "type": "custom"
        },
        {
          "id": "e5d25e2b486f77409de05bba0-5d25e2cc86f77443e47ae019",
          "source": "5d25e2b486f77409de05bba0",
          "target": "5d25e2cc86f77443e47ae019",
          "type": "custom"
        },
        {
          "id": "e5d25e2cc86f77443e47ae019-5d25e2d886f77442734d335e",
          "source": "5d25e2cc86f77443e47ae019",
          "target": "5d25e2d886f77442734d335e",
          "type": "custom"
        },
        {
          "id": "e5d25e2cc86f77443e47ae019-5d25e2e286f77444001e2e48",
          "source": "5d25e2cc86f77443e47ae019",
          "target": "5d25e2e286f77444001e2e48",
          "type": "custom"
        },
        {
          "id": "e5ae449c386f7744bde357697-5d25e2e286f77444001e2e48",
          "source": "5ae449c386f7744bde357697",
          "target": "5d25e2e286f77444001e2e48",
          "type": "custom"
        },
        {
          "id": "e5d25e2b486f77409de05bba0-5d25e2ee86f77443e35162ea",
          "source": "5d25e2b486f77409de05bba0",
          "target": "5d25e2ee86f77443e35162ea",
          "type": "custom"
        },
        {
          "id": "e596a0e1686f7741ddf17dbee-5d25e2ee86f77443e35162ea",
          "source": "596a0e1686f7741ddf17dbee",
          "target": "5d25e2ee86f77443e35162ea",
          "type": "custom"
        },
        {
          "id": "e5d25e2c386f77443e7549029-5d25e43786f7740a212217fa",
          "source": "5d25e2c386f77443e7549029",
          "target": "5d25e43786f7740a212217fa",
          "type": "custom"
        },
        {
          "id": "e5d25e2cc86f77443e47ae019-5d25e44386f77409453bce7b",
          "source": "5d25e2cc86f77443e47ae019",
          "target": "5d25e44386f77409453bce7b",
          "type": "custom"
        },
        {
          "id": "e608a768d82e40b3c727fd17d-5d25e44f86f77443e625e385",
          "source": "608a768d82e40b3c727fd17d",
          "target": "5d25e44f86f77443e625e385",
          "type": "custom"
        },
        {
          "id": "e5d25e2b486f77409de05bba0-5d25e45e86f77408251c4bfa",
          "source": "5d25e2b486f77409de05bba0",
          "target": "5d25e45e86f77408251c4bfa",
          "type": "custom"
        },
        {
          "id": "e5d25e44f86f77443e625e385-5d25e45e86f77408251c4bfa",
          "source": "5d25e44f86f77443e625e385",
          "target": "5d25e45e86f77408251c4bfa",
          "type": "custom"
        },
        {
          "id": "e5d25e48d86f77408251c4bfb-5d25e46e86f77409453bce7c",
          "source": "5d25e48d86f77408251c4bfb",
          "target": "5d25e46e86f77409453bce7c",
          "type": "custom"
        },
        {
          "id": "e5d25cf2686f77443e75488d4-5d25e48186f77443e625e386",
          "source": "5d25cf2686f77443e75488d4",
          "target": "5d25e48186f77443e625e386",
          "type": "custom"
        },
        {
          "id": "e5d24b81486f77439c92d6ba8-5d25e48d86f77408251c4bfb",
          "source": "5d24b81486f77439c92d6ba8",
          "target": "5d25e48d86f77408251c4bfb",
          "type": "custom"
        },
        {
          "id": "e5979ed3886f77431307dc512-5d25e48d86f77408251c4bfb",
          "source": "5979ed3886f77431307dc512",
          "target": "5d25e48d86f77408251c4bfb",
          "type": "custom"
        },
        {
          "id": "e5d25e48186f77443e625e386-5d25e4ad86f77443e625e387",
          "source": "5d25e48186f77443e625e386",
          "target": "5d25e4ad86f77443e625e387",
          "type": "custom"
        },
        {
          "id": "e5d25e4ad86f77443e625e387-5d25e4b786f77408251c4bfc",
          "source": "5d25e4ad86f77443e625e387",
          "target": "5d25e4b786f77408251c4bfc",
          "type": "custom"
        },
        {
          "id": "e5d25e2ee86f77443e35162ea-5d25e4ca86f77409dd5cdf2c",
          "source": "5d25e2ee86f77443e35162ea",
          "target": "5d25e4ca86f77409dd5cdf2c",
          "type": "custom"
        },
        {
          "id": "e63a88045abf76d719f42d715-5d25e4d586f77443e625e388",
          "source": "63a88045abf76d719f42d715",
          "target": "5d25e4d586f77443e625e388",
          "type": "custom"
        },
        {
          "id": "e5979f8bb86f7743ec214c7a6-5d4bec3486f7743cac246665",
          "source": "5979f8bb86f7743ec214c7a6",
          "target": "5d4bec3486f7743cac246665",
          "type": "custom"
        },
        {
          "id": "e5a68667486f7742607157d28-5d6fb2c086f77449da599c24",
          "source": "5a68667486f7742607157d28",
          "target": "5d6fb2c086f77449da599c24",
          "type": "custom"
        },
        {
          "id": "e5a27bc6986f7741c7358402b-5d6fbc2886f77449d825f9d3",
          "source": "5a27bc6986f7741c7358402b",
          "target": "5d6fbc2886f77449d825f9d3",
          "type": "custom"
        },
        {
          "id": "e5ae4498786f7744bde357695-5dc53acb86f77469c740c893",
          "source": "5ae4498786f7744bde357695",
          "target": "5dc53acb86f77469c740c893",
          "type": "custom"
        },
        {
          "id": "e5d25e2e286f77444001e2e48-5dc53acb86f77469c740c893",
          "source": "5d25e2e286f77444001e2e48",
          "target": "5dc53acb86f77469c740c893",
          "type": "custom"
        },
        {
          "id": "e5ae4497b86f7744cf402ed00-5e381b0286f77420e3417a74",
          "source": "5ae4497b86f7744cf402ed00",
          "target": "5e381b0286f77420e3417a74",
          "type": "custom"
        },
        {
          "id": "e5ae4497b86f7744cf402ed00-5e383a6386f77465910ce1f3",
          "source": "5ae4497b86f7744cf402ed00",
          "target": "5e383a6386f77465910ce1f3",
          "type": "custom"
        },
        {
          "id": "e5e381b0286f77420e3417a74-5e4d4ac186f774264f758336",
          "source": "5e381b0286f77420e3417a74",
          "target": "5e4d4ac186f774264f758336",
          "type": "custom"
        },
        {
          "id": "e5e383a6386f77465910ce1f3-5e4d515e86f77438b2195244",
          "source": "5e383a6386f77465910ce1f3",
          "target": "5e4d515e86f77438b2195244",
          "type": "custom"
        },
        {
          "id": "e5d25e2a986f77409dd5cdf2a-5eaaaa7c93afa0558f3b5a1c",
          "source": "5d25e2a986f77409dd5cdf2a",
          "target": "5eaaaa7c93afa0558f3b5a1c",
          "type": "custom"
        },
        {
          "id": "e5967725e86f774601a446662-5eda19f0edce541157209cee",
          "source": "5967725e86f774601a446662",
          "target": "5eda19f0edce541157209cee",
          "type": "custom"
        },
        {
          "id": "e5edabd13218d181e29451442-5edab4b1218d181e29451435",
          "source": "5edabd13218d181e29451442",
          "target": "5edab4b1218d181e29451435",
          "type": "custom"
        },
        {
          "id": "e5edaba7c0c502106f869bc02-5edab4b1218d181e29451435",
          "source": "5edaba7c0c502106f869bc02",
          "target": "5edab4b1218d181e29451435",
          "type": "custom"
        },
        {
          "id": "e5f04886a3937dc337a6b8238-5edab4b1218d181e29451435",
          "source": "5f04886a3937dc337a6b8238",
          "target": "5edab4b1218d181e29451435",
          "type": "custom"
        },
        {
          "id": "e596a1e6c86f7741ddc2d3206-5edab736cc183c769d778bc2",
          "source": "596a1e6c86f7741ddc2d3206",
          "target": "5edab736cc183c769d778bc2",
          "type": "custom"
        },
        {
          "id": "e5edab736cc183c769d778bc2-5edaba7c0c502106f869bc02",
          "source": "5edab736cc183c769d778bc2",
          "target": "5edaba7c0c502106f869bc02",
          "type": "custom"
        },
        {
          "id": "e5eda19f0edce541157209cee-5edabd13218d181e29451442",
          "source": "5eda19f0edce541157209cee",
          "target": "5edabd13218d181e29451442",
          "type": "custom"
        },
        {
          "id": "e5a27d2af86f7744e1115b323-5edac020218d181e29451446",
          "source": "5a27d2af86f7744e1115b323",
          "target": "5edac020218d181e29451446",
          "type": "custom"
        },
        {
          "id": "e5a27b75b86f7742e97191958-5edac020218d181e29451446",
          "source": "5a27b75b86f7742e97191958",
          "target": "5edac020218d181e29451446",
          "type": "custom"
        },
        {
          "id": "e5eda19f0edce541157209cee-5edac020218d181e29451446",
          "source": "5eda19f0edce541157209cee",
          "target": "5edac020218d181e29451446",
          "type": "custom"
        },
        {
          "id": "e5edab4b1218d181e29451435-5edac34d0bb72a50635c2bfa",
          "source": "5edab4b1218d181e29451435",
          "target": "5edac34d0bb72a50635c2bfa",
          "type": "custom"
        },
        {
          "id": "e5edac020218d181e29451446-5edac63b930f5454f51e128b",
          "source": "5edac020218d181e29451446",
          "target": "5edac63b930f5454f51e128b",
          "type": "custom"
        },
        {
          "id": "e5edac34d0bb72a50635c2bfa-5edac63b930f5454f51e128b",
          "source": "5edac34d0bb72a50635c2bfa",
          "target": "5edac63b930f5454f51e128b",
          "type": "custom"
        },
        {
          "id": "e59c124d686f774189b3c843f-5ede55112c95834b583f052a",
          "source": "59c124d686f774189b3c843f",
          "target": "5ede55112c95834b583f052a",
          "type": "custom"
        },
        {
          "id": "e5ede55112c95834b583f052a-5ede567cfa6dc072ce15d6e3",
          "source": "5ede55112c95834b583f052a",
          "target": "5ede567cfa6dc072ce15d6e3",
          "type": "custom"
        },
        {
          "id": "e5eda19f0edce541157209cee-5f04886a3937dc337a6b8238",
          "source": "5eda19f0edce541157209cee",
          "target": "5f04886a3937dc337a6b8238",
          "type": "custom"
        },
        {
          "id": "e5edab736cc183c769d778bc2-5f04886a3937dc337a6b8238",
          "source": "5edab736cc183c769d778bc2",
          "target": "5f04886a3937dc337a6b8238",
          "type": "custom"
        },
        {
          "id": "e5936d90786f7742b1420ba5b-5fd9fad9c1ce6b1a3b486d00",
          "source": "5936d90786f7742b1420ba5b",
          "target": "5fd9fad9c1ce6b1a3b486d00",
          "type": "custom"
        },
        {
          "id": "e5d25e2ee86f77443e35162ea-600302d73b897b11364cd161",
          "source": "5d25e2ee86f77443e35162ea",
          "target": "600302d73b897b11364cd161",
          "type": "custom"
        },
        {
          "id": "e5a27d2af86f7744e1115b323-6086c852c945025d41566124",
          "source": "5a27d2af86f7744e1115b323",
          "target": "6086c852c945025d41566124",
          "type": "custom"
        },
        {
          "id": "e5a27b87686f77460de0252a8-6086c852c945025d41566124",
          "source": "5a27b87686f77460de0252a8",
          "target": "6086c852c945025d41566124",
          "type": "custom"
        },
        {
          "id": "e6086c852c945025d41566124-60896888e4a85c72ef3fa300",
          "source": "6086c852c945025d41566124",
          "target": "60896888e4a85c72ef3fa300",
          "type": "custom"
        },
        {
          "id": "e60896bca6ee58f38c417d4f2-60896b7bfa70fc097863b8f5",
          "source": "60896bca6ee58f38c417d4f2",
          "target": "60896b7bfa70fc097863b8f5",
          "type": "custom"
        },
        {
          "id": "e5ede567cfa6dc072ce15d6e3-60896bca6ee58f38c417d4f2",
          "source": "5ede567cfa6dc072ce15d6e3",
          "target": "60896bca6ee58f38c417d4f2",
          "type": "custom"
        },
        {
          "id": "e5969f9e986f7741dde183a50-60896e28e4a85c72ef3fa301",
          "source": "5969f9e986f7741dde183a50",
          "target": "60896e28e4a85c72ef3fa301",
          "type": "custom"
        },
        {
          "id": "e6089736efa70fc097863b8f6-6089732b59b92115597ad789",
          "source": "6089736efa70fc097863b8f6",
          "target": "6089732b59b92115597ad789",
          "type": "custom"
        },
        {
          "id": "e5ac3477486f7741d651d6885-6089736efa70fc097863b8f6",
          "source": "5ac3477486f7741d651d6885",
          "target": "6089736efa70fc097863b8f6",
          "type": "custom"
        },
        {
          "id": "e597a0f5686f774273b74f676-6089743983426423753cd58a",
          "source": "597a0f5686f774273b74f676",
          "target": "6089743983426423753cd58a",
          "type": "custom"
        },
        {
          "id": "e608974d01a66564e74191fc0-608974af4b05530f55550c21",
          "source": "608974d01a66564e74191fc0",
          "target": "608974af4b05530f55550c21",
          "type": "custom"
        },
        {
          "id": "e5ae448f286f77448d73c0131-608974d01a66564e74191fc0",
          "source": "5ae448f286f77448d73c0131",
          "target": "608974d01a66564e74191fc0",
          "type": "custom"
        },
        {
          "id": "e5d25e4d586f77443e625e388-608a768d82e40b3c727fd17d",
          "source": "5d25e4d586f77443e625e388",
          "target": "608a768d82e40b3c727fd17d",
          "type": "custom"
        },
        {
          "id": "e5d25e2cc86f77443e47ae019-60c0c018f7afb4354815096a",
          "source": "5d25e2cc86f77443e47ae019",
          "target": "60c0c018f7afb4354815096a",
          "type": "custom"
        },
        {
          "id": "e5ac3477486f7741d651d6885-60c0c018f7afb4354815096a",
          "source": "5ac3477486f7741d651d6885",
          "target": "60c0c018f7afb4354815096a",
          "type": "custom"
        },
        {
          "id": "e59ca2eb686f77445a80ed049-60e71b62a0beca400d69efc4",
          "source": "59ca2eb686f77445a80ed049",
          "target": "60e71b62a0beca400d69efc4",
          "type": "custom"
        },
        {
          "id": "e59ca2eb686f77445a80ed049-60e71b9bbd90872cb85440f3",
          "source": "59ca2eb686f77445a80ed049",
          "target": "60e71b9bbd90872cb85440f3",
          "type": "custom"
        },
        {
          "id": "e59ca2eb686f77445a80ed049-60e71bb4e456d449cd47ca75",
          "source": "59ca2eb686f77445a80ed049",
          "target": "60e71bb4e456d449cd47ca75",
          "type": "custom"
        },
        {
          "id": "e5edabd13218d181e29451442-60e71c11d54b755a3b53eb65",
          "source": "5edabd13218d181e29451442",
          "target": "60e71c11d54b755a3b53eb65",
          "type": "custom"
        },
        {
          "id": "e5c0d0d5086f774363760aef2-60e71c48c1bfa3050473b8e5",
          "source": "5c0d0d5086f774363760aef2",
          "target": "60e71c48c1bfa3050473b8e5",
          "type": "custom"
        },
        {
          "id": "e5c0d4e61d09282029f53920e-60e71c9ad54b755a3b53eb66",
          "source": "5c0d4e61d09282029f53920e",
          "target": "60e71c9ad54b755a3b53eb66",
          "type": "custom"
        },
        {
          "id": "e5d25e2cc86f77443e47ae019-60e71ccb5688f6424c7bfec4",
          "source": "5d25e2cc86f77443e47ae019",
          "target": "60e71ccb5688f6424c7bfec4",
          "type": "custom"
        },
        {
          "id": "e5a27b75b86f7742e97191958-60e71ccb5688f6424c7bfec4",
          "source": "5a27b75b86f7742e97191958",
          "target": "60e71ccb5688f6424c7bfec4",
          "type": "custom"
        },
        {
          "id": "e60e71ccb5688f6424c7bfec4-60e71ce009d7c801eb0c0ec6",
          "source": "60e71ccb5688f6424c7bfec4",
          "target": "60e71ce009d7c801eb0c0ec6",
          "type": "custom"
        },
        {
          "id": "e5f04886a3937dc337a6b8238-60e71d23c1bfa3050473b8e6",
          "source": "5f04886a3937dc337a6b8238",
          "target": "60e71d23c1bfa3050473b8e6",
          "type": "custom"
        },
        {
          "id": "e60e71d23c1bfa3050473b8e6-60e71d6d7fcf9c556f325055",
          "source": "60e71d23c1bfa3050473b8e6",
          "target": "60e71d6d7fcf9c556f325055",
          "type": "custom"
        },
        {
          "id": "e5ae449d986f774453a54a7e1-60e71dc0a94be721b065bbfc",
          "source": "5ae449d986f774453a54a7e1",
          "target": "60e71dc0a94be721b065bbfc",
          "type": "custom"
        },
        {
          "id": "e60e71dc0a94be721b065bbfc-60e71dc67fcf9c556f325056",
          "source": "60e71dc0a94be721b065bbfc",
          "target": "60e71dc67fcf9c556f325056",
          "type": "custom"
        },
        {
          "id": "e5d25e2c386f77443e7549029-60e71e8ed54b755a3b53eb67",
          "source": "5d25e2c386f77443e7549029",
          "target": "60e71e8ed54b755a3b53eb67",
          "type": "custom"
        },
        {
          "id": "e60c0c018f7afb4354815096a-60e71e8ed54b755a3b53eb67",
          "source": "60c0c018f7afb4354815096a",
          "target": "60e71e8ed54b755a3b53eb67",
          "type": "custom"
        },
        {
          "id": "e5d25e2ee86f77443e35162ea-60e71e8ed54b755a3b53eb67",
          "source": "5d25e2ee86f77443e35162ea",
          "target": "60e71e8ed54b755a3b53eb67",
          "type": "custom"
        },
        {
          "id": "e5d25e44f86f77443e625e385-60e71e8ed54b755a3b53eb67",
          "source": "5d25e44f86f77443e625e385",
          "target": "60e71e8ed54b755a3b53eb67",
          "type": "custom"
        },
        {
          "id": "e5edab4b1218d181e29451435-60e71e8ed54b755a3b53eb67",
          "source": "5edab4b1218d181e29451435",
          "target": "60e71e8ed54b755a3b53eb67",
          "type": "custom"
        },
        {
          "id": "e5d25e2e286f77444001e2e48-60e71e8ed54b755a3b53eb67",
          "source": "5d25e2e286f77444001e2e48",
          "target": "60e71e8ed54b755a3b53eb67",
          "type": "custom"
        },
        {
          "id": "e5edab4b1218d181e29451435-60e729cf5698ee7b05057439",
          "source": "5edab4b1218d181e29451435",
          "target": "60e729cf5698ee7b05057439",
          "type": "custom"
        },
        {
          "id": "e59ca2eb686f77445a80ed049-60effd818b669d08a35bfad5",
          "source": "59ca2eb686f77445a80ed049",
          "target": "60effd818b669d08a35bfad5",
          "type": "custom"
        },
        {
          "id": "e59c50c8886f7745fed3193bf-6179ac7511973d018217d0b9",
          "source": "59c50c8886f7745fed3193bf",
          "target": "6179ac7511973d018217d0b9",
          "type": "custom"
        },
        {
          "id": "e6179ac7511973d018217d0b9-6179acbdc760af5ad2053585",
          "source": "6179ac7511973d018217d0b9",
          "target": "6179acbdc760af5ad2053585",
          "type": "custom"
        },
        {
          "id": "e5d25e2cc86f77443e47ae019-6179ad0a6e9dd54ac275e3f2",
          "source": "5d25e2cc86f77443e47ae019",
          "target": "6179ad0a6e9dd54ac275e3f2",
          "type": "custom"
        },
        {
          "id": "e60896e28e4a85c72ef3fa301-6179ad56c760af5ad2053587",
          "source": "60896e28e4a85c72ef3fa301",
          "target": "6179ad56c760af5ad2053587",
          "type": "custom"
        },
        {
          "id": "e5a68663e86f774501078f78a-6179afd0bca27a099552e040",
          "source": "5a68663e86f774501078f78a",
          "target": "6179afd0bca27a099552e040",
          "type": "custom"
        },
        {
          "id": "e5a03153686f77442d90e2171-6179aff8f57fb279792c60a1",
          "source": "5a03153686f77442d90e2171",
          "target": "6179aff8f57fb279792c60a1",
          "type": "custom"
        },
        {
          "id": "e5ac3464c86f7741d651d6877-6179b3a12153c15e937d52bc",
          "source": "5ac3464c86f7741d651d6877",
          "target": "6179b3a12153c15e937d52bc",
          "type": "custom"
        },
        {
          "id": "e5ac3462b86f7741d6118b983-6179b3bdc7560e13d23eeb8d",
          "source": "5ac3462b86f7741d6118b983",
          "target": "6179b3bdc7560e13d23eeb8d",
          "type": "custom"
        },
        {
          "id": "e6086c852c945025d41566124-6179b4d1bca27a099552e04e",
          "source": "6086c852c945025d41566124",
          "target": "6179b4d1bca27a099552e04e",
          "type": "custom"
        },
        {
          "id": "e6193850f60b34236ee0483de-6179b4f16e9dd54ac275e407",
          "source": "6193850f60b34236ee0483de",
          "target": "6179b4f16e9dd54ac275e407",
          "type": "custom"
        },
        {
          "id": "e59ca29fb86f77445ab465c87-6179b5b06e9dd54ac275e409",
          "source": "59ca29fb86f77445ab465c87",
          "target": "6179b5b06e9dd54ac275e409",
          "type": "custom"
        },
        {
          "id": "e5a0327ba86f77456b9154236-6179b5eabca27a099552e052",
          "source": "5a0327ba86f77456b9154236",
          "target": "6179b5eabca27a099552e052",
          "type": "custom"
        },
        {
          "id": "e5d25e48186f77443e625e386-61904daa7d0d857927447b9c",
          "source": "5d25e48186f77443e625e386",
          "target": "61904daa7d0d857927447b9c",
          "type": "custom"
        },
        {
          "id": "e5a27d2af86f7744e1115b323-6193850f60b34236ee0483de",
          "source": "5a27d2af86f7744e1115b323",
          "target": "6193850f60b34236ee0483de",
          "type": "custom"
        },
        {
          "id": "e5a27bb5986f7741dfb660900-61958c366726521dd96828ec",
          "source": "5a27bb5986f7741dfb660900",
          "target": "61958c366726521dd96828ec",
          "type": "custom"
        },
        {
          "id": "e5bc4856986f77454c317bea7-625d6ff5ddc94657c21a1625",
          "source": "5bc4856986f77454c317bea7",
          "target": "625d6ff5ddc94657c21a1625",
          "type": "custom"
        },
        {
          "id": "e5d25e2cc86f77443e47ae019-625d6ff5ddc94657c21a1625",
          "source": "5d25e2cc86f77443e47ae019",
          "target": "625d6ff5ddc94657c21a1625",
          "type": "custom"
        },
        {
          "id": "e61958c366726521dd96828ec-625d6ff5ddc94657c21a1625",
          "source": "61958c366726521dd96828ec",
          "target": "625d6ff5ddc94657c21a1625",
          "type": "custom"
        },
        {
          "id": "e63913715f8e5dd32bf4e3aaa-625d6ff5ddc94657c21a1625",
          "source": "63913715f8e5dd32bf4e3aaa",
          "target": "625d6ff5ddc94657c21a1625",
          "type": "custom"
        },
        {
          "id": "e626bd75b05f287031503c7f6-625d6ff5ddc94657c21a1625",
          "source": "626bd75b05f287031503c7f6",
          "target": "625d6ff5ddc94657c21a1625",
          "type": "custom"
        },
        {
          "id": "e59ca29fb86f77445ab465c87-625d6ff5ddc94657c21a1625",
          "source": "59ca29fb86f77445ab465c87",
          "target": "625d6ff5ddc94657c21a1625",
          "type": "custom"
        },
        {
          "id": "e5ae3280386f7742a41359364-625d6ff5ddc94657c21a1625",
          "source": "5ae3280386f7742a41359364",
          "target": "625d6ff5ddc94657c21a1625",
          "type": "custom"
        },
        {
          "id": "e5c0bbaa886f7746941031d82-625d6ff5ddc94657c21a1625",
          "source": "5c0bbaa886f7746941031d82",
          "target": "625d6ff5ddc94657c21a1625",
          "type": "custom"
        },
        {
          "id": "e5c0d4c12d09282029f539173-625d6ff5ddc94657c21a1625",
          "source": "5c0d4c12d09282029f539173",
          "target": "625d6ff5ddc94657c21a1625",
          "type": "custom"
        },
        {
          "id": "e5c1141f386f77430ff393792-625d6ff5ddc94657c21a1625",
          "source": "5c1141f386f77430ff393792",
          "target": "625d6ff5ddc94657c21a1625",
          "type": "custom"
        },
        {
          "id": "e639135c3744e452011470807-625d6ff5ddc94657c21a1625",
          "source": "639135c3744e452011470807",
          "target": "625d6ff5ddc94657c21a1625",
          "type": "custom"
        },
        {
          "id": "e5c0d1c4cd0928202a02a6f5c-625d6ff5ddc94657c21a1625",
          "source": "5c0d1c4cd0928202a02a6f5c",
          "target": "625d6ff5ddc94657c21a1625",
          "type": "custom"
        },
        {
          "id": "e625d6ff5ddc94657c21a1625-625d6ffaf7308432be1d44c5",
          "source": "625d6ff5ddc94657c21a1625",
          "target": "625d6ffaf7308432be1d44c5",
          "type": "custom"
        },
        {
          "id": "e625d6ffaf7308432be1d44c5-625d6ffcaa168e51321d69d7",
          "source": "625d6ffaf7308432be1d44c5",
          "target": "625d6ffcaa168e51321d69d7",
          "type": "custom"
        },
        {
          "id": "e625d6ffcaa168e51321d69d7-625d6fff4149f1149b5b12c9",
          "source": "625d6ffcaa168e51321d69d7",
          "target": "625d6fff4149f1149b5b12c9",
          "type": "custom"
        },
        {
          "id": "e625d6fff4149f1149b5b12c9-625d7001c4874104f230c0c5",
          "source": "625d6fff4149f1149b5b12c9",
          "target": "625d7001c4874104f230c0c5",
          "type": "custom"
        },
        {
          "id": "e625d7001c4874104f230c0c5-625d70031ed3bb5bcc5bd9e5",
          "source": "625d7001c4874104f230c0c5",
          "target": "625d70031ed3bb5bcc5bd9e5",
          "type": "custom"
        },
        {
          "id": "e625d70031ed3bb5bcc5bd9e5-625d7005a4eb80027c4f2e09",
          "source": "625d70031ed3bb5bcc5bd9e5",
          "target": "625d7005a4eb80027c4f2e09",
          "type": "custom"
        },
        {
          "id": "e625d7005a4eb80027c4f2e09-625d700cc48e6c62a440fab5",
          "source": "625d7005a4eb80027c4f2e09",
          "target": "625d700cc48e6c62a440fab5",
          "type": "custom"
        },
        {
          "id": "e625d7005a4eb80027c4f2e09-626148251ed3bb5bcc5bd9ed",
          "source": "625d7005a4eb80027c4f2e09",
          "target": "626148251ed3bb5bcc5bd9ed",
          "type": "custom"
        },
        {
          "id": "e626148251ed3bb5bcc5bd9ed-6261482fa4eb80027c4f2e11",
          "source": "626148251ed3bb5bcc5bd9ed",
          "target": "6261482fa4eb80027c4f2e11",
          "type": "custom"
        },
        {
          "id": "e6261482fa4eb80027c4f2e11-626148334149f1149b5b12ca",
          "source": "6261482fa4eb80027c4f2e11",
          "target": "626148334149f1149b5b12ca",
          "type": "custom"
        },
        {
          "id": "e626148334149f1149b5b12ca-62614836f7308432be1d44cc",
          "source": "626148334149f1149b5b12ca",
          "target": "62614836f7308432be1d44cc",
          "type": "custom"
        },
        {
          "id": "e6179afd0bca27a099552e040-626bd75b05f287031503c7f6",
          "source": "6179afd0bca27a099552e040",
          "target": "626bd75b05f287031503c7f6",
          "type": "custom"
        },
        {
          "id": "e6179ac7511973d018217d0b9-626bd75c71bd851e971b82a5",
          "source": "6179ac7511973d018217d0b9",
          "target": "626bd75c71bd851e971b82a5",
          "type": "custom"
        },
        {
          "id": "e6179b4f16e9dd54ac275e407-626bd75d5bef5d7d590bd415",
          "source": "6179b4f16e9dd54ac275e407",
          "target": "626bd75d5bef5d7d590bd415",
          "type": "custom"
        },
        {
          "id": "e625d700cc48e6c62a440fab5-626bd75d5bef5d7d590bd415",
          "source": "625d700cc48e6c62a440fab5",
          "target": "626bd75d5bef5d7d590bd415",
          "type": "custom"
        },
        {
          "id": "e5ac3460c86f7742880308185-626bd75e47ea7f506e5493c5",
          "source": "5ac3460c86f7742880308185",
          "target": "626bd75e47ea7f506e5493c5",
          "type": "custom"
        },
        {
          "id": "e5d25e2c386f77443e7549029-626bdcc3a371ee3a7a3514c5",
          "source": "5d25e2c386f77443e7549029",
          "target": "626bdcc3a371ee3a7a3514c5",
          "type": "custom"
        },
        {
          "id": "e5d25e2ee86f77443e35162ea-626bdcc3a371ee3a7a3514c5",
          "source": "5d25e2ee86f77443e35162ea",
          "target": "626bdcc3a371ee3a7a3514c5",
          "type": "custom"
        },
        {
          "id": "e5d25e2e286f77444001e2e48-626bdcc3a371ee3a7a3514c5",
          "source": "5d25e2e286f77444001e2e48",
          "target": "626bdcc3a371ee3a7a3514c5",
          "type": "custom"
        },
        {
          "id": "e5ae448a386f7744d3730fff0-638fcd23dc65553116701d33",
          "source": "5ae448a386f7744d3730fff0",
          "target": "638fcd23dc65553116701d33",
          "type": "custom"
        },
        {
          "id": "e61958c366726521dd96828ec-639135534b15ca31f76bc317",
          "source": "61958c366726521dd96828ec",
          "target": "639135534b15ca31f76bc317",
          "type": "custom"
        },
        {
          "id": "e59675ea386f77414b32bded2-6391359b9444fb141f4e6ee6",
          "source": "59675ea386f77414b32bded2",
          "target": "6391359b9444fb141f4e6ee6",
          "type": "custom"
        },
        {
          "id": "e638fcd23dc65553116701d33-639135a7e705511c8a4a1b78",
          "source": "638fcd23dc65553116701d33",
          "target": "639135a7e705511c8a4a1b78",
          "type": "custom"
        },
        {
          "id": "e6391359b9444fb141f4e6ee6-639135b04ed9512be67647d7",
          "source": "6391359b9444fb141f4e6ee6",
          "target": "639135b04ed9512be67647d7",
          "type": "custom"
        },
        {
          "id": "e639135a7e705511c8a4a1b78-639135bbc115f907b14700a6",
          "source": "639135a7e705511c8a4a1b78",
          "target": "639135bbc115f907b14700a6",
          "type": "custom"
        },
        {
          "id": "e5b478d0f86f7744d190d91b5-639135bbc115f907b14700a6",
          "source": "5b478d0f86f7744d190d91b5",
          "target": "639135bbc115f907b14700a6",
          "type": "custom"
        },
        {
          "id": "e639dbaf17c898a131e1cffff-639135c3744e452011470807",
          "source": "639dbaf17c898a131e1cffff",
          "target": "639135c3744e452011470807",
          "type": "custom"
        },
        {
          "id": "e639135c3744e452011470807-639135cd8ba6894d155e77cb",
          "source": "639135c3744e452011470807",
          "target": "639135cd8ba6894d155e77cb",
          "type": "custom"
        },
        {
          "id": "e5969f9e986f7741dde183a50-639135d89444fb141f4e6eea",
          "source": "5969f9e986f7741dde183a50",
          "target": "639135d89444fb141f4e6eea",
          "type": "custom"
        },
        {
          "id": "e639135d89444fb141f4e6eea-639135e0fa894f0a866afde6",
          "source": "639135d89444fb141f4e6eea",
          "target": "639135e0fa894f0a866afde6",
          "type": "custom"
        },
        {
          "id": "e63913715f8e5dd32bf4e3aaa-639135e8c115f907b14700aa",
          "source": "63913715f8e5dd32bf4e3aaa",
          "target": "639135e8c115f907b14700aa",
          "type": "custom"
        },
        {
          "id": "e6179b3bdc7560e13d23eeb8d-639135e8c115f907b14700aa",
          "source": "6179b3bdc7560e13d23eeb8d",
          "target": "639135e8c115f907b14700aa",
          "type": "custom"
        },
        {
          "id": "e6086c852c945025d41566124-639135f286e646067c176a87",
          "source": "6086c852c945025d41566124",
          "target": "639135f286e646067c176a87",
          "type": "custom"
        },
        {
          "id": "e5a27bafb86f7741c73584017-639136d68ba6894d155e77cf",
          "source": "5a27bafb86f7741c73584017",
          "target": "639136d68ba6894d155e77cf",
          "type": "custom"
        },
        {
          "id": "e5d25e2cc86f77443e47ae019-639136df4b15ca31f76bc31f",
          "source": "5d25e2cc86f77443e47ae019",
          "target": "639136df4b15ca31f76bc31f",
          "type": "custom"
        },
        {
          "id": "e63a88045abf76d719f42d715-639136e84ed9512be67647db",
          "source": "63a88045abf76d719f42d715",
          "target": "639136e84ed9512be67647db",
          "type": "custom"
        },
        {
          "id": "e59ca264786f77445a80ed044-639136f086e646067c176a8b",
          "source": "59ca264786f77445a80ed044",
          "target": "639136f086e646067c176a8b",
          "type": "custom"
        },
        {
          "id": "e63913715f8e5dd32bf4e3aaa-639136fa9444fb141f4e6eee",
          "source": "63913715f8e5dd32bf4e3aaa",
          "target": "639136fa9444fb141f4e6eee",
          "type": "custom"
        },
        {
          "id": "e626bd75e47ea7f506e5493c5-63913715f8e5dd32bf4e3aaa",
          "source": "626bd75e47ea7f506e5493c5",
          "target": "63913715f8e5dd32bf4e3aaa",
          "type": "custom"
        },
        {
          "id": "e63a511ea30d85e10e375b045-6391372c8ba6894d155e77d7",
          "source": "63a511ea30d85e10e375b045",
          "target": "6391372c8ba6894d155e77d7",
          "type": "custom"
        },
        {
          "id": "e6261482fa4eb80027c4f2e11-6391d90f4ed9512be67647df",
          "source": "6261482fa4eb80027c4f2e11",
          "target": "6391d90f4ed9512be67647df",
          "type": "custom"
        },
        {
          "id": "e5a27bafb86f7741c73584017-639282134ed9512be67647ed",
          "source": "5a27bafb86f7741c73584017",
          "target": "639282134ed9512be67647ed",
          "type": "custom"
        },
        {
          "id": "e625d7005a4eb80027c4f2e09-63966faeea19ac7ed845db2c",
          "source": "625d7005a4eb80027c4f2e09",
          "target": "63966faeea19ac7ed845db2c",
          "type": "custom"
        },
        {
          "id": "e63966faeea19ac7ed845db2c-63966fbeea19ac7ed845db2e",
          "source": "63966faeea19ac7ed845db2c",
          "target": "63966fbeea19ac7ed845db2e",
          "type": "custom"
        },
        {
          "id": "e63966fbeea19ac7ed845db2e-63966fccac6f8f3c677b9d89",
          "source": "63966fbeea19ac7ed845db2e",
          "target": "63966fccac6f8f3c677b9d89",
          "type": "custom"
        },
        {
          "id": "e63966fe7ea74a47c2d3fc0e6-63966fd9ea19ac7ed845db30",
          "source": "63966fe7ea74a47c2d3fc0e6",
          "target": "63966fd9ea19ac7ed845db30",
          "type": "custom"
        },
        {
          "id": "e63966fccac6f8f3c677b9d89-63966fe7ea74a47c2d3fc0e6",
          "source": "63966fccac6f8f3c677b9d89",
          "target": "63966fe7ea74a47c2d3fc0e6",
          "type": "custom"
        },
        {
          "id": "e63966fd9ea19ac7ed845db30-63966ff54c3ef01b6f3ffad8",
          "source": "63966fd9ea19ac7ed845db30",
          "target": "63966ff54c3ef01b6f3ffad8",
          "type": "custom"
        },
        {
          "id": "e63966ff54c3ef01b6f3ffad8-639670029113f06a7c3b2377",
          "source": "63966ff54c3ef01b6f3ffad8",
          "target": "639670029113f06a7c3b2377",
          "type": "custom"
        },
        {
          "id": "e639670029113f06a7c3b2377-6396700fea19ac7ed845db32",
          "source": "639670029113f06a7c3b2377",
          "target": "6396700fea19ac7ed845db32",
          "type": "custom"
        },
        {
          "id": "e6396700fea19ac7ed845db32-6396701b9113f06a7c3b2379",
          "source": "6396700fea19ac7ed845db32",
          "target": "6396701b9113f06a7c3b2379",
          "type": "custom"
        },
        {
          "id": "e6396701b9113f06a7c3b2379-63967028c4a91c5cb76abd81",
          "source": "6396701b9113f06a7c3b2379",
          "target": "63967028c4a91c5cb76abd81",
          "type": "custom"
        },
        {
          "id": "e5ac2426c86f774138762edfe-639872f9decada40426d3447",
          "source": "5ac2426c86f774138762edfe",
          "target": "639872f9decada40426d3447",
          "type": "custom"
        },
        {
          "id": "e5ac2428686f77412450b42bf-639872f9decada40426d3447",
          "source": "5ac2428686f77412450b42bf",
          "target": "639872f9decada40426d3447",
          "type": "custom"
        },
        {
          "id": "e5ae3277186f7745973054106-639872fa9b4fb827b200d8e5",
          "source": "5ae3277186f7745973054106",
          "target": "639872fa9b4fb827b200d8e5",
          "type": "custom"
        },
        {
          "id": "e5ae327c886f7745c7b3f2f3f-639872fc93ae507d5858c3a6",
          "source": "5ae327c886f7745c7b3f2f3f",
          "target": "639872fc93ae507d5858c3a6",
          "type": "custom"
        },
        {
          "id": "e5ac244c486f77413e12cf945-639872fe8871e1272b10ccf6",
          "source": "5ac244c486f77413e12cf945",
          "target": "639872fe8871e1272b10ccf6",
          "type": "custom"
        },
        {
          "id": "e5b477b6f86f7747290681823-639873003693c63d86328f25",
          "source": "5b477b6f86f7747290681823",
          "target": "639873003693c63d86328f25",
          "type": "custom"
        },
        {
          "id": "e5b477f7686f7744d1b23c4d2-63987301e11ec11ff5504036",
          "source": "5b477f7686f7744d1b23c4d2",
          "target": "63987301e11ec11ff5504036",
          "type": "custom"
        },
        {
          "id": "e5b4795fb86f7745876267770-639dbaf17c898a131e1cffff",
          "source": "5b4795fb86f7745876267770",
          "target": "639dbaf17c898a131e1cffff",
          "type": "custom"
        },
        {
          "id": "e63913715f8e5dd32bf4e3aaa-63a511ea30d85e10e375b045",
          "source": "63913715f8e5dd32bf4e3aaa",
          "target": "63a511ea30d85e10e375b045",
          "type": "custom"
        },
        {
          "id": "e5c0bd94186f7747a727f09b2-63a5cf262964a7488f5243ce",
          "source": "5c0bd94186f7747a727f09b2",
          "target": "63a5cf262964a7488f5243ce",
          "type": "custom"
        },
        {
          "id": "e5d25b6be86f77444001e1b89-63a88045abf76d719f42d715",
          "source": "5d25b6be86f77444001e1b89",
          "target": "63a88045abf76d719f42d715",
          "type": "custom"
        },
        {
          "id": "e59ca2eb686f77445a80ed049-63a9ae24009ffc6a551631a5",
          "source": "59ca2eb686f77445a80ed049",
          "target": "63a9ae24009ffc6a551631a5",
          "type": "custom"
        },
        {
          "id": "e639136f086e646067c176a8b-63a9ae24009ffc6a551631a5",
          "source": "639136f086e646067c176a8b",
          "target": "63a9ae24009ffc6a551631a5",
          "type": "custom"
        },
        {
          "id": "e5a27bc6986f7741c7358402b-63a9b229813bba58a50c9ee5",
          "source": "5a27bc6986f7741c7358402b",
          "target": "63a9b229813bba58a50c9ee5",
          "type": "custom"
        },
        {
          "id": "e639135f286e646067c176a87-63a9b229813bba58a50c9ee5",
          "source": "639135f286e646067c176a87",
          "target": "63a9b229813bba58a50c9ee5",
          "type": "custom"
        },
        {
          "id": "e639136df4b15ca31f76bc31f-63a9b36cc31b00242d28a99f",
          "source": "639136df4b15ca31f76bc31f",
          "target": "63a9b36cc31b00242d28a99f",
          "type": "custom"
        },
        {
          "id": "e6391372c8ba6894d155e77d7-63a9b36cc31b00242d28a99f",
          "source": "6391372c8ba6894d155e77d7",
          "target": "63a9b36cc31b00242d28a99f",
          "type": "custom"
        },
        {
          "id": "e596a0e1686f7741ddf17dbee-63ab180c87413d64ae0ac20a",
          "source": "596a0e1686f7741ddf17dbee",
          "target": "63ab180c87413d64ae0ac20a",
          "type": "custom"
        },
        {
          "id": "e5d25e2cc86f77443e47ae019-64e7b971f9d6fa49d6769b44",
          "source": "5d25e2cc86f77443e47ae019",
          "target": "64e7b971f9d6fa49d6769b44",
          "type": "custom"
        },
        {
          "id": "e639135e0fa894f0a866afde6-64e7b971f9d6fa49d6769b44",
          "source": "639135e0fa894f0a866afde6",
          "target": "64e7b971f9d6fa49d6769b44",
          "type": "custom"
        },
        {
          "id": "e59ca2eb686f77445a80ed049-64e7b99017ab941a6f7bf9d7",
          "source": "59ca2eb686f77445a80ed049",
          "target": "64e7b99017ab941a6f7bf9d7",
          "type": "custom"
        },
        {
          "id": "e64e7b99017ab941a6f7bf9d7-64e7b9a4aac4cd0a726562cb",
          "source": "64e7b99017ab941a6f7bf9d7",
          "target": "64e7b9a4aac4cd0a726562cb",
          "type": "custom"
        },
        {
          "id": "e639135a7e705511c8a4a1b78-64edbb1317ab941a6f7cc247",
          "source": "639135a7e705511c8a4a1b78",
          "target": "64edbb1317ab941a6f7cc247",
          "type": "custom"
        },
        {
          "id": "e5c112d7e86f7740d6f647486-64edbb1317ab941a6f7cc247",
          "source": "5c112d7e86f7740d6f647486",
          "target": "64edbb1317ab941a6f7cc247",
          "type": "custom"
        },
        {
          "id": "e6391372c8ba6894d155e77d7-64ee99639878a0569d6ec8c9",
          "source": "6391372c8ba6894d155e77d7",
          "target": "64ee99639878a0569d6ec8c9",
          "type": "custom"
        },
        {
          "id": "e5ac346cf86f7741d63233a02-64ee9df4496db64f9b7a4432",
          "source": "5ac346cf86f7741d63233a02",
          "target": "64ee9df4496db64f9b7a4432",
          "type": "custom"
        },
        {
          "id": "e63967028c4a91c5cb76abd81-64f1cc571a5f313cb144bf90",
          "source": "63967028c4a91c5cb76abd81",
          "target": "64f1cc571a5f313cb144bf90",
          "type": "custom"
        },
        {
          "id": "e64f1cc571a5f313cb144bf90-64f1d6e732bed22c3e0c7423",
          "source": "64f1cc571a5f313cb144bf90",
          "target": "64f1d6e732bed22c3e0c7423",
          "type": "custom"
        },
        {
          "id": "e639136e84ed9512be67647db-64f3176921045e77405d63b5",
          "source": "639136e84ed9512be67647db",
          "target": "64f3176921045e77405d63b5",
          "type": "custom"
        },
        {
          "id": "e639135e0fa894f0a866afde6-64f3176921045e77405d63b5",
          "source": "639135e0fa894f0a866afde6",
          "target": "64f3176921045e77405d63b5",
          "type": "custom"
        },
        {
          "id": "e639135b04ed9512be67647d7-64f5aac4b63b74469b6c14c2",
          "source": "639135b04ed9512be67647d7",
          "target": "64f5aac4b63b74469b6c14c2",
          "type": "custom"
        },
        {
          "id": "e63a5cf262964a7488f5243ce-64f5deac39e45b527a7c4232",
          "source": "63a5cf262964a7488f5243ce",
          "target": "64f5deac39e45b527a7c4232",
          "type": "custom"
        },
        {
          "id": "e5b478ff486f7744d184ecbbf-64f5e20652fc01298e2c61e3",
          "source": "5b478ff486f7744d184ecbbf",
          "target": "64f5e20652fc01298e2c61e3",
          "type": "custom"
        },
        {
          "id": "e64f5e20652fc01298e2c61e3-64f6aafd67e11a7c6206e0d0",
          "source": "64f5e20652fc01298e2c61e3",
          "target": "64f6aafd67e11a7c6206e0d0",
          "type": "custom"
        },
        {
          "id": "e639135d89444fb141f4e6eea-64f731ab83cfca080a361e42",
          "source": "639135d89444fb141f4e6eea",
          "target": "64f731ab83cfca080a361e42",
          "type": "custom"
        },
        {
          "id": "e5b47825886f77468074618d3-64f83bb69878a0569d6ecfbe",
          "source": "5b47825886f77468074618d3",
          "target": "64f83bb69878a0569d6ecfbe",
          "type": "custom"
        },
        {
          "id": "e64f83bb69878a0569d6ecfbe-64f83bcdde58fc437700d8fa",
          "source": "64f83bb69878a0569d6ecfbe",
          "target": "64f83bcdde58fc437700d8fa",
          "type": "custom"
        },
        {
          "id": "e64f83bcdde58fc437700d8fa-64f83bd983cfca080a362c82",
          "source": "64f83bcdde58fc437700d8fa",
          "target": "64f83bd983cfca080a362c82",
          "type": "custom"
        }
      ]
    },
    "kappa": {
      "nodes": [
        {
          "id": "5936d90786f7742b1420ba5b",
          "data": {
            "taskName": "Debut",
            "minPlayerLevel": "1",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5936da9e86f7742d65037edf",
              "5fd9fad9c1ce6b1a3b486d00"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5936da9e86f7742d65037edf",
          "data": {
            "taskName": "Background Check",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "59674eb386f774539f14813a"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59674eb386f774539f14813a",
          "data": {
            "taskName": "Delivery from the Past",
            "minPlayerLevel": "5",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "59c124d686f774189b3c843f"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5967530a86f77462ba22226b",
          "data": {
            "taskName": "Bad Rep Evidence",
            "minPlayerLevel": "6",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "59675d6c86f7740a842fc482"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59675d6c86f7740a842fc482",
          "data": {
            "taskName": "Ice Cream Cones",
            "minPlayerLevel": "9",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5967725e86f774601a446662"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5967725e86f774601a446662",
          "data": {
            "taskName": "Shaking up the Teller",
            "minPlayerLevel": "15",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "59c50a9e86f7745fef66f4ff",
              "5c12452c86f7744b83469073",
              "5eda19f0edce541157209cee"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5967733e86f774602332fc84",
          "data": {
            "taskName": "Shortage",
            "minPlayerLevel": "1",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "59689ee586f7740d1570bbd5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59689ee586f7740d1570bbd5",
          "data": {
            "taskName": "Sanitary Standards - Part 1",
            "minPlayerLevel": "4",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "596a204686f774576d4c95de"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5969f90786f77420d2328015",
          "data": {
            "taskName": "Painkiller",
            "minPlayerLevel": "8",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5969f9e986f7741dde183a50"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5969f9e986f7741dde183a50",
          "data": {
            "taskName": "Pharmacist",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "596a0e1686f7741ddf17dbee",
              "596a1e6c86f7741ddc2d3206",
              "596a218586f77420d232807c",
              "5a68661a86f774500f48afb0",
              "60896e28e4a85c72ef3fa301"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "596a0e1686f7741ddf17dbee",
          "data": {
            "taskName": "Supply Plans",
            "minPlayerLevel": "13",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "596a101f86f7741ddb481582",
              "5d25e2ee86f77443e35162ea"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "596a101f86f7741ddb481582",
          "data": {
            "taskName": "Kind of Sabotage",
            "minPlayerLevel": "13",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "596a1e6c86f7741ddc2d3206",
          "data": {
            "taskName": "General Wares",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5edab736cc183c769d778bc2"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "596a204686f774576d4c95de",
          "data": {
            "taskName": "Sanitary Standards - Part 2",
            "minPlayerLevel": "8",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5969f90786f77420d2328015"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "596a218586f77420d232807c",
          "data": {
            "taskName": "Car Repair",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "596b36c586f77450d6045ad2",
          "data": {
            "taskName": "Supplier",
            "minPlayerLevel": "5",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "596b43fb86f77457ca186186",
              "596b455186f77457cb50eccb",
              "5a27c99a86f7747d2c6bdd8e"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "596b43fb86f77457ca186186",
          "data": {
            "taskName": "The Extortionist",
            "minPlayerLevel": "7",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5979ed3886f77431307dc512"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "596b455186f77457cb50eccb",
          "data": {
            "taskName": "Stirrup",
            "minPlayerLevel": "8",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5979ed3886f77431307dc512",
          "data": {
            "taskName": "What’s on the Flash Drive?",
            "minPlayerLevel": "8",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5979eee086f774311955e614",
              "5d25e48d86f77408251c4bfb"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5979eee086f774311955e614",
          "data": {
            "taskName": "Golden Swag",
            "minPlayerLevel": "8",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5979f9ba86f7740f6c3fe9f2"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5979f8bb86f7743ec214c7a6",
          "data": {
            "taskName": "Polikhim Hobo",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5d4bec3486f7743cac246665"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5979f9ba86f7740f6c3fe9f2",
          "data": {
            "taskName": "Chemical - Part 1",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5979f8bb86f7743ec214c7a6",
              "597a0b2986f77426d66c0633"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "597a0b2986f77426d66c0633",
          "data": {
            "taskName": "Chemical - Part 2",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "597a0e5786f77426d66c0636"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "597a0e5786f77426d66c0636",
          "data": {
            "taskName": "Chemical - Part 3",
            "minPlayerLevel": "11",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "597a0f5686f774273b74f676",
              "5b478eca86f7744642012254"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "597a0f5686f774273b74f676",
          "data": {
            "taskName": "Chemical - Part 4",
            "minPlayerLevel": "11",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "597a160786f77477531d39d2",
              "597a171586f77405ba6887d3",
              "6089743983426423753cd58a"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "597a160786f77477531d39d2",
          "data": {
            "taskName": "Out of Curiosity",
            "minPlayerLevel": "11",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "597a171586f77405ba6887d3",
          "data": {
            "taskName": "Big Customer",
            "minPlayerLevel": "11",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59c124d686f774189b3c843f",
          "data": {
            "taskName": "BP Depot",
            "minPlayerLevel": "5",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5967530a86f77462ba22226b",
              "5ede55112c95834b583f052a"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59c50a9e86f7745fef66f4ff",
          "data": {
            "taskName": "The Punisher - Part 1",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "59c50c8886f7745fed3193bf"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59c50c8886f7745fed3193bf",
          "data": {
            "taskName": "The Punisher - Part 2",
            "minPlayerLevel": "18",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "59c512ad86f7741f0d09de9b",
              "6179ac7511973d018217d0b9"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59c512ad86f7741f0d09de9b",
          "data": {
            "taskName": "The Punisher - Part 3",
            "minPlayerLevel": "19",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "59ca264786f77445a80ed044"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59ca264786f77445a80ed044",
          "data": {
            "taskName": "The Punisher - Part 4",
            "minPlayerLevel": "20",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "59ca29fb86f77445ab465c87"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59ca29fb86f77445ab465c87",
          "data": {
            "taskName": "The Punisher - Part 5",
            "minPlayerLevel": "20",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "59ca2eb686f77445a80ed049"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "59ca2eb686f77445a80ed049",
          "data": {
            "taskName": "The Punisher - Part 6",
            "minPlayerLevel": "21",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "60e71bb4e456d449cd47ca75"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a03153686f77442d90e2171",
          "data": {
            "taskName": "Spa Tour - Part 1",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a03173786f77451cb427172",
              "6179aff8f57fb279792c60a1"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a03173786f77451cb427172",
          "data": {
            "taskName": "Spa Tour - Part 2",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a0327ba86f77456b9154236"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a0327ba86f77456b9154236",
          "data": {
            "taskName": "Spa Tour - Part 3",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a03296886f774569778596a"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a03296886f774569778596a",
          "data": {
            "taskName": "Spa Tour - Part 4",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a0449d586f77474e66227b7"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a0449d586f77474e66227b7",
          "data": {
            "taskName": "Spa Tour - Part 5",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27ba9586f7741b543d8e85"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27b75b86f7742e97191958",
          "data": {
            "taskName": "Fishing Gear",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27b7a786f774579c3eb376",
              "5edac020218d181e29451446"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27b7a786f774579c3eb376",
          "data": {
            "taskName": "Tigr Safari",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27b7d686f77460d847e6a6"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27b7d686f77460d847e6a6",
          "data": {
            "taskName": "Scrap Metal",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27b80086f774429a5d7e20"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27b80086f774429a5d7e20",
          "data": {
            "taskName": "Eagle Eye",
            "minPlayerLevel": "11",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27b87686f77460de0252a8"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27b87686f77460de0252a8",
          "data": {
            "taskName": "Humanitarian Supplies",
            "minPlayerLevel": "11",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a03153686f77442d90e2171",
              "5a27b9de86f77464e5044585",
              "6086c852c945025d41566124"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27b9de86f77464e5044585",
          "data": {
            "taskName": "The Cult - Part 1",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27ba1c86f77461ea5a3c56"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27ba1c86f77461ea5a3c56",
          "data": {
            "taskName": "The Cult - Part 2",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27ba9586f7741b543d8e85",
          "data": {
            "taskName": "Spa Tour - Part 6",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27bafb86f7741c73584017"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27bafb86f7741c73584017",
          "data": {
            "taskName": "Spa Tour - Part 7",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27bb1e86f7741f27621b7e",
              "5a27bb8386f7741c770d2d0a"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27bb1e86f7741f27621b7e",
          "data": {
            "taskName": "Cargo X - Part 1",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27bb3d86f77411ea361a21"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27bb3d86f77411ea361a21",
          "data": {
            "taskName": "Cargo X - Part 2",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27bb5986f7741dfb660900"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27bb5986f7741dfb660900",
          "data": {
            "taskName": "Cargo X - Part 3",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "61958c366726521dd96828ec"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27bb8386f7741c770d2d0a",
          "data": {
            "taskName": "Wet Job - Part 1",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27bbf886f774333a418eeb"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27bbf886f774333a418eeb",
          "data": {
            "taskName": "Wet Job - Part 2",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27bc1586f7741f6d40fa2f"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27bc1586f7741f6d40fa2f",
          "data": {
            "taskName": "Wet Job - Part 3",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27bc3686f7741c73584026"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27bc3686f7741c73584026",
          "data": {
            "taskName": "Wet Job - Part 4",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27bc6986f7741c7358402b"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27bc6986f7741c7358402b",
          "data": {
            "taskName": "Wet Job - Part 5",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5a27bc8586f7741b543d8ea4"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27bc8586f7741b543d8ea4",
          "data": {
            "taskName": "Wet Job - Part 6",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5c0be13186f7746f016734aa",
              "5c0d4e61d09282029f53920e"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27c99a86f7747d2c6bdd8e",
          "data": {
            "taskName": "Friend From the West - Part 1",
            "minPlayerLevel": "9",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5a27b75b86f7742e97191958",
              "5a27d2af86f7744e1115b323"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a27d2af86f7744e1115b323",
          "data": {
            "taskName": "Friend From the West - Part 2",
            "minPlayerLevel": "9",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5a03153686f77442d90e2171",
              "5a27b9de86f77464e5044585",
              "5b47926a86f7747ccc057c15",
              "5b4794cb86f774598100d5d4",
              "5edac020218d181e29451446",
              "6086c852c945025d41566124",
              "6193850f60b34236ee0483de"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a68661a86f774500f48afb0",
          "data": {
            "taskName": "Health Care Privacy - Part 1",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5a68663e86f774501078f78a"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a68663e86f774501078f78a",
          "data": {
            "taskName": "Health Care Privacy - Part 2",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5a68665c86f774255929b4c7",
              "6179afd0bca27a099552e040"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a68665c86f774255929b4c7",
          "data": {
            "taskName": "Health Care Privacy - Part 3",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5a68667486f7742607157d28"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a68667486f7742607157d28",
          "data": {
            "taskName": "Health Care Privacy - Part 4",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5a68669a86f774255929b4d4",
              "5c0be5fc86f774467a116593",
              "5c0d0d5086f774363760aef2"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5a68669a86f774255929b4d4",
          "data": {
            "taskName": "Health Care Privacy - Part 5",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5c0d1c4cd0928202a02a6f5c"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac23c6186f7741247042bad",
          "data": {
            "taskName": "Gunsmith - Part 1",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac2426c86f774138762edfe",
              "5ac2428686f77412450b42bf",
              "5ac345dc86f774288030817f",
              "5d2495a886f77425cd51e403"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac2426c86f774138762edfe",
          "data": {
            "taskName": "Gunsmith - Part 2",
            "minPlayerLevel": "5",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac3467986f7741d6224abc2",
              "639872f9decada40426d3447"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac2428686f77412450b42bf",
          "data": {
            "taskName": "Gunsmith - Part 3",
            "minPlayerLevel": "7",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac3479086f7742880308199",
              "639872f9decada40426d3447"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac242ab86f77412464f68b4",
          "data": {
            "taskName": "Gunsmith - Part 16",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5b47749f86f7746c5d6a5fd4"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac244c486f77413e12cf945",
          "data": {
            "taskName": "Gunsmith - Part 13",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "639872fe8871e1272b10ccf6"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac244eb86f7741356335af1",
          "data": {
            "taskName": "Gunsmith - Part 7",
            "minPlayerLevel": "15",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ae3277186f7745973054106"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac345dc86f774288030817f",
          "data": {
            "taskName": "Farming - Part 1",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac3460c86f7742880308185"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac3460c86f7742880308185",
          "data": {
            "taskName": "Farming - Part 2",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac3462b86f7741d6118b983",
              "5ac3475486f7741d6224abd3",
              "626bd75e47ea7f506e5493c5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac3462b86f7741d6118b983",
          "data": {
            "taskName": "Farming - Part 3",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac3464c86f7741d651d6877",
              "5c0bde0986f77479cf22c2f8",
              "6179b3bdc7560e13d23eeb8d"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac3464c86f7741d651d6877",
          "data": {
            "taskName": "Farming - Part 4",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c1128e386f7746565181106",
              "5c139eb686f7747878361a6f",
              "6179b3a12153c15e937d52bc"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac3467986f7741d6224abc2",
          "data": {
            "taskName": "Signal - Part 1",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac346a886f7744e1b083d67",
              "5ac3479086f7742880308199"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac346a886f7744e1b083d67",
          "data": {
            "taskName": "Signal - Part 2",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac346cf86f7741d63233a02",
              "5ac3477486f7741d651d6885"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac346cf86f7741d63233a02",
          "data": {
            "taskName": "Signal - Part 3",
            "minPlayerLevel": "15",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac346e886f7741d6118b99b"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac346e886f7741d6118b99b",
          "data": {
            "taskName": "Signal - Part 4",
            "minPlayerLevel": "15",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac3475486f7741d6224abd3",
          "data": {
            "taskName": "Bad Habit",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac3477486f7741d651d6885",
          "data": {
            "taskName": "Scout",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "6089736efa70fc097863b8f6",
              "60c0c018f7afb4354815096a"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ac3479086f7742880308199",
          "data": {
            "taskName": "Insider",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae3267986f7742a413592fe",
          "data": {
            "taskName": "Gunsmith - Part 5",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ae3270f86f77445ba41d4dd"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae3270f86f77445ba41d4dd",
          "data": {
            "taskName": "Gunsmith - Part 6",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac244eb86f7741356335af1"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae3277186f7745973054106",
          "data": {
            "taskName": "Gunsmith - Part 8",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "639872fa9b4fb827b200d8e5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae327c886f7745c7b3f2f3f",
          "data": {
            "taskName": "Gunsmith - Part 10",
            "minPlayerLevel": "20",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "639872fc93ae507d5858c3a6"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae3280386f7742a41359364",
          "data": {
            "taskName": "Gunsmith - Part 15",
            "minPlayerLevel": "29",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac242ab86f77412464f68b4"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae448a386f7744d3730fff0",
          "data": {
            "taskName": "Only Business",
            "minPlayerLevel": "15",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae448bf86f7744d733e55ee",
              "5ae448e586f7744dcf0c2a67"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae448bf86f7744d733e55ee",
          "data": {
            "taskName": "Make ULTRA Great Again",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae448f286f77448d73c0131",
              "5ae4493486f7744efa289417"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae448e586f7744dcf0c2a67",
          "data": {
            "taskName": "Big Sale",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae448f286f77448d73c0131",
              "5ae4493486f7744efa289417"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae448f286f77448d73c0131",
          "data": {
            "taskName": "The Blood of War - Part 1",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae4490786f7744ca822adcc",
              "5ae4499a86f77449783815db",
              "5b47876e86f7744d1c353205",
              "5b47891f86f7744d1b23c571",
              "608974d01a66564e74191fc0"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae4490786f7744ca822adcc",
          "data": {
            "taskName": "Dressed to Kill",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae449b386f77446d8741719"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae4493486f7744efa289417",
          "data": {
            "taskName": "Database - Part 1",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae4493d86f7744b8e15aa8f"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae4493d86f7744b8e15aa8f",
          "data": {
            "taskName": "Database - Part 2",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae4495086f77443c122bc40",
              "5ae449b386f77446d8741719",
              "5b478d0f86f7744d190d91b5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae4495086f77443c122bc40",
          "data": {
            "taskName": "Sew it Good - Part 1",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae4495c86f7744e87761355",
              "5b47876e86f7744d1c353205"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae4495c86f7744e87761355",
          "data": {
            "taskName": "Sew it Good - Part 2",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae4496986f774459e77beb6",
              "5ae4498786f7744bde357695"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae4496986f774459e77beb6",
          "data": {
            "taskName": "Sew it Good - Part 3",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae4497b86f7744cf402ed00",
              "5b47891f86f7744d1b23c571"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae4497b86f7744cf402ed00",
          "data": {
            "taskName": "Sew it Good - Part 4",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae4499a86f77449783815db"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae4498786f7744bde357695",
          "data": {
            "taskName": "The Key to Success",
            "minPlayerLevel": "26",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae449a586f7744bde357696",
              "5ae449d986f774453a54a7e1"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae4499a86f77449783815db",
          "data": {
            "taskName": "Charisma Brings Success",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae449a586f7744bde357696",
          "data": {
            "taskName": "No Fuss Needed",
            "minPlayerLevel": "26",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae449b386f77446d8741719",
          "data": {
            "taskName": "Gratitude",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae449c386f7744bde357697",
              "5b478b1886f7744d1b23c57d"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae449c386f7744bde357697",
          "data": {
            "taskName": "Sales Night",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5ae449d986f774453a54a7e1",
              "5d25e2e286f77444001e2e48"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ae449d986f774453a54a7e1",
          "data": {
            "taskName": "Supervisor",
            "minPlayerLevel": "40",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b47749f86f7746c5d6a5fd4",
          "data": {
            "taskName": "Gunsmith - Part 17",
            "minPlayerLevel": "31",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5b477b6f86f7747290681823"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b47799d86f7746c5d6a5fd8",
          "data": {
            "taskName": "Gunsmith - Part 12",
            "minPlayerLevel": "23",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ac244c486f77413e12cf945"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b477b6f86f7747290681823",
          "data": {
            "taskName": "Gunsmith - Part 18",
            "minPlayerLevel": "33",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "639873003693c63d86328f25"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b477f7686f7744d1b23c4d2",
          "data": {
            "taskName": "Gunsmith - Part 20",
            "minPlayerLevel": "37",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "63987301e11ec11ff5504036"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b47825886f77468074618d3",
          "data": {
            "taskName": "Gunsmith - Part 22",
            "minPlayerLevel": "39",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b47876e86f7744d1c353205",
          "data": {
            "taskName": "The Blood of War - Part 2",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5c10f94386f774227172c572"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b47891f86f7744d1b23c571",
          "data": {
            "taskName": "Living High is Not a Crime - Part 1",
            "minPlayerLevel": "27",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5c1141f386f77430ff393792"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b478b1886f7744d1b23c57d",
          "data": {
            "taskName": "Hot Delivery",
            "minPlayerLevel": "29",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5c112d7e86f7740d6f647486"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b478d0f86f7744d190d91b5",
          "data": {
            "taskName": "Minibus",
            "minPlayerLevel": "24",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b478eca86f7744642012254",
          "data": {
            "taskName": "Vitamins - Part 1",
            "minPlayerLevel": "22",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5b478ff486f7744d184ecbbf"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b478ff486f7744d184ecbbf",
          "data": {
            "taskName": "Vitamins - Part 2",
            "minPlayerLevel": "22",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b47926a86f7747ccc057c15",
          "data": {
            "taskName": "Informed Means Armed",
            "minPlayerLevel": "24",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5b4795fb86f7745876267770"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b4794cb86f774598100d5d4",
          "data": {
            "taskName": "Lend-Lease - Part 1",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5c0d0f1886f77457b8210226"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5b4795fb86f7745876267770",
          "data": {
            "taskName": "Chumming",
            "minPlayerLevel": "27",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5c0bc91486f7746ab41857a2",
              "5c0bdb5286f774166e38eed4"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5bc4776586f774512d07cf05",
          "data": {
            "taskName": "The Tarkov Shooter - Part 1",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5bc479e586f7747f376c7da3"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5bc479e586f7747f376c7da3",
          "data": {
            "taskName": "The Tarkov Shooter - Part 2",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5bc47dbf86f7741ee74e93b9"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5bc47dbf86f7741ee74e93b9",
          "data": {
            "taskName": "The Tarkov Shooter - Part 3",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5bc480a686f7741af0342e29",
              "5d25e2b486f77409de05bba0"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5bc480a686f7741af0342e29",
          "data": {
            "taskName": "The Tarkov Shooter - Part 4",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5bc4826c86f774106d22d88b"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5bc4826c86f774106d22d88b",
          "data": {
            "taskName": "The Tarkov Shooter - Part 5",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5bc4836986f7740c0152911c"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5bc4836986f7740c0152911c",
          "data": {
            "taskName": "The Tarkov Shooter - Part 6",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5bc4856986f77454c317bea7"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5bc4856986f77454c317bea7",
          "data": {
            "taskName": "The Tarkov Shooter - Part 7",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5bc4893c86f774626f5ebf3e"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5bc4893c86f774626f5ebf3e",
          "data": {
            "taskName": "The Tarkov Shooter - Part 8",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0bbaa886f7746941031d82",
          "data": {
            "taskName": "Bullshit",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5c1234c286f77406fa13baeb"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0bc91486f7746ab41857a2",
          "data": {
            "taskName": "Silent Caliber",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5c0bbaa886f7746941031d82"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0bd01e86f7747cdd799e56",
          "data": {
            "taskName": "Insomnia",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0bd94186f7747a727f09b2",
          "data": {
            "taskName": "Test Drive - Part 1",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0bdb5286f774166e38eed4",
          "data": {
            "taskName": "Flint",
            "minPlayerLevel": "35",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0bde0986f77479cf22c2f8",
          "data": {
            "taskName": "A Shooter Born in Heaven",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0be13186f7746f016734aa",
          "data": {
            "taskName": "Psycho Sniper",
            "minPlayerLevel": "35",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0be5fc86f774467a116593",
          "data": {
            "taskName": "Private Clinic",
            "minPlayerLevel": "35",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5c0d1c4cd0928202a02a6f5c"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0d0d5086f774363760aef2",
          "data": {
            "taskName": "Athlete",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "60e71c48c1bfa3050473b8e5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0d0f1886f77457b8210226",
          "data": {
            "taskName": "Lend-Lease - Part 2",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5c0d4c12d09282029f539173"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0d190cd09282029f5390d8",
          "data": {
            "taskName": "Grenadier",
            "minPlayerLevel": "20",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5c0bd94186f7747a727f09b2"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0d1c4cd0928202a02a6f5c",
          "data": {
            "taskName": "Decontamination Service",
            "minPlayerLevel": "35",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0d4c12d09282029f539173",
          "data": {
            "taskName": "Peacekeeping Mission",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c0d4e61d09282029f53920e",
          "data": {
            "taskName": "The Guide",
            "minPlayerLevel": "40",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c10f94386f774227172c572",
          "data": {
            "taskName": "The Blood of War - Part 3",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5c1141f386f77430ff393792"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c1128e386f7746565181106",
          "data": {
            "taskName": "Fertilizers",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c112d7e86f7740d6f647486",
          "data": {
            "taskName": "Scavenger",
            "minPlayerLevel": "29",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c1141f386f77430ff393792",
          "data": {
            "taskName": "Living High is Not a Crime - Part 2",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c1234c286f77406fa13baeb",
          "data": {
            "taskName": "Setup",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c12452c86f7744b83469073",
          "data": {
            "taskName": "Perfect Mediator",
            "minPlayerLevel": "35",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c139eb686f7747878361a6f",
          "data": {
            "taskName": "Import",
            "minPlayerLevel": "35",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5c51aac186f77432ea65c552",
          "data": {
            "taskName": "Collector",
            "minPlayerLevel": "48",
            "kappaRequired": true,
            "traderName": "Fence",
            "parents": []
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d2495a886f77425cd51e403",
          "data": {
            "taskName": "Introduction",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5d24b81486f77439c92d6ba8"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d24b81486f77439c92d6ba8",
          "data": {
            "taskName": "Acquaintance",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5bc4776586f774512d07cf05",
              "5d25aed386f77442734d25d2",
              "5d25e48d86f77408251c4bfb"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25aed386f77442734d25d2",
          "data": {
            "taskName": "The Survivalist Path - Unprotected but Dangerous",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25b6be86f77444001e1b89"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25b6be86f77444001e1b89",
          "data": {
            "taskName": "The Survivalist Path - Thrifty",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25bfd086f77442734d3007",
              "63a88045abf76d719f42d715"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25bfd086f77442734d3007",
          "data": {
            "taskName": "The Survivalist Path - Zhivchik",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25c81b86f77443e625dd71"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25c81b86f77443e625dd71",
          "data": {
            "taskName": "The Survivalist Path - Wounded Beast",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25cf2686f77443e75488d4"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25cf2686f77443e75488d4",
          "data": {
            "taskName": "The Survivalist Path - Tough Guy",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e29d86f7740a22516326",
              "5d25e2b486f77409de05bba0",
              "5d25e48186f77443e625e386"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e29d86f7740a22516326",
          "data": {
            "taskName": "The Survivalist Path - Eagle-Owl",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e2a986f77409dd5cdf2a"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e2a986f77409dd5cdf2a",
          "data": {
            "taskName": "The Survivalist Path - Combat Medic",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5eaaaa7c93afa0558f3b5a1c"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e2b486f77409de05bba0",
          "data": {
            "taskName": "The Huntsman Path - Secured Perimeter",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e2c386f77443e7549029",
              "5d25e2cc86f77443e47ae019",
              "5d25e2ee86f77443e35162ea",
              "5d25e45e86f77408251c4bfa"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e2c386f77443e7549029",
          "data": {
            "taskName": "The Huntsman Path - Trophy",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e43786f7740a212217fa",
              "626bdcc3a371ee3a7a3514c5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e2cc86f77443e47ae019",
          "data": {
            "taskName": "The Huntsman Path - Forest Cleaning",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e2d886f77442734d335e",
              "5d25e2e286f77444001e2e48",
              "5d25e44386f77409453bce7b",
              "60c0c018f7afb4354815096a",
              "6179ad0a6e9dd54ac275e3f2"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e2d886f77442734d335e",
          "data": {
            "taskName": "The Huntsman Path - Controller",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e2e286f77444001e2e48",
          "data": {
            "taskName": "The Huntsman Path - Sellout",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "626bdcc3a371ee3a7a3514c5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e2ee86f77443e35162ea",
          "data": {
            "taskName": "The Huntsman Path - Woods Keeper",
            "minPlayerLevel": "13",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e4ca86f77409dd5cdf2c",
              "626bdcc3a371ee3a7a3514c5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e43786f7740a212217fa",
          "data": {
            "taskName": "The Huntsman Path - Justice",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e44386f77409453bce7b",
          "data": {
            "taskName": "The Huntsman Path - Evil Watchman",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e44f86f77443e625e385",
          "data": {
            "taskName": "The Huntsman Path - Eraser - Part 1",
            "minPlayerLevel": "20",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e45e86f77408251c4bfa"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e45e86f77408251c4bfa",
          "data": {
            "taskName": "The Huntsman Path - Eraser - Part 2",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e46e86f77409453bce7c",
          "data": {
            "taskName": "Ambulance",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e48186f77443e625e386",
          "data": {
            "taskName": "Courtesy Visit",
            "minPlayerLevel": "20",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e4ad86f77443e625e387",
              "61904daa7d0d857927447b9c"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e48d86f77408251c4bfb",
          "data": {
            "taskName": "Shady Business",
            "minPlayerLevel": "20",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e46e86f77409453bce7c"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e4ad86f77443e625e387",
          "data": {
            "taskName": "Nostalgia",
            "minPlayerLevel": "28",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e4b786f77408251c4bfc"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e4b786f77408251c4bfc",
          "data": {
            "taskName": "Fishing Place",
            "minPlayerLevel": "28",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e4ca86f77409dd5cdf2c",
          "data": {
            "taskName": "Hunting Trip",
            "minPlayerLevel": "33",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d25e4d586f77443e625e388",
          "data": {
            "taskName": "Reserve",
            "minPlayerLevel": "20",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "608a768d82e40b3c727fd17d"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5d4bec3486f7743cac246665",
          "data": {
            "taskName": "Regulated Materials",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5eaaaa7c93afa0558f3b5a1c",
          "data": {
            "taskName": "The Survivalist Path - Junkie",
            "minPlayerLevel": "2",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5eda19f0edce541157209cee",
          "data": {
            "taskName": "Anesthesia",
            "minPlayerLevel": "21",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5edabd13218d181e29451442",
              "5edac020218d181e29451446",
              "5f04886a3937dc337a6b8238"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5edab4b1218d181e29451435",
          "data": {
            "taskName": "The Huntsman Path - Sadist",
            "minPlayerLevel": "22",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5edac34d0bb72a50635c2bfa"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5edab736cc183c769d778bc2",
          "data": {
            "taskName": "Colleagues - Part 1",
            "minPlayerLevel": "21",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5edaba7c0c502106f869bc02",
              "5f04886a3937dc337a6b8238"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5edaba7c0c502106f869bc02",
          "data": {
            "taskName": "Colleagues - Part 2",
            "minPlayerLevel": "21",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5edab4b1218d181e29451435"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5edabd13218d181e29451442",
          "data": {
            "taskName": "Rigged Game",
            "minPlayerLevel": "21",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5edab4b1218d181e29451435"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5edac020218d181e29451446",
          "data": {
            "taskName": "Samples",
            "minPlayerLevel": "21",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5edac63b930f5454f51e128b"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5edac34d0bb72a50635c2bfa",
          "data": {
            "taskName": "Colleagues - Part 3",
            "minPlayerLevel": "22",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5edac63b930f5454f51e128b"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5edac63b930f5454f51e128b",
          "data": {
            "taskName": "TerraGroup Employee",
            "minPlayerLevel": "23",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ede55112c95834b583f052a",
          "data": {
            "taskName": "The Bunker - Part 1",
            "minPlayerLevel": "10",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5ede567cfa6dc072ce15d6e3"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5ede567cfa6dc072ce15d6e3",
          "data": {
            "taskName": "The Bunker - Part 2",
            "minPlayerLevel": "11",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "60896bca6ee58f38c417d4f2"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5f04886a3937dc337a6b8238",
          "data": {
            "taskName": "Chemistry Closet",
            "minPlayerLevel": "22",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5edab4b1218d181e29451435"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "5fd9fad9c1ce6b1a3b486d00",
          "data": {
            "taskName": "Search Mission",
            "minPlayerLevel": "5",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6086c852c945025d41566124",
          "data": {
            "taskName": "Revision - Reserve",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "60896888e4a85c72ef3fa300",
              "6179b4d1bca27a099552e04e"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60896888e4a85c72ef3fa300",
          "data": {
            "taskName": "Classified Technologies",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60896b7bfa70fc097863b8f5",
          "data": {
            "taskName": "Documents",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60896bca6ee58f38c417d4f2",
          "data": {
            "taskName": "No Place for Renegades",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "60896b7bfa70fc097863b8f5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60896e28e4a85c72ef3fa301",
          "data": {
            "taskName": "Disease History",
            "minPlayerLevel": "15",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "6179ad56c760af5ad2053587"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6089732b59b92115597ad789",
          "data": {
            "taskName": "Surplus Goods",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6089736efa70fc097863b8f6",
          "data": {
            "taskName": "Back Door",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "6089732b59b92115597ad789"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6089743983426423753cd58a",
          "data": {
            "taskName": "Safe Corridor",
            "minPlayerLevel": "15",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "608974af4b05530f55550c21",
          "data": {
            "taskName": "Inventory Check",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "608974d01a66564e74191fc0",
          "data": {
            "taskName": "A Fuel Matter",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Ragman",
            "parents": [
              "608974af4b05530f55550c21"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "608a768d82e40b3c727fd17d",
          "data": {
            "taskName": "Pest Control",
            "minPlayerLevel": "20",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e44f86f77443e625e385"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60c0c018f7afb4354815096a",
          "data": {
            "taskName": "The Huntsman Path - Factory Chief",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60e71bb4e456d449cd47ca75",
          "data": {
            "taskName": "Intimidator",
            "minPlayerLevel": "45",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "60e71c48c1bfa3050473b8e5",
          "data": {
            "taskName": "Crisis",
            "minPlayerLevel": "48",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6179ac7511973d018217d0b9",
          "data": {
            "taskName": "Easy Job - Part 1",
            "minPlayerLevel": "18",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "6179acbdc760af5ad2053585",
              "626bd75c71bd851e971b82a5"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6179acbdc760af5ad2053585",
          "data": {
            "taskName": "Easy Job - Part 2",
            "minPlayerLevel": "18",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6179ad0a6e9dd54ac275e3f2",
          "data": {
            "taskName": "The Huntsman Path - Outcasts",
            "minPlayerLevel": "22",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6179ad56c760af5ad2053587",
          "data": {
            "taskName": "Seaside Vacation",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6179afd0bca27a099552e040",
          "data": {
            "taskName": "Lost Contact",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "626bd75b05f287031503c7f6"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6179aff8f57fb279792c60a1",
          "data": {
            "taskName": "Overpopulation",
            "minPlayerLevel": "15",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6179b3a12153c15e937d52bc",
          "data": {
            "taskName": "Energy Crisis",
            "minPlayerLevel": "25",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6179b3bdc7560e13d23eeb8d",
          "data": {
            "taskName": "Corporate Secrets",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6179b4d1bca27a099552e04e",
          "data": {
            "taskName": "Revision - Lighthouse",
            "minPlayerLevel": "14",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6179b4f16e9dd54ac275e407",
          "data": {
            "taskName": "Missing Cargo",
            "minPlayerLevel": "30",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "61904daa7d0d857927447b9c",
          "data": {
            "taskName": "The Hermit",
            "minPlayerLevel": "20",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "6193850f60b34236ee0483de",
          "data": {
            "taskName": "Long Road",
            "minPlayerLevel": "20",
            "kappaRequired": true,
            "traderName": "Skier",
            "parents": [
              "6179b4f16e9dd54ac275e407"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "61958c366726521dd96828ec",
          "data": {
            "taskName": "Cargo X - Part 4",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Peacekeeper",
            "parents": [
              "5c0bd01e86f7747cdd799e56"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "626bd75b05f287031503c7f6",
          "data": {
            "taskName": "Drug Trafficking",
            "minPlayerLevel": "17",
            "kappaRequired": true,
            "traderName": "Therapist",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "626bd75c71bd851e971b82a5",
          "data": {
            "taskName": "Reconnaissance",
            "minPlayerLevel": "18",
            "kappaRequired": true,
            "traderName": "Prapor",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "626bd75e47ea7f506e5493c5",
          "data": {
            "taskName": "Broadcast - Part 1",
            "minPlayerLevel": "12",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "626bdcc3a371ee3a7a3514c5",
          "data": {
            "taskName": "Stray Dogs",
            "minPlayerLevel": "35",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5c51aac186f77432ea65c552"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639872f9decada40426d3447",
          "data": {
            "taskName": "Gunsmith - Part 4",
            "minPlayerLevel": "9",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ae3267986f7742a413592fe"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639872fa9b4fb827b200d8e5",
          "data": {
            "taskName": "Gunsmith - Part 9",
            "minPlayerLevel": "19",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ae327c886f7745c7b3f2f3f"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639872fc93ae507d5858c3a6",
          "data": {
            "taskName": "Gunsmith - Part 11",
            "minPlayerLevel": "22",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5b47799d86f7746c5d6a5fd8"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639872fe8871e1272b10ccf6",
          "data": {
            "taskName": "Gunsmith - Part 14",
            "minPlayerLevel": "27",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5ae3280386f7742a41359364"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "639873003693c63d86328f25",
          "data": {
            "taskName": "Gunsmith - Part 19",
            "minPlayerLevel": "36",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5b477f7686f7744d1b23c4d2"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "63987301e11ec11ff5504036",
          "data": {
            "taskName": "Gunsmith - Part 21",
            "minPlayerLevel": "38",
            "kappaRequired": true,
            "traderName": "Mechanic",
            "parents": [
              "5b47825886f77468074618d3"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        },
        {
          "id": "63a88045abf76d719f42d715",
          "data": {
            "taskName": "The Delicious Sausage",
            "minPlayerLevel": "5",
            "kappaRequired": true,
            "traderName": "Jaeger",
            "parents": [
              "5d25e4d586f77443e625e388"
            ]
          },
          "type": "custom",
          "position": {
            "x": 0,
            "y": 0
          }
        }
      ],
      "edges": [
        {
          "id": "e5936d90786f7742b1420ba5b-5936da9e86f7742d65037edf",
          "source": "5936d90786f7742b1420ba5b",
          "target": "5936da9e86f7742d65037edf",
          "type": "custom"
        },
        {
          "id": "e5936da9e86f7742d65037edf-59674eb386f774539f14813a",
          "source": "5936da9e86f7742d65037edf",
          "target": "59674eb386f774539f14813a",
          "type": "custom"
        },
        {
          "id": "e59c124d686f774189b3c843f-5967530a86f77462ba22226b",
          "source": "59c124d686f774189b3c843f",
          "target": "5967530a86f77462ba22226b",
          "type": "custom"
        },
        {
          "id": "e5967530a86f77462ba22226b-59675d6c86f7740a842fc482",
          "source": "5967530a86f77462ba22226b",
          "target": "59675d6c86f7740a842fc482",
          "type": "custom"
        },
        {
          "id": "e59675d6c86f7740a842fc482-5967725e86f774601a446662",
          "source": "59675d6c86f7740a842fc482",
          "target": "5967725e86f774601a446662",
          "type": "custom"
        },
        {
          "id": "e5967733e86f774602332fc84-59689ee586f7740d1570bbd5",
          "source": "5967733e86f774602332fc84",
          "target": "59689ee586f7740d1570bbd5",
          "type": "custom"
        },
        {
          "id": "e596a204686f774576d4c95de-5969f90786f77420d2328015",
          "source": "596a204686f774576d4c95de",
          "target": "5969f90786f77420d2328015",
          "type": "custom"
        },
        {
          "id": "e5969f90786f77420d2328015-5969f9e986f7741dde183a50",
          "source": "5969f90786f77420d2328015",
          "target": "5969f9e986f7741dde183a50",
          "type": "custom"
        },
        {
          "id": "e5969f9e986f7741dde183a50-596a0e1686f7741ddf17dbee",
          "source": "5969f9e986f7741dde183a50",
          "target": "596a0e1686f7741ddf17dbee",
          "type": "custom"
        },
        {
          "id": "e596a0e1686f7741ddf17dbee-596a101f86f7741ddb481582",
          "source": "596a0e1686f7741ddf17dbee",
          "target": "596a101f86f7741ddb481582",
          "type": "custom"
        },
        {
          "id": "e5969f9e986f7741dde183a50-596a1e6c86f7741ddc2d3206",
          "source": "5969f9e986f7741dde183a50",
          "target": "596a1e6c86f7741ddc2d3206",
          "type": "custom"
        },
        {
          "id": "e59689ee586f7740d1570bbd5-596a204686f774576d4c95de",
          "source": "59689ee586f7740d1570bbd5",
          "target": "596a204686f774576d4c95de",
          "type": "custom"
        },
        {
          "id": "e5969f9e986f7741dde183a50-596a218586f77420d232807c",
          "source": "5969f9e986f7741dde183a50",
          "target": "596a218586f77420d232807c",
          "type": "custom"
        },
        {
          "id": "e596b36c586f77450d6045ad2-596b43fb86f77457ca186186",
          "source": "596b36c586f77450d6045ad2",
          "target": "596b43fb86f77457ca186186",
          "type": "custom"
        },
        {
          "id": "e596b36c586f77450d6045ad2-596b455186f77457cb50eccb",
          "source": "596b36c586f77450d6045ad2",
          "target": "596b455186f77457cb50eccb",
          "type": "custom"
        },
        {
          "id": "e596b43fb86f77457ca186186-5979ed3886f77431307dc512",
          "source": "596b43fb86f77457ca186186",
          "target": "5979ed3886f77431307dc512",
          "type": "custom"
        },
        {
          "id": "e5979ed3886f77431307dc512-5979eee086f774311955e614",
          "source": "5979ed3886f77431307dc512",
          "target": "5979eee086f774311955e614",
          "type": "custom"
        },
        {
          "id": "e5979f9ba86f7740f6c3fe9f2-5979f8bb86f7743ec214c7a6",
          "source": "5979f9ba86f7740f6c3fe9f2",
          "target": "5979f8bb86f7743ec214c7a6",
          "type": "custom"
        },
        {
          "id": "e5979eee086f774311955e614-5979f9ba86f7740f6c3fe9f2",
          "source": "5979eee086f774311955e614",
          "target": "5979f9ba86f7740f6c3fe9f2",
          "type": "custom"
        },
        {
          "id": "e5979f9ba86f7740f6c3fe9f2-597a0b2986f77426d66c0633",
          "source": "5979f9ba86f7740f6c3fe9f2",
          "target": "597a0b2986f77426d66c0633",
          "type": "custom"
        },
        {
          "id": "e597a0b2986f77426d66c0633-597a0e5786f77426d66c0636",
          "source": "597a0b2986f77426d66c0633",
          "target": "597a0e5786f77426d66c0636",
          "type": "custom"
        },
        {
          "id": "e597a0e5786f77426d66c0636-597a0f5686f774273b74f676",
          "source": "597a0e5786f77426d66c0636",
          "target": "597a0f5686f774273b74f676",
          "type": "custom"
        },
        {
          "id": "e597a0f5686f774273b74f676-597a160786f77477531d39d2",
          "source": "597a0f5686f774273b74f676",
          "target": "597a160786f77477531d39d2",
          "type": "custom"
        },
        {
          "id": "e597a0f5686f774273b74f676-597a171586f77405ba6887d3",
          "source": "597a0f5686f774273b74f676",
          "target": "597a171586f77405ba6887d3",
          "type": "custom"
        },
        {
          "id": "e59674eb386f774539f14813a-59c124d686f774189b3c843f",
          "source": "59674eb386f774539f14813a",
          "target": "59c124d686f774189b3c843f",
          "type": "custom"
        },
        {
          "id": "e5967725e86f774601a446662-59c50a9e86f7745fef66f4ff",
          "source": "5967725e86f774601a446662",
          "target": "59c50a9e86f7745fef66f4ff",
          "type": "custom"
        },
        {
          "id": "e59c50a9e86f7745fef66f4ff-59c50c8886f7745fed3193bf",
          "source": "59c50a9e86f7745fef66f4ff",
          "target": "59c50c8886f7745fed3193bf",
          "type": "custom"
        },
        {
          "id": "e59c50c8886f7745fed3193bf-59c512ad86f7741f0d09de9b",
          "source": "59c50c8886f7745fed3193bf",
          "target": "59c512ad86f7741f0d09de9b",
          "type": "custom"
        },
        {
          "id": "e59c512ad86f7741f0d09de9b-59ca264786f77445a80ed044",
          "source": "59c512ad86f7741f0d09de9b",
          "target": "59ca264786f77445a80ed044",
          "type": "custom"
        },
        {
          "id": "e59ca264786f77445a80ed044-59ca29fb86f77445ab465c87",
          "source": "59ca264786f77445a80ed044",
          "target": "59ca29fb86f77445ab465c87",
          "type": "custom"
        },
        {
          "id": "e59ca29fb86f77445ab465c87-59ca2eb686f77445a80ed049",
          "source": "59ca29fb86f77445ab465c87",
          "target": "59ca2eb686f77445a80ed049",
          "type": "custom"
        },
        {
          "id": "e5a27d2af86f7744e1115b323-5a03153686f77442d90e2171",
          "source": "5a27d2af86f7744e1115b323",
          "target": "5a03153686f77442d90e2171",
          "type": "custom"
        },
        {
          "id": "e5a27b87686f77460de0252a8-5a03153686f77442d90e2171",
          "source": "5a27b87686f77460de0252a8",
          "target": "5a03153686f77442d90e2171",
          "type": "custom"
        },
        {
          "id": "e5a03153686f77442d90e2171-5a03173786f77451cb427172",
          "source": "5a03153686f77442d90e2171",
          "target": "5a03173786f77451cb427172",
          "type": "custom"
        },
        {
          "id": "e5a03173786f77451cb427172-5a0327ba86f77456b9154236",
          "source": "5a03173786f77451cb427172",
          "target": "5a0327ba86f77456b9154236",
          "type": "custom"
        },
        {
          "id": "e5a0327ba86f77456b9154236-5a03296886f774569778596a",
          "source": "5a0327ba86f77456b9154236",
          "target": "5a03296886f774569778596a",
          "type": "custom"
        },
        {
          "id": "e5a03296886f774569778596a-5a0449d586f77474e66227b7",
          "source": "5a03296886f774569778596a",
          "target": "5a0449d586f77474e66227b7",
          "type": "custom"
        },
        {
          "id": "e5a27c99a86f7747d2c6bdd8e-5a27b75b86f7742e97191958",
          "source": "5a27c99a86f7747d2c6bdd8e",
          "target": "5a27b75b86f7742e97191958",
          "type": "custom"
        },
        {
          "id": "e5a27b75b86f7742e97191958-5a27b7a786f774579c3eb376",
          "source": "5a27b75b86f7742e97191958",
          "target": "5a27b7a786f774579c3eb376",
          "type": "custom"
        },
        {
          "id": "e5a27b7a786f774579c3eb376-5a27b7d686f77460d847e6a6",
          "source": "5a27b7a786f774579c3eb376",
          "target": "5a27b7d686f77460d847e6a6",
          "type": "custom"
        },
        {
          "id": "e5a27b7d686f77460d847e6a6-5a27b80086f774429a5d7e20",
          "source": "5a27b7d686f77460d847e6a6",
          "target": "5a27b80086f774429a5d7e20",
          "type": "custom"
        },
        {
          "id": "e5a27b80086f774429a5d7e20-5a27b87686f77460de0252a8",
          "source": "5a27b80086f774429a5d7e20",
          "target": "5a27b87686f77460de0252a8",
          "type": "custom"
        },
        {
          "id": "e5a27d2af86f7744e1115b323-5a27b9de86f77464e5044585",
          "source": "5a27d2af86f7744e1115b323",
          "target": "5a27b9de86f77464e5044585",
          "type": "custom"
        },
        {
          "id": "e5a27b87686f77460de0252a8-5a27b9de86f77464e5044585",
          "source": "5a27b87686f77460de0252a8",
          "target": "5a27b9de86f77464e5044585",
          "type": "custom"
        },
        {
          "id": "e5a27b9de86f77464e5044585-5a27ba1c86f77461ea5a3c56",
          "source": "5a27b9de86f77464e5044585",
          "target": "5a27ba1c86f77461ea5a3c56",
          "type": "custom"
        },
        {
          "id": "e5a0449d586f77474e66227b7-5a27ba9586f7741b543d8e85",
          "source": "5a0449d586f77474e66227b7",
          "target": "5a27ba9586f7741b543d8e85",
          "type": "custom"
        },
        {
          "id": "e5a27ba9586f7741b543d8e85-5a27bafb86f7741c73584017",
          "source": "5a27ba9586f7741b543d8e85",
          "target": "5a27bafb86f7741c73584017",
          "type": "custom"
        },
        {
          "id": "e5a27bafb86f7741c73584017-5a27bb1e86f7741f27621b7e",
          "source": "5a27bafb86f7741c73584017",
          "target": "5a27bb1e86f7741f27621b7e",
          "type": "custom"
        },
        {
          "id": "e5a27bb1e86f7741f27621b7e-5a27bb3d86f77411ea361a21",
          "source": "5a27bb1e86f7741f27621b7e",
          "target": "5a27bb3d86f77411ea361a21",
          "type": "custom"
        },
        {
          "id": "e5a27bb3d86f77411ea361a21-5a27bb5986f7741dfb660900",
          "source": "5a27bb3d86f77411ea361a21",
          "target": "5a27bb5986f7741dfb660900",
          "type": "custom"
        },
        {
          "id": "e5a27bafb86f7741c73584017-5a27bb8386f7741c770d2d0a",
          "source": "5a27bafb86f7741c73584017",
          "target": "5a27bb8386f7741c770d2d0a",
          "type": "custom"
        },
        {
          "id": "e5a27bb8386f7741c770d2d0a-5a27bbf886f774333a418eeb",
          "source": "5a27bb8386f7741c770d2d0a",
          "target": "5a27bbf886f774333a418eeb",
          "type": "custom"
        },
        {
          "id": "e5a27bbf886f774333a418eeb-5a27bc1586f7741f6d40fa2f",
          "source": "5a27bbf886f774333a418eeb",
          "target": "5a27bc1586f7741f6d40fa2f",
          "type": "custom"
        },
        {
          "id": "e5a27bc1586f7741f6d40fa2f-5a27bc3686f7741c73584026",
          "source": "5a27bc1586f7741f6d40fa2f",
          "target": "5a27bc3686f7741c73584026",
          "type": "custom"
        },
        {
          "id": "e5a27bc3686f7741c73584026-5a27bc6986f7741c7358402b",
          "source": "5a27bc3686f7741c73584026",
          "target": "5a27bc6986f7741c7358402b",
          "type": "custom"
        },
        {
          "id": "e5a27bc6986f7741c7358402b-5a27bc8586f7741b543d8ea4",
          "source": "5a27bc6986f7741c7358402b",
          "target": "5a27bc8586f7741b543d8ea4",
          "type": "custom"
        },
        {
          "id": "e596b36c586f77450d6045ad2-5a27c99a86f7747d2c6bdd8e",
          "source": "596b36c586f77450d6045ad2",
          "target": "5a27c99a86f7747d2c6bdd8e",
          "type": "custom"
        },
        {
          "id": "e5a27c99a86f7747d2c6bdd8e-5a27d2af86f7744e1115b323",
          "source": "5a27c99a86f7747d2c6bdd8e",
          "target": "5a27d2af86f7744e1115b323",
          "type": "custom"
        },
        {
          "id": "e5969f9e986f7741dde183a50-5a68661a86f774500f48afb0",
          "source": "5969f9e986f7741dde183a50",
          "target": "5a68661a86f774500f48afb0",
          "type": "custom"
        },
        {
          "id": "e5a68661a86f774500f48afb0-5a68663e86f774501078f78a",
          "source": "5a68661a86f774500f48afb0",
          "target": "5a68663e86f774501078f78a",
          "type": "custom"
        },
        {
          "id": "e5a68663e86f774501078f78a-5a68665c86f774255929b4c7",
          "source": "5a68663e86f774501078f78a",
          "target": "5a68665c86f774255929b4c7",
          "type": "custom"
        },
        {
          "id": "e5a68665c86f774255929b4c7-5a68667486f7742607157d28",
          "source": "5a68665c86f774255929b4c7",
          "target": "5a68667486f7742607157d28",
          "type": "custom"
        },
        {
          "id": "e5a68667486f7742607157d28-5a68669a86f774255929b4d4",
          "source": "5a68667486f7742607157d28",
          "target": "5a68669a86f774255929b4d4",
          "type": "custom"
        },
        {
          "id": "e5ac23c6186f7741247042bad-5ac2426c86f774138762edfe",
          "source": "5ac23c6186f7741247042bad",
          "target": "5ac2426c86f774138762edfe",
          "type": "custom"
        },
        {
          "id": "e5ac23c6186f7741247042bad-5ac2428686f77412450b42bf",
          "source": "5ac23c6186f7741247042bad",
          "target": "5ac2428686f77412450b42bf",
          "type": "custom"
        },
        {
          "id": "e5ae3280386f7742a41359364-5ac242ab86f77412464f68b4",
          "source": "5ae3280386f7742a41359364",
          "target": "5ac242ab86f77412464f68b4",
          "type": "custom"
        },
        {
          "id": "e5b47799d86f7746c5d6a5fd8-5ac244c486f77413e12cf945",
          "source": "5b47799d86f7746c5d6a5fd8",
          "target": "5ac244c486f77413e12cf945",
          "type": "custom"
        },
        {
          "id": "e5ae3270f86f77445ba41d4dd-5ac244eb86f7741356335af1",
          "source": "5ae3270f86f77445ba41d4dd",
          "target": "5ac244eb86f7741356335af1",
          "type": "custom"
        },
        {
          "id": "e5ac23c6186f7741247042bad-5ac345dc86f774288030817f",
          "source": "5ac23c6186f7741247042bad",
          "target": "5ac345dc86f774288030817f",
          "type": "custom"
        },
        {
          "id": "e5ac345dc86f774288030817f-5ac3460c86f7742880308185",
          "source": "5ac345dc86f774288030817f",
          "target": "5ac3460c86f7742880308185",
          "type": "custom"
        },
        {
          "id": "e5ac3460c86f7742880308185-5ac3462b86f7741d6118b983",
          "source": "5ac3460c86f7742880308185",
          "target": "5ac3462b86f7741d6118b983",
          "type": "custom"
        },
        {
          "id": "e5ac3462b86f7741d6118b983-5ac3464c86f7741d651d6877",
          "source": "5ac3462b86f7741d6118b983",
          "target": "5ac3464c86f7741d651d6877",
          "type": "custom"
        },
        {
          "id": "e5ac2426c86f774138762edfe-5ac3467986f7741d6224abc2",
          "source": "5ac2426c86f774138762edfe",
          "target": "5ac3467986f7741d6224abc2",
          "type": "custom"
        },
        {
          "id": "e5ac3467986f7741d6224abc2-5ac346a886f7744e1b083d67",
          "source": "5ac3467986f7741d6224abc2",
          "target": "5ac346a886f7744e1b083d67",
          "type": "custom"
        },
        {
          "id": "e5ac346a886f7744e1b083d67-5ac346cf86f7741d63233a02",
          "source": "5ac346a886f7744e1b083d67",
          "target": "5ac346cf86f7741d63233a02",
          "type": "custom"
        },
        {
          "id": "e5ac346cf86f7741d63233a02-5ac346e886f7741d6118b99b",
          "source": "5ac346cf86f7741d63233a02",
          "target": "5ac346e886f7741d6118b99b",
          "type": "custom"
        },
        {
          "id": "e5ac3460c86f7742880308185-5ac3475486f7741d6224abd3",
          "source": "5ac3460c86f7742880308185",
          "target": "5ac3475486f7741d6224abd3",
          "type": "custom"
        },
        {
          "id": "e5ac346a886f7744e1b083d67-5ac3477486f7741d651d6885",
          "source": "5ac346a886f7744e1b083d67",
          "target": "5ac3477486f7741d651d6885",
          "type": "custom"
        },
        {
          "id": "e5ac2428686f77412450b42bf-5ac3479086f7742880308199",
          "source": "5ac2428686f77412450b42bf",
          "target": "5ac3479086f7742880308199",
          "type": "custom"
        },
        {
          "id": "e5ac3467986f7741d6224abc2-5ac3479086f7742880308199",
          "source": "5ac3467986f7741d6224abc2",
          "target": "5ac3479086f7742880308199",
          "type": "custom"
        },
        {
          "id": "e639872f9decada40426d3447-5ae3267986f7742a413592fe",
          "source": "639872f9decada40426d3447",
          "target": "5ae3267986f7742a413592fe",
          "type": "custom"
        },
        {
          "id": "e5ae3267986f7742a413592fe-5ae3270f86f77445ba41d4dd",
          "source": "5ae3267986f7742a413592fe",
          "target": "5ae3270f86f77445ba41d4dd",
          "type": "custom"
        },
        {
          "id": "e5ac244eb86f7741356335af1-5ae3277186f7745973054106",
          "source": "5ac244eb86f7741356335af1",
          "target": "5ae3277186f7745973054106",
          "type": "custom"
        },
        {
          "id": "e639872fa9b4fb827b200d8e5-5ae327c886f7745c7b3f2f3f",
          "source": "639872fa9b4fb827b200d8e5",
          "target": "5ae327c886f7745c7b3f2f3f",
          "type": "custom"
        },
        {
          "id": "e639872fe8871e1272b10ccf6-5ae3280386f7742a41359364",
          "source": "639872fe8871e1272b10ccf6",
          "target": "5ae3280386f7742a41359364",
          "type": "custom"
        },
        {
          "id": "e5ae448a386f7744d3730fff0-5ae448bf86f7744d733e55ee",
          "source": "5ae448a386f7744d3730fff0",
          "target": "5ae448bf86f7744d733e55ee",
          "type": "custom"
        },
        {
          "id": "e5ae448a386f7744d3730fff0-5ae448e586f7744dcf0c2a67",
          "source": "5ae448a386f7744d3730fff0",
          "target": "5ae448e586f7744dcf0c2a67",
          "type": "custom"
        },
        {
          "id": "e5ae448e586f7744dcf0c2a67-5ae448f286f77448d73c0131",
          "source": "5ae448e586f7744dcf0c2a67",
          "target": "5ae448f286f77448d73c0131",
          "type": "custom"
        },
        {
          "id": "e5ae448bf86f7744d733e55ee-5ae448f286f77448d73c0131",
          "source": "5ae448bf86f7744d733e55ee",
          "target": "5ae448f286f77448d73c0131",
          "type": "custom"
        },
        {
          "id": "e5ae448f286f77448d73c0131-5ae4490786f7744ca822adcc",
          "source": "5ae448f286f77448d73c0131",
          "target": "5ae4490786f7744ca822adcc",
          "type": "custom"
        },
        {
          "id": "e5ae448e586f7744dcf0c2a67-5ae4493486f7744efa289417",
          "source": "5ae448e586f7744dcf0c2a67",
          "target": "5ae4493486f7744efa289417",
          "type": "custom"
        },
        {
          "id": "e5ae448bf86f7744d733e55ee-5ae4493486f7744efa289417",
          "source": "5ae448bf86f7744d733e55ee",
          "target": "5ae4493486f7744efa289417",
          "type": "custom"
        },
        {
          "id": "e5ae4493486f7744efa289417-5ae4493d86f7744b8e15aa8f",
          "source": "5ae4493486f7744efa289417",
          "target": "5ae4493d86f7744b8e15aa8f",
          "type": "custom"
        },
        {
          "id": "e5ae4493d86f7744b8e15aa8f-5ae4495086f77443c122bc40",
          "source": "5ae4493d86f7744b8e15aa8f",
          "target": "5ae4495086f77443c122bc40",
          "type": "custom"
        },
        {
          "id": "e5ae4495086f77443c122bc40-5ae4495c86f7744e87761355",
          "source": "5ae4495086f77443c122bc40",
          "target": "5ae4495c86f7744e87761355",
          "type": "custom"
        },
        {
          "id": "e5ae4495c86f7744e87761355-5ae4496986f774459e77beb6",
          "source": "5ae4495c86f7744e87761355",
          "target": "5ae4496986f774459e77beb6",
          "type": "custom"
        },
        {
          "id": "e5ae4496986f774459e77beb6-5ae4497b86f7744cf402ed00",
          "source": "5ae4496986f774459e77beb6",
          "target": "5ae4497b86f7744cf402ed00",
          "type": "custom"
        },
        {
          "id": "e5ae4495c86f7744e87761355-5ae4498786f7744bde357695",
          "source": "5ae4495c86f7744e87761355",
          "target": "5ae4498786f7744bde357695",
          "type": "custom"
        },
        {
          "id": "e5ae448f286f77448d73c0131-5ae4499a86f77449783815db",
          "source": "5ae448f286f77448d73c0131",
          "target": "5ae4499a86f77449783815db",
          "type": "custom"
        },
        {
          "id": "e5ae4497b86f7744cf402ed00-5ae4499a86f77449783815db",
          "source": "5ae4497b86f7744cf402ed00",
          "target": "5ae4499a86f77449783815db",
          "type": "custom"
        },
        {
          "id": "e5ae4498786f7744bde357695-5ae449a586f7744bde357696",
          "source": "5ae4498786f7744bde357695",
          "target": "5ae449a586f7744bde357696",
          "type": "custom"
        },
        {
          "id": "e5ae4490786f7744ca822adcc-5ae449b386f77446d8741719",
          "source": "5ae4490786f7744ca822adcc",
          "target": "5ae449b386f77446d8741719",
          "type": "custom"
        },
        {
          "id": "e5ae4493d86f7744b8e15aa8f-5ae449b386f77446d8741719",
          "source": "5ae4493d86f7744b8e15aa8f",
          "target": "5ae449b386f77446d8741719",
          "type": "custom"
        },
        {
          "id": "e5ae449b386f77446d8741719-5ae449c386f7744bde357697",
          "source": "5ae449b386f77446d8741719",
          "target": "5ae449c386f7744bde357697",
          "type": "custom"
        },
        {
          "id": "e5ae4498786f7744bde357695-5ae449d986f774453a54a7e1",
          "source": "5ae4498786f7744bde357695",
          "target": "5ae449d986f774453a54a7e1",
          "type": "custom"
        },
        {
          "id": "e5ae449c386f7744bde357697-5ae449d986f774453a54a7e1",
          "source": "5ae449c386f7744bde357697",
          "target": "5ae449d986f774453a54a7e1",
          "type": "custom"
        },
        {
          "id": "e5ac242ab86f77412464f68b4-5b47749f86f7746c5d6a5fd4",
          "source": "5ac242ab86f77412464f68b4",
          "target": "5b47749f86f7746c5d6a5fd4",
          "type": "custom"
        },
        {
          "id": "e639872fc93ae507d5858c3a6-5b47799d86f7746c5d6a5fd8",
          "source": "639872fc93ae507d5858c3a6",
          "target": "5b47799d86f7746c5d6a5fd8",
          "type": "custom"
        },
        {
          "id": "e5b47749f86f7746c5d6a5fd4-5b477b6f86f7747290681823",
          "source": "5b47749f86f7746c5d6a5fd4",
          "target": "5b477b6f86f7747290681823",
          "type": "custom"
        },
        {
          "id": "e639873003693c63d86328f25-5b477f7686f7744d1b23c4d2",
          "source": "639873003693c63d86328f25",
          "target": "5b477f7686f7744d1b23c4d2",
          "type": "custom"
        },
        {
          "id": "e63987301e11ec11ff5504036-5b47825886f77468074618d3",
          "source": "63987301e11ec11ff5504036",
          "target": "5b47825886f77468074618d3",
          "type": "custom"
        },
        {
          "id": "e5ae448f286f77448d73c0131-5b47876e86f7744d1c353205",
          "source": "5ae448f286f77448d73c0131",
          "target": "5b47876e86f7744d1c353205",
          "type": "custom"
        },
        {
          "id": "e5ae4495086f77443c122bc40-5b47876e86f7744d1c353205",
          "source": "5ae4495086f77443c122bc40",
          "target": "5b47876e86f7744d1c353205",
          "type": "custom"
        },
        {
          "id": "e5ae448f286f77448d73c0131-5b47891f86f7744d1b23c571",
          "source": "5ae448f286f77448d73c0131",
          "target": "5b47891f86f7744d1b23c571",
          "type": "custom"
        },
        {
          "id": "e5ae4496986f774459e77beb6-5b47891f86f7744d1b23c571",
          "source": "5ae4496986f774459e77beb6",
          "target": "5b47891f86f7744d1b23c571",
          "type": "custom"
        },
        {
          "id": "e5ae449b386f77446d8741719-5b478b1886f7744d1b23c57d",
          "source": "5ae449b386f77446d8741719",
          "target": "5b478b1886f7744d1b23c57d",
          "type": "custom"
        },
        {
          "id": "e5ae4493d86f7744b8e15aa8f-5b478d0f86f7744d190d91b5",
          "source": "5ae4493d86f7744b8e15aa8f",
          "target": "5b478d0f86f7744d190d91b5",
          "type": "custom"
        },
        {
          "id": "e597a0e5786f77426d66c0636-5b478eca86f7744642012254",
          "source": "597a0e5786f77426d66c0636",
          "target": "5b478eca86f7744642012254",
          "type": "custom"
        },
        {
          "id": "e5b478eca86f7744642012254-5b478ff486f7744d184ecbbf",
          "source": "5b478eca86f7744642012254",
          "target": "5b478ff486f7744d184ecbbf",
          "type": "custom"
        },
        {
          "id": "e5a27d2af86f7744e1115b323-5b47926a86f7747ccc057c15",
          "source": "5a27d2af86f7744e1115b323",
          "target": "5b47926a86f7747ccc057c15",
          "type": "custom"
        },
        {
          "id": "e5a27d2af86f7744e1115b323-5b4794cb86f774598100d5d4",
          "source": "5a27d2af86f7744e1115b323",
          "target": "5b4794cb86f774598100d5d4",
          "type": "custom"
        },
        {
          "id": "e5b47926a86f7747ccc057c15-5b4795fb86f7745876267770",
          "source": "5b47926a86f7747ccc057c15",
          "target": "5b4795fb86f7745876267770",
          "type": "custom"
        },
        {
          "id": "e5d24b81486f77439c92d6ba8-5bc4776586f774512d07cf05",
          "source": "5d24b81486f77439c92d6ba8",
          "target": "5bc4776586f774512d07cf05",
          "type": "custom"
        },
        {
          "id": "e5bc4776586f774512d07cf05-5bc479e586f7747f376c7da3",
          "source": "5bc4776586f774512d07cf05",
          "target": "5bc479e586f7747f376c7da3",
          "type": "custom"
        },
        {
          "id": "e5bc479e586f7747f376c7da3-5bc47dbf86f7741ee74e93b9",
          "source": "5bc479e586f7747f376c7da3",
          "target": "5bc47dbf86f7741ee74e93b9",
          "type": "custom"
        },
        {
          "id": "e5bc47dbf86f7741ee74e93b9-5bc480a686f7741af0342e29",
          "source": "5bc47dbf86f7741ee74e93b9",
          "target": "5bc480a686f7741af0342e29",
          "type": "custom"
        },
        {
          "id": "e5bc480a686f7741af0342e29-5bc4826c86f774106d22d88b",
          "source": "5bc480a686f7741af0342e29",
          "target": "5bc4826c86f774106d22d88b",
          "type": "custom"
        },
        {
          "id": "e5bc4826c86f774106d22d88b-5bc4836986f7740c0152911c",
          "source": "5bc4826c86f774106d22d88b",
          "target": "5bc4836986f7740c0152911c",
          "type": "custom"
        },
        {
          "id": "e5bc4836986f7740c0152911c-5bc4856986f77454c317bea7",
          "source": "5bc4836986f7740c0152911c",
          "target": "5bc4856986f77454c317bea7",
          "type": "custom"
        },
        {
          "id": "e5bc4856986f77454c317bea7-5bc4893c86f774626f5ebf3e",
          "source": "5bc4856986f77454c317bea7",
          "target": "5bc4893c86f774626f5ebf3e",
          "type": "custom"
        },
        {
          "id": "e5c0bc91486f7746ab41857a2-5c0bbaa886f7746941031d82",
          "source": "5c0bc91486f7746ab41857a2",
          "target": "5c0bbaa886f7746941031d82",
          "type": "custom"
        },
        {
          "id": "e5b4795fb86f7745876267770-5c0bc91486f7746ab41857a2",
          "source": "5b4795fb86f7745876267770",
          "target": "5c0bc91486f7746ab41857a2",
          "type": "custom"
        },
        {
          "id": "e61958c366726521dd96828ec-5c0bd01e86f7747cdd799e56",
          "source": "61958c366726521dd96828ec",
          "target": "5c0bd01e86f7747cdd799e56",
          "type": "custom"
        },
        {
          "id": "e5c0d190cd09282029f5390d8-5c0bd94186f7747a727f09b2",
          "source": "5c0d190cd09282029f5390d8",
          "target": "5c0bd94186f7747a727f09b2",
          "type": "custom"
        },
        {
          "id": "e5b4795fb86f7745876267770-5c0bdb5286f774166e38eed4",
          "source": "5b4795fb86f7745876267770",
          "target": "5c0bdb5286f774166e38eed4",
          "type": "custom"
        },
        {
          "id": "e5ac3462b86f7741d6118b983-5c0bde0986f77479cf22c2f8",
          "source": "5ac3462b86f7741d6118b983",
          "target": "5c0bde0986f77479cf22c2f8",
          "type": "custom"
        },
        {
          "id": "e5a27bc8586f7741b543d8ea4-5c0be13186f7746f016734aa",
          "source": "5a27bc8586f7741b543d8ea4",
          "target": "5c0be13186f7746f016734aa",
          "type": "custom"
        },
        {
          "id": "e5a68667486f7742607157d28-5c0be5fc86f774467a116593",
          "source": "5a68667486f7742607157d28",
          "target": "5c0be5fc86f774467a116593",
          "type": "custom"
        },
        {
          "id": "e5a68667486f7742607157d28-5c0d0d5086f774363760aef2",
          "source": "5a68667486f7742607157d28",
          "target": "5c0d0d5086f774363760aef2",
          "type": "custom"
        },
        {
          "id": "e5b4794cb86f774598100d5d4-5c0d0f1886f77457b8210226",
          "source": "5b4794cb86f774598100d5d4",
          "target": "5c0d0f1886f77457b8210226",
          "type": "custom"
        },
        {
          "id": "e5a68669a86f774255929b4d4-5c0d1c4cd0928202a02a6f5c",
          "source": "5a68669a86f774255929b4d4",
          "target": "5c0d1c4cd0928202a02a6f5c",
          "type": "custom"
        },
        {
          "id": "e5c0be5fc86f774467a116593-5c0d1c4cd0928202a02a6f5c",
          "source": "5c0be5fc86f774467a116593",
          "target": "5c0d1c4cd0928202a02a6f5c",
          "type": "custom"
        },
        {
          "id": "e5c0d0f1886f77457b8210226-5c0d4c12d09282029f539173",
          "source": "5c0d0f1886f77457b8210226",
          "target": "5c0d4c12d09282029f539173",
          "type": "custom"
        },
        {
          "id": "e5a27bc8586f7741b543d8ea4-5c0d4e61d09282029f53920e",
          "source": "5a27bc8586f7741b543d8ea4",
          "target": "5c0d4e61d09282029f53920e",
          "type": "custom"
        },
        {
          "id": "e5b47876e86f7744d1c353205-5c10f94386f774227172c572",
          "source": "5b47876e86f7744d1c353205",
          "target": "5c10f94386f774227172c572",
          "type": "custom"
        },
        {
          "id": "e5ac3464c86f7741d651d6877-5c1128e386f7746565181106",
          "source": "5ac3464c86f7741d651d6877",
          "target": "5c1128e386f7746565181106",
          "type": "custom"
        },
        {
          "id": "e5b478b1886f7744d1b23c57d-5c112d7e86f7740d6f647486",
          "source": "5b478b1886f7744d1b23c57d",
          "target": "5c112d7e86f7740d6f647486",
          "type": "custom"
        },
        {
          "id": "e5b47891f86f7744d1b23c571-5c1141f386f77430ff393792",
          "source": "5b47891f86f7744d1b23c571",
          "target": "5c1141f386f77430ff393792",
          "type": "custom"
        },
        {
          "id": "e5c10f94386f774227172c572-5c1141f386f77430ff393792",
          "source": "5c10f94386f774227172c572",
          "target": "5c1141f386f77430ff393792",
          "type": "custom"
        },
        {
          "id": "e5c0bbaa886f7746941031d82-5c1234c286f77406fa13baeb",
          "source": "5c0bbaa886f7746941031d82",
          "target": "5c1234c286f77406fa13baeb",
          "type": "custom"
        },
        {
          "id": "e5967725e86f774601a446662-5c12452c86f7744b83469073",
          "source": "5967725e86f774601a446662",
          "target": "5c12452c86f7744b83469073",
          "type": "custom"
        },
        {
          "id": "e5ac3464c86f7741d651d6877-5c139eb686f7747878361a6f",
          "source": "5ac3464c86f7741d651d6877",
          "target": "5c139eb686f7747878361a6f",
          "type": "custom"
        },
        {
          "id": "e5bc4893c86f774626f5ebf3e-5c51aac186f77432ea65c552",
          "source": "5bc4893c86f774626f5ebf3e",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5eaaaa7c93afa0558f3b5a1c-5c51aac186f77432ea65c552",
          "source": "5eaaaa7c93afa0558f3b5a1c",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5d25e43786f7740a212217fa-5c51aac186f77432ea65c552",
          "source": "5d25e43786f7740a212217fa",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5d25e2d886f77442734d335e-5c51aac186f77432ea65c552",
          "source": "5d25e2d886f77442734d335e",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5d25e44386f77409453bce7b-5c51aac186f77432ea65c552",
          "source": "5d25e44386f77409453bce7b",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5fd9fad9c1ce6b1a3b486d00-5c51aac186f77432ea65c552",
          "source": "5fd9fad9c1ce6b1a3b486d00",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e596b455186f77457cb50eccb-5c51aac186f77432ea65c552",
          "source": "596b455186f77457cb50eccb",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e596a218586f77420d232807c-5c51aac186f77432ea65c552",
          "source": "596a218586f77420d232807c",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5ac3475486f7741d6224abd3-5c51aac186f77432ea65c552",
          "source": "5ac3475486f7741d6224abd3",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5ac3479086f7742880308199-5c51aac186f77432ea65c552",
          "source": "5ac3479086f7742880308199",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5a27ba1c86f77461ea5a3c56-5c51aac186f77432ea65c552",
          "source": "5a27ba1c86f77461ea5a3c56",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e60896b7bfa70fc097863b8f5-5c51aac186f77432ea65c552",
          "source": "60896b7bfa70fc097863b8f5",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e60c0c018f7afb4354815096a-5c51aac186f77432ea65c552",
          "source": "60c0c018f7afb4354815096a",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e626bd75e47ea7f506e5493c5-5c51aac186f77432ea65c552",
          "source": "626bd75e47ea7f506e5493c5",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c0bde0986f77479cf22c2f8-5c51aac186f77432ea65c552",
          "source": "5c0bde0986f77479cf22c2f8",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e60896888e4a85c72ef3fa300-5c51aac186f77432ea65c552",
          "source": "60896888e4a85c72ef3fa300",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e6089732b59b92115597ad789-5c51aac186f77432ea65c552",
          "source": "6089732b59b92115597ad789",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e6179b4d1bca27a099552e04e-5c51aac186f77432ea65c552",
          "source": "6179b4d1bca27a099552e04e",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5ac346e886f7741d6118b99b-5c51aac186f77432ea65c552",
          "source": "5ac346e886f7741d6118b99b",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e6179aff8f57fb279792c60a1-5c51aac186f77432ea65c552",
          "source": "6179aff8f57fb279792c60a1",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e6089743983426423753cd58a-5c51aac186f77432ea65c552",
          "source": "6089743983426423753cd58a",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e608974af4b05530f55550c21-5c51aac186f77432ea65c552",
          "source": "608974af4b05530f55550c21",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e6179b3bdc7560e13d23eeb8d-5c51aac186f77432ea65c552",
          "source": "6179b3bdc7560e13d23eeb8d",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e6179ad56c760af5ad2053587-5c51aac186f77432ea65c552",
          "source": "6179ad56c760af5ad2053587",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e626bd75b05f287031503c7f6-5c51aac186f77432ea65c552",
          "source": "626bd75b05f287031503c7f6",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e6179acbdc760af5ad2053585-5c51aac186f77432ea65c552",
          "source": "6179acbdc760af5ad2053585",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e626bd75c71bd851e971b82a5-5c51aac186f77432ea65c552",
          "source": "626bd75c71bd851e971b82a5",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e61904daa7d0d857927447b9c-5c51aac186f77432ea65c552",
          "source": "61904daa7d0d857927447b9c",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5b478ff486f7744d184ecbbf-5c51aac186f77432ea65c552",
          "source": "5b478ff486f7744d184ecbbf",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e6179ad0a6e9dd54ac275e3f2-5c51aac186f77432ea65c552",
          "source": "6179ad0a6e9dd54ac275e3f2",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5edac63b930f5454f51e128b-5c51aac186f77432ea65c552",
          "source": "5edac63b930f5454f51e128b",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5b478d0f86f7744d190d91b5-5c51aac186f77432ea65c552",
          "source": "5b478d0f86f7744d190d91b5",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5d25e46e86f77409453bce7c-5c51aac186f77432ea65c552",
          "source": "5d25e46e86f77409453bce7c",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c0bd01e86f7747cdd799e56-5c51aac186f77432ea65c552",
          "source": "5c0bd01e86f7747cdd799e56",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e6179b3a12153c15e937d52bc-5c51aac186f77432ea65c552",
          "source": "6179b3a12153c15e937d52bc",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5ae4499a86f77449783815db-5c51aac186f77432ea65c552",
          "source": "5ae4499a86f77449783815db",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5d4bec3486f7743cac246665-5c51aac186f77432ea65c552",
          "source": "5d4bec3486f7743cac246665",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5ae449a586f7744bde357696-5c51aac186f77432ea65c552",
          "source": "5ae449a586f7744bde357696",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5d25e4b786f77408251c4bfc-5c51aac186f77432ea65c552",
          "source": "5d25e4b786f77408251c4bfc",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c112d7e86f7740d6f647486-5c51aac186f77432ea65c552",
          "source": "5c112d7e86f7740d6f647486",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c1234c286f77406fa13baeb-5c51aac186f77432ea65c552",
          "source": "5c1234c286f77406fa13baeb",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c1141f386f77430ff393792-5c51aac186f77432ea65c552",
          "source": "5c1141f386f77430ff393792",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c1128e386f7746565181106-5c51aac186f77432ea65c552",
          "source": "5c1128e386f7746565181106",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c0bd94186f7747a727f09b2-5c51aac186f77432ea65c552",
          "source": "5c0bd94186f7747a727f09b2",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5d25e45e86f77408251c4bfa-5c51aac186f77432ea65c552",
          "source": "5d25e45e86f77408251c4bfa",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e6179b4f16e9dd54ac275e407-5c51aac186f77432ea65c552",
          "source": "6179b4f16e9dd54ac275e407",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c0d4c12d09282029f539173-5c51aac186f77432ea65c552",
          "source": "5c0d4c12d09282029f539173",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5d25e4ca86f77409dd5cdf2c-5c51aac186f77432ea65c552",
          "source": "5d25e4ca86f77409dd5cdf2c",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c0d1c4cd0928202a02a6f5c-5c51aac186f77432ea65c552",
          "source": "5c0d1c4cd0928202a02a6f5c",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c0bdb5286f774166e38eed4-5c51aac186f77432ea65c552",
          "source": "5c0bdb5286f774166e38eed4",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c0be13186f7746f016734aa-5c51aac186f77432ea65c552",
          "source": "5c0be13186f7746f016734aa",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c12452c86f7744b83469073-5c51aac186f77432ea65c552",
          "source": "5c12452c86f7744b83469073",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c139eb686f7747878361a6f-5c51aac186f77432ea65c552",
          "source": "5c139eb686f7747878361a6f",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e626bdcc3a371ee3a7a3514c5-5c51aac186f77432ea65c552",
          "source": "626bdcc3a371ee3a7a3514c5",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5b47825886f77468074618d3-5c51aac186f77432ea65c552",
          "source": "5b47825886f77468074618d3",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5ae449d986f774453a54a7e1-5c51aac186f77432ea65c552",
          "source": "5ae449d986f774453a54a7e1",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5c0d4e61d09282029f53920e-5c51aac186f77432ea65c552",
          "source": "5c0d4e61d09282029f53920e",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e60e71bb4e456d449cd47ca75-5c51aac186f77432ea65c552",
          "source": "60e71bb4e456d449cd47ca75",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e60e71c48c1bfa3050473b8e5-5c51aac186f77432ea65c552",
          "source": "60e71c48c1bfa3050473b8e5",
          "target": "5c51aac186f77432ea65c552",
          "type": "custom"
        },
        {
          "id": "e5ac23c6186f7741247042bad-5d2495a886f77425cd51e403",
          "source": "5ac23c6186f7741247042bad",
          "target": "5d2495a886f77425cd51e403",
          "type": "custom"
        },
        {
          "id": "e5d2495a886f77425cd51e403-5d24b81486f77439c92d6ba8",
          "source": "5d2495a886f77425cd51e403",
          "target": "5d24b81486f77439c92d6ba8",
          "type": "custom"
        },
        {
          "id": "e5d24b81486f77439c92d6ba8-5d25aed386f77442734d25d2",
          "source": "5d24b81486f77439c92d6ba8",
          "target": "5d25aed386f77442734d25d2",
          "type": "custom"
        },
        {
          "id": "e5d25aed386f77442734d25d2-5d25b6be86f77444001e1b89",
          "source": "5d25aed386f77442734d25d2",
          "target": "5d25b6be86f77444001e1b89",
          "type": "custom"
        },
        {
          "id": "e5d25b6be86f77444001e1b89-5d25bfd086f77442734d3007",
          "source": "5d25b6be86f77444001e1b89",
          "target": "5d25bfd086f77442734d3007",
          "type": "custom"
        },
        {
          "id": "e5d25bfd086f77442734d3007-5d25c81b86f77443e625dd71",
          "source": "5d25bfd086f77442734d3007",
          "target": "5d25c81b86f77443e625dd71",
          "type": "custom"
        },
        {
          "id": "e5d25c81b86f77443e625dd71-5d25cf2686f77443e75488d4",
          "source": "5d25c81b86f77443e625dd71",
          "target": "5d25cf2686f77443e75488d4",
          "type": "custom"
        },
        {
          "id": "e5d25cf2686f77443e75488d4-5d25e29d86f7740a22516326",
          "source": "5d25cf2686f77443e75488d4",
          "target": "5d25e29d86f7740a22516326",
          "type": "custom"
        },
        {
          "id": "e5d25e29d86f7740a22516326-5d25e2a986f77409dd5cdf2a",
          "source": "5d25e29d86f7740a22516326",
          "target": "5d25e2a986f77409dd5cdf2a",
          "type": "custom"
        },
        {
          "id": "e5bc47dbf86f7741ee74e93b9-5d25e2b486f77409de05bba0",
          "source": "5bc47dbf86f7741ee74e93b9",
          "target": "5d25e2b486f77409de05bba0",
          "type": "custom"
        },
        {
          "id": "e5d25cf2686f77443e75488d4-5d25e2b486f77409de05bba0",
          "source": "5d25cf2686f77443e75488d4",
          "target": "5d25e2b486f77409de05bba0",
          "type": "custom"
        },
        {
          "id": "e5d25e2b486f77409de05bba0-5d25e2c386f77443e7549029",
          "source": "5d25e2b486f77409de05bba0",
          "target": "5d25e2c386f77443e7549029",
          "type": "custom"
        },
        {
          "id": "e5d25e2b486f77409de05bba0-5d25e2cc86f77443e47ae019",
          "source": "5d25e2b486f77409de05bba0",
          "target": "5d25e2cc86f77443e47ae019",
          "type": "custom"
        },
        {
          "id": "e5d25e2cc86f77443e47ae019-5d25e2d886f77442734d335e",
          "source": "5d25e2cc86f77443e47ae019",
          "target": "5d25e2d886f77442734d335e",
          "type": "custom"
        },
        {
          "id": "e5d25e2cc86f77443e47ae019-5d25e2e286f77444001e2e48",
          "source": "5d25e2cc86f77443e47ae019",
          "target": "5d25e2e286f77444001e2e48",
          "type": "custom"
        },
        {
          "id": "e5ae449c386f7744bde357697-5d25e2e286f77444001e2e48",
          "source": "5ae449c386f7744bde357697",
          "target": "5d25e2e286f77444001e2e48",
          "type": "custom"
        },
        {
          "id": "e5d25e2b486f77409de05bba0-5d25e2ee86f77443e35162ea",
          "source": "5d25e2b486f77409de05bba0",
          "target": "5d25e2ee86f77443e35162ea",
          "type": "custom"
        },
        {
          "id": "e596a0e1686f7741ddf17dbee-5d25e2ee86f77443e35162ea",
          "source": "596a0e1686f7741ddf17dbee",
          "target": "5d25e2ee86f77443e35162ea",
          "type": "custom"
        },
        {
          "id": "e5d25e2c386f77443e7549029-5d25e43786f7740a212217fa",
          "source": "5d25e2c386f77443e7549029",
          "target": "5d25e43786f7740a212217fa",
          "type": "custom"
        },
        {
          "id": "e5d25e2cc86f77443e47ae019-5d25e44386f77409453bce7b",
          "source": "5d25e2cc86f77443e47ae019",
          "target": "5d25e44386f77409453bce7b",
          "type": "custom"
        },
        {
          "id": "e608a768d82e40b3c727fd17d-5d25e44f86f77443e625e385",
          "source": "608a768d82e40b3c727fd17d",
          "target": "5d25e44f86f77443e625e385",
          "type": "custom"
        },
        {
          "id": "e5d25e2b486f77409de05bba0-5d25e45e86f77408251c4bfa",
          "source": "5d25e2b486f77409de05bba0",
          "target": "5d25e45e86f77408251c4bfa",
          "type": "custom"
        },
        {
          "id": "e5d25e44f86f77443e625e385-5d25e45e86f77408251c4bfa",
          "source": "5d25e44f86f77443e625e385",
          "target": "5d25e45e86f77408251c4bfa",
          "type": "custom"
        },
        {
          "id": "e5d25e48d86f77408251c4bfb-5d25e46e86f77409453bce7c",
          "source": "5d25e48d86f77408251c4bfb",
          "target": "5d25e46e86f77409453bce7c",
          "type": "custom"
        },
        {
          "id": "e5d25cf2686f77443e75488d4-5d25e48186f77443e625e386",
          "source": "5d25cf2686f77443e75488d4",
          "target": "5d25e48186f77443e625e386",
          "type": "custom"
        },
        {
          "id": "e5d24b81486f77439c92d6ba8-5d25e48d86f77408251c4bfb",
          "source": "5d24b81486f77439c92d6ba8",
          "target": "5d25e48d86f77408251c4bfb",
          "type": "custom"
        },
        {
          "id": "e5979ed3886f77431307dc512-5d25e48d86f77408251c4bfb",
          "source": "5979ed3886f77431307dc512",
          "target": "5d25e48d86f77408251c4bfb",
          "type": "custom"
        },
        {
          "id": "e5d25e48186f77443e625e386-5d25e4ad86f77443e625e387",
          "source": "5d25e48186f77443e625e386",
          "target": "5d25e4ad86f77443e625e387",
          "type": "custom"
        },
        {
          "id": "e5d25e4ad86f77443e625e387-5d25e4b786f77408251c4bfc",
          "source": "5d25e4ad86f77443e625e387",
          "target": "5d25e4b786f77408251c4bfc",
          "type": "custom"
        },
        {
          "id": "e5d25e2ee86f77443e35162ea-5d25e4ca86f77409dd5cdf2c",
          "source": "5d25e2ee86f77443e35162ea",
          "target": "5d25e4ca86f77409dd5cdf2c",
          "type": "custom"
        },
        {
          "id": "e63a88045abf76d719f42d715-5d25e4d586f77443e625e388",
          "source": "63a88045abf76d719f42d715",
          "target": "5d25e4d586f77443e625e388",
          "type": "custom"
        },
        {
          "id": "e5979f8bb86f7743ec214c7a6-5d4bec3486f7743cac246665",
          "source": "5979f8bb86f7743ec214c7a6",
          "target": "5d4bec3486f7743cac246665",
          "type": "custom"
        },
        {
          "id": "e5d25e2a986f77409dd5cdf2a-5eaaaa7c93afa0558f3b5a1c",
          "source": "5d25e2a986f77409dd5cdf2a",
          "target": "5eaaaa7c93afa0558f3b5a1c",
          "type": "custom"
        },
        {
          "id": "e5967725e86f774601a446662-5eda19f0edce541157209cee",
          "source": "5967725e86f774601a446662",
          "target": "5eda19f0edce541157209cee",
          "type": "custom"
        },
        {
          "id": "e5edabd13218d181e29451442-5edab4b1218d181e29451435",
          "source": "5edabd13218d181e29451442",
          "target": "5edab4b1218d181e29451435",
          "type": "custom"
        },
        {
          "id": "e5edaba7c0c502106f869bc02-5edab4b1218d181e29451435",
          "source": "5edaba7c0c502106f869bc02",
          "target": "5edab4b1218d181e29451435",
          "type": "custom"
        },
        {
          "id": "e5f04886a3937dc337a6b8238-5edab4b1218d181e29451435",
          "source": "5f04886a3937dc337a6b8238",
          "target": "5edab4b1218d181e29451435",
          "type": "custom"
        },
        {
          "id": "e596a1e6c86f7741ddc2d3206-5edab736cc183c769d778bc2",
          "source": "596a1e6c86f7741ddc2d3206",
          "target": "5edab736cc183c769d778bc2",
          "type": "custom"
        },
        {
          "id": "e5edab736cc183c769d778bc2-5edaba7c0c502106f869bc02",
          "source": "5edab736cc183c769d778bc2",
          "target": "5edaba7c0c502106f869bc02",
          "type": "custom"
        },
        {
          "id": "e5eda19f0edce541157209cee-5edabd13218d181e29451442",
          "source": "5eda19f0edce541157209cee",
          "target": "5edabd13218d181e29451442",
          "type": "custom"
        },
        {
          "id": "e5a27d2af86f7744e1115b323-5edac020218d181e29451446",
          "source": "5a27d2af86f7744e1115b323",
          "target": "5edac020218d181e29451446",
          "type": "custom"
        },
        {
          "id": "e5a27b75b86f7742e97191958-5edac020218d181e29451446",
          "source": "5a27b75b86f7742e97191958",
          "target": "5edac020218d181e29451446",
          "type": "custom"
        },
        {
          "id": "e5eda19f0edce541157209cee-5edac020218d181e29451446",
          "source": "5eda19f0edce541157209cee",
          "target": "5edac020218d181e29451446",
          "type": "custom"
        },
        {
          "id": "e5edab4b1218d181e29451435-5edac34d0bb72a50635c2bfa",
          "source": "5edab4b1218d181e29451435",
          "target": "5edac34d0bb72a50635c2bfa",
          "type": "custom"
        },
        {
          "id": "e5edac020218d181e29451446-5edac63b930f5454f51e128b",
          "source": "5edac020218d181e29451446",
          "target": "5edac63b930f5454f51e128b",
          "type": "custom"
        },
        {
          "id": "e5edac34d0bb72a50635c2bfa-5edac63b930f5454f51e128b",
          "source": "5edac34d0bb72a50635c2bfa",
          "target": "5edac63b930f5454f51e128b",
          "type": "custom"
        },
        {
          "id": "e59c124d686f774189b3c843f-5ede55112c95834b583f052a",
          "source": "59c124d686f774189b3c843f",
          "target": "5ede55112c95834b583f052a",
          "type": "custom"
        },
        {
          "id": "e5ede55112c95834b583f052a-5ede567cfa6dc072ce15d6e3",
          "source": "5ede55112c95834b583f052a",
          "target": "5ede567cfa6dc072ce15d6e3",
          "type": "custom"
        },
        {
          "id": "e5eda19f0edce541157209cee-5f04886a3937dc337a6b8238",
          "source": "5eda19f0edce541157209cee",
          "target": "5f04886a3937dc337a6b8238",
          "type": "custom"
        },
        {
          "id": "e5edab736cc183c769d778bc2-5f04886a3937dc337a6b8238",
          "source": "5edab736cc183c769d778bc2",
          "target": "5f04886a3937dc337a6b8238",
          "type": "custom"
        },
        {
          "id": "e5936d90786f7742b1420ba5b-5fd9fad9c1ce6b1a3b486d00",
          "source": "5936d90786f7742b1420ba5b",
          "target": "5fd9fad9c1ce6b1a3b486d00",
          "type": "custom"
        },
        {
          "id": "e5a27d2af86f7744e1115b323-6086c852c945025d41566124",
          "source": "5a27d2af86f7744e1115b323",
          "target": "6086c852c945025d41566124",
          "type": "custom"
        },
        {
          "id": "e5a27b87686f77460de0252a8-6086c852c945025d41566124",
          "source": "5a27b87686f77460de0252a8",
          "target": "6086c852c945025d41566124",
          "type": "custom"
        },
        {
          "id": "e6086c852c945025d41566124-60896888e4a85c72ef3fa300",
          "source": "6086c852c945025d41566124",
          "target": "60896888e4a85c72ef3fa300",
          "type": "custom"
        },
        {
          "id": "e60896bca6ee58f38c417d4f2-60896b7bfa70fc097863b8f5",
          "source": "60896bca6ee58f38c417d4f2",
          "target": "60896b7bfa70fc097863b8f5",
          "type": "custom"
        },
        {
          "id": "e5ede567cfa6dc072ce15d6e3-60896bca6ee58f38c417d4f2",
          "source": "5ede567cfa6dc072ce15d6e3",
          "target": "60896bca6ee58f38c417d4f2",
          "type": "custom"
        },
        {
          "id": "e5969f9e986f7741dde183a50-60896e28e4a85c72ef3fa301",
          "source": "5969f9e986f7741dde183a50",
          "target": "60896e28e4a85c72ef3fa301",
          "type": "custom"
        },
        {
          "id": "e6089736efa70fc097863b8f6-6089732b59b92115597ad789",
          "source": "6089736efa70fc097863b8f6",
          "target": "6089732b59b92115597ad789",
          "type": "custom"
        },
        {
          "id": "e5ac3477486f7741d651d6885-6089736efa70fc097863b8f6",
          "source": "5ac3477486f7741d651d6885",
          "target": "6089736efa70fc097863b8f6",
          "type": "custom"
        },
        {
          "id": "e597a0f5686f774273b74f676-6089743983426423753cd58a",
          "source": "597a0f5686f774273b74f676",
          "target": "6089743983426423753cd58a",
          "type": "custom"
        },
        {
          "id": "e608974d01a66564e74191fc0-608974af4b05530f55550c21",
          "source": "608974d01a66564e74191fc0",
          "target": "608974af4b05530f55550c21",
          "type": "custom"
        },
        {
          "id": "e5ae448f286f77448d73c0131-608974d01a66564e74191fc0",
          "source": "5ae448f286f77448d73c0131",
          "target": "608974d01a66564e74191fc0",
          "type": "custom"
        },
        {
          "id": "e5d25e4d586f77443e625e388-608a768d82e40b3c727fd17d",
          "source": "5d25e4d586f77443e625e388",
          "target": "608a768d82e40b3c727fd17d",
          "type": "custom"
        },
        {
          "id": "e5d25e2cc86f77443e47ae019-60c0c018f7afb4354815096a",
          "source": "5d25e2cc86f77443e47ae019",
          "target": "60c0c018f7afb4354815096a",
          "type": "custom"
        },
        {
          "id": "e5ac3477486f7741d651d6885-60c0c018f7afb4354815096a",
          "source": "5ac3477486f7741d651d6885",
          "target": "60c0c018f7afb4354815096a",
          "type": "custom"
        },
        {
          "id": "e59ca2eb686f77445a80ed049-60e71bb4e456d449cd47ca75",
          "source": "59ca2eb686f77445a80ed049",
          "target": "60e71bb4e456d449cd47ca75",
          "type": "custom"
        },
        {
          "id": "e5c0d0d5086f774363760aef2-60e71c48c1bfa3050473b8e5",
          "source": "5c0d0d5086f774363760aef2",
          "target": "60e71c48c1bfa3050473b8e5",
          "type": "custom"
        },
        {
          "id": "e59c50c8886f7745fed3193bf-6179ac7511973d018217d0b9",
          "source": "59c50c8886f7745fed3193bf",
          "target": "6179ac7511973d018217d0b9",
          "type": "custom"
        },
        {
          "id": "e6179ac7511973d018217d0b9-6179acbdc760af5ad2053585",
          "source": "6179ac7511973d018217d0b9",
          "target": "6179acbdc760af5ad2053585",
          "type": "custom"
        },
        {
          "id": "e5d25e2cc86f77443e47ae019-6179ad0a6e9dd54ac275e3f2",
          "source": "5d25e2cc86f77443e47ae019",
          "target": "6179ad0a6e9dd54ac275e3f2",
          "type": "custom"
        },
        {
          "id": "e60896e28e4a85c72ef3fa301-6179ad56c760af5ad2053587",
          "source": "60896e28e4a85c72ef3fa301",
          "target": "6179ad56c760af5ad2053587",
          "type": "custom"
        },
        {
          "id": "e5a68663e86f774501078f78a-6179afd0bca27a099552e040",
          "source": "5a68663e86f774501078f78a",
          "target": "6179afd0bca27a099552e040",
          "type": "custom"
        },
        {
          "id": "e5a03153686f77442d90e2171-6179aff8f57fb279792c60a1",
          "source": "5a03153686f77442d90e2171",
          "target": "6179aff8f57fb279792c60a1",
          "type": "custom"
        },
        {
          "id": "e5ac3464c86f7741d651d6877-6179b3a12153c15e937d52bc",
          "source": "5ac3464c86f7741d651d6877",
          "target": "6179b3a12153c15e937d52bc",
          "type": "custom"
        },
        {
          "id": "e5ac3462b86f7741d6118b983-6179b3bdc7560e13d23eeb8d",
          "source": "5ac3462b86f7741d6118b983",
          "target": "6179b3bdc7560e13d23eeb8d",
          "type": "custom"
        },
        {
          "id": "e6086c852c945025d41566124-6179b4d1bca27a099552e04e",
          "source": "6086c852c945025d41566124",
          "target": "6179b4d1bca27a099552e04e",
          "type": "custom"
        },
        {
          "id": "e6193850f60b34236ee0483de-6179b4f16e9dd54ac275e407",
          "source": "6193850f60b34236ee0483de",
          "target": "6179b4f16e9dd54ac275e407",
          "type": "custom"
        },
        {
          "id": "e5d25e48186f77443e625e386-61904daa7d0d857927447b9c",
          "source": "5d25e48186f77443e625e386",
          "target": "61904daa7d0d857927447b9c",
          "type": "custom"
        },
        {
          "id": "e5a27d2af86f7744e1115b323-6193850f60b34236ee0483de",
          "source": "5a27d2af86f7744e1115b323",
          "target": "6193850f60b34236ee0483de",
          "type": "custom"
        },
        {
          "id": "e5a27bb5986f7741dfb660900-61958c366726521dd96828ec",
          "source": "5a27bb5986f7741dfb660900",
          "target": "61958c366726521dd96828ec",
          "type": "custom"
        },
        {
          "id": "e6179afd0bca27a099552e040-626bd75b05f287031503c7f6",
          "source": "6179afd0bca27a099552e040",
          "target": "626bd75b05f287031503c7f6",
          "type": "custom"
        },
        {
          "id": "e6179ac7511973d018217d0b9-626bd75c71bd851e971b82a5",
          "source": "6179ac7511973d018217d0b9",
          "target": "626bd75c71bd851e971b82a5",
          "type": "custom"
        },
        {
          "id": "e5ac3460c86f7742880308185-626bd75e47ea7f506e5493c5",
          "source": "5ac3460c86f7742880308185",
          "target": "626bd75e47ea7f506e5493c5",
          "type": "custom"
        },
        {
          "id": "e5d25e2c386f77443e7549029-626bdcc3a371ee3a7a3514c5",
          "source": "5d25e2c386f77443e7549029",
          "target": "626bdcc3a371ee3a7a3514c5",
          "type": "custom"
        },
        {
          "id": "e5d25e2ee86f77443e35162ea-626bdcc3a371ee3a7a3514c5",
          "source": "5d25e2ee86f77443e35162ea",
          "target": "626bdcc3a371ee3a7a3514c5",
          "type": "custom"
        },
        {
          "id": "e5d25e2e286f77444001e2e48-626bdcc3a371ee3a7a3514c5",
          "source": "5d25e2e286f77444001e2e48",
          "target": "626bdcc3a371ee3a7a3514c5",
          "type": "custom"
        },
        {
          "id": "e5ac2426c86f774138762edfe-639872f9decada40426d3447",
          "source": "5ac2426c86f774138762edfe",
          "target": "639872f9decada40426d3447",
          "type": "custom"
        },
        {
          "id": "e5ac2428686f77412450b42bf-639872f9decada40426d3447",
          "source": "5ac2428686f77412450b42bf",
          "target": "639872f9decada40426d3447",
          "type": "custom"
        },
        {
          "id": "e5ae3277186f7745973054106-639872fa9b4fb827b200d8e5",
          "source": "5ae3277186f7745973054106",
          "target": "639872fa9b4fb827b200d8e5",
          "type": "custom"
        },
        {
          "id": "e5ae327c886f7745c7b3f2f3f-639872fc93ae507d5858c3a6",
          "source": "5ae327c886f7745c7b3f2f3f",
          "target": "639872fc93ae507d5858c3a6",
          "type": "custom"
        },
        {
          "id": "e5ac244c486f77413e12cf945-639872fe8871e1272b10ccf6",
          "source": "5ac244c486f77413e12cf945",
          "target": "639872fe8871e1272b10ccf6",
          "type": "custom"
        },
        {
          "id": "e5b477b6f86f7747290681823-639873003693c63d86328f25",
          "source": "5b477b6f86f7747290681823",
          "target": "639873003693c63d86328f25",
          "type": "custom"
        },
        {
          "id": "e5b477f7686f7744d1b23c4d2-63987301e11ec11ff5504036",
          "source": "5b477f7686f7744d1b23c4d2",
          "target": "63987301e11ec11ff5504036",
          "type": "custom"
        },
        {
          "id": "e5d25b6be86f77444001e1b89-63a88045abf76d719f42d715",
          "source": "5d25b6be86f77444001e1b89",
          "target": "63a88045abf76d719f42d715",
          "type": "custom"
        }
      ]
    }
  }
}
